import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {filterSingleDate_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template';
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {slugify} from "../../utils/Helpers";
import {filterArticle_template} from "./filterArticle_template";
import {embedder_template} from "./embedder_template";
import {EmbedInfo} from "../../utils/embeds/types";
import {countryStates_template} from "./countryStates_template";
import EmbedHelper, { embedType } from "../../utils/EmbedHelper";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import { relativeRadiusToValue } from "@amcharts/amcharts4/.internal/core/utils/Utils";
import { offboarding } from "../../modules/offboarding";

declare var ko: any;
declare var Dropzone: any;

enum MinPerformanceFilledType {
    AUTO = 'auto',
    CUSTOM = 'custom'
}
enum RateStateStatus {
    SAVED_CHANGE = 'modify',
    UNSAVED_CHANGE = 'unsaved',
    UNCHANGED = 'default',
    NOT_USED = 'unused'
}
enum PaymentMethod {
    PAYPAL = 1,
    WIRE_TRANSFER = 2,
    PAYONEER = 3,
    DIRECT_BANK_TRANSFER = 4,
    NONE = 0
}

enum CountryBankId {
    CA = 32,
    US = 197
}

interface PaymentMethodDisplay {
    isPaymentBank: boolean;
    isPaymentMethodId: boolean;
}

export class usersEdit_template extends vnTemplate {

    protected SpellcheckTooltipContent ;
    protected SpellcheckTooltip: infoButton_template
    protected socialMediaFilter : multipleSelector_template;
    protected effectiveDatePicker: filterSingleDate_template;
    public articleFilter : filterArticle_template;
    protected embedder: embedder_template;
    protected embedHelper: EmbedHelper;
    public countryGroups: countryStates_template;
    public bankCountryGroups: countryStates_template;
    protected twoFactorAuthenticationTooltipContent;
    protected twoFactorAuthenticationTooltip: infoButton_template;

    protected maxTooltipButtonContent = `
        <p>The maximum dollar amount that can be set to a transaction for the performance of a single article.</p>
    `;

    protected minTooltipButtonContent = `
        <p> Min Threshold is the dollar amount at which performance transaction calculation is activated.  The performance transaction will only be generated when an article's pageviews, multiplied by the rate, exceeds the threshold.  e.g.:</p>

            <ul>
                <li>No threshold was set => Performance Transaction created for $15.50.  </li>
                <li>Same scenario, but threshold set at $10.00 => Performance Transaction created for $5.50.</li>
            </ul>

        <p>When threshold is set to “Auto”, that dollar amount will be tied to the same amount as the Article Commission.</p>
    `;

    protected writerCommissionButtonContent = `
        <p>The amount used to generate a one-time transaction for each article published with the associated payment category.</p>
    `;

    protected writerSessionCommissionButtonContent = `
        <p>The rate set will be multipled against the {US-Session Performance/Session Performance"} divided by 1000, of the article with the associated payment category.</p
        <h3 class="tooltips-adv-title">Min/Max</h3>
        <p>If the calculated total is less than the <strong>Minimum</strong>, no transaction will be generated.</p>
        <p>If the calculated total is more than the <strong>Maximum</strong>, the transaction will use the maximum amount for payout.</p>
    `;

    protected editorSessionCommissionButtonContent = `
        <p>The rate set will be multipled against the {US-Session Performance/Session Performance"} divided by 1000, of the article with the associated payment category.</p
        <h3 class="tooltips-adv-title">Min/Max</h3>
        <p>If the calculated total is less than the <strong>Minimum</strong>, no transaction will be generated.</p>
        <p>If the calculated total is more than the <strong>Maximum</strong>, the transaction will use the maximum amount for payout.</p>
    `;

    protected writerPerformanceButtonContent = `
        <p>The rate used to calculate an amount of a transaction for each article with the associated payment category.  The calculation is based on pageviews to the article, multiplied by the rate and divided by 1000.  The transaction amount is recalculated every day, as pageviews come in, until the full time period set by that payment category has elapsed (payment category time periods are custom by brand).</p>
    `;

    protected writerArticlegroupButtonContent = `
        <p>The rate used to calculate a Performance transaction on multiple articles.</p>
        <p>The group of articles is determined by their publish date.  If Bi-Monthly setting is chosen, groups will be based on articles published between the 1st-15th or 16th to last day of every month.</p>
        <p>A separate transaction will be created for each payment category with a specified rate in this column.  The transaction amount is calculated by taking the pageviews generated by all articles in the given date range and payment category, multiplied by the rate and divided by 1000.</p>
        <p>If a rate is put for the "All" payment category, this will apply to all the articles with a payment category NOT specifically set for this user.  (e.g. if you set a rate for "feature" and a rate for "all", two transactions will be created.  One based on the pageviews of "feature" articles and a second one based on the pageviews of all articles that are not "feature").</p>
    `;

    protected editorCommissionButtonContent = `
        <p>The amount used to generate a one-time transaction for each article published with the associated payment category.</p>
    `;

    protected editorPerformanceButtonContent = `
        <p>The rate used to calculate an amount of a transaction for each article with the associated payment category.  The calculation is based on pageviews to the article, multiplied by the rate and divided by 1000.  The transaction amount is recalculated every day, as pageviews come in, until the full time period set by that payment category has elapsed (payment category time periods are custom by brand).</p>
    `;

    protected editorArticlegroupButtonContent = `
        <p>The rate used to calculate a Performance transaction on multiple articles.</p>
        <p>The group of articles is determined by their publish date.  If Bi-Monthly setting is chosen, groups will be based on articles published between the 1st-15th or 16th to last day of every month.</p>
        <p>A separate transaction will be created for each payment category with a specified rate in this column.  The transaction amount is calculated by taking the pageviews generated by all articles in the given date range and payment category, multiplied by the rate and divided by 1000.</p>
        <p>If a rate is put for the "All" payment category, this will apply to all the articles with a payment category NOT specifically set for this user.  (e.g. if you set a rate for "feature" and a rate for "all", two transactions will be created.  One based on the pageviews of "feature" articles and a second one based on the pageviews of all articles that are not "feature").</p>
    `;

    protected outputMinTargetTooltipContent = `
        <p>When a <b>MINIMUM OUTPUT TARGET</b> is set, transactions for articles/republishes will not be generated until the user has published enough to meet their target in a <i><b>MONTH</b></i>.
        <br /><br />
        <i><b>ONLY</b></i> standard articles/republishes above the <b>TARGET</b> will generate transactions.
        <br />Example: if the <b>TARGET</b> is 50, then transactions will be generated for the 51st, 52nd, 53rd, etc. articles/republishes that are published in the month.  The transaction will be based on the matching payment category commission rate set below.
        <br /><br />
        NOTE: Video and Thread articles <i><b>DO NOT COUNT</b></i> towards the target (based on the "TYPE" chosen in the article).
        </p>
    `;

    protected tier1TargetSATooltipContent = `
        <p><b>TIER 1 TARGET S/A</b> is the session per article goal for a <i><b>MONTH</b></i>, if met, will generate a Bonus for the user.  Setting a number is optional.  If this field is left blank, Emaki will use the brand's Session Targets for the month (and content type) automatically.
        <br /><br />
        Only the <b>ACTIVE SESSIONS</b> of new articles published that month will be considered toward the <b>TARGET S/A</b>.
        <br />Active Sessions: Sessions on those articles, which happened within the first 30 days after publish.
        <br /><br />
        NOTE: Republishes, Video, and Thread articles <i><b>DO NOT COUNT</b></i> towards the target (based on the "TYPE" chosen in the article).
        </p>
    `;

    protected tier1BonusPercentageTooltipContent = `
        <p><b>TIER 1 BONUS % OF CONSULTING BASE</b> is the percentage that will be used to calculate the amount of the bonus transaction by multiplying it with the sum of <i><b>Time Period-Consulting Base</b></i> in the same <i><b>Month</b></i>.
        <br /><br />
        Emaki will begin checking to create transactions <i><b>10 DAYS AFTER</b></i> the end of a month.  This is to allow for initial active sessions to be reported before determining if S/A targets are met.
        <br />If you do not want to pay out a bonus for a period (even though targets were met), you should uncheck the Monthly S/A bonus from this profile.  As long as this bonus is set in their Payment Rate profile, Emaki will continuously generate the bonus for the previous month.
        <br /><br />
        NOTE: Users with consulting base pays twice per month (1-15 and 16-EOM) will also be considered for calculating the bonus.  As long as the time period falls within the same month.
        <br />Similarly, a reversal would only apply to the time period specified in the reversal.
        <br />Example: Reversal created on December 4th, for the month of Nov 1st-30th.  This would be a subtraction from calculating the Monthly S/A payout of November only.
        </p>
    `;

    protected tier2TargetSATooltipContent = `
       <p><b>TIER 2 TARGET S/A</b> is the session per article goal for a <i><b>MONTH</b></i>, if met, will generate a Bonus for the user.  Setting a number is optional.
        <br />If this field is left blank, <b>NO TIER 2</b> bonus will be eligible for the user.
        <br /><br />
        Input the percentage over the Tier 1 target, which the user must meet in order to unlock the Tier 2 payout.
        <br />Example: Tier 1 Target S/A is 5000.  Inputting "50" would mean the user must have an S/A of 7500 in order to receive the Tier 2 payout.
        <br /><br />
        NOTE: Video and Thread articles <i><b>DO NOT COUNT</b></i> towards the target (based on the "TYPE" chosen in the article).
        </p>
    `;

    protected tier2BonusPercentageTooltipContent = `
       <p><b>TIER 2 BONUS % OF CONSULTING BASE</b> is the percentage that will be used to calculate the amount of the bonus transaction by multiplying it with the sum of <i><b>Time Period-Consulting Base</b></i> in the same <i><b>Month</b></i>.
        <br /><br />
        Emaki will begin checking to create transactions <i><b>10 DAYS AFTER</b></i> the end of a month if Tier 2 is met for all brands set.  If Tier 2 is not met, it will instead wait the full <i><b>10 DAYS</b></i>, before generating any transactions for Tier 1 amounts, in order to ensure the full active sessions are considered.
        <br />
        NOTE: Once Emaki generates a Monthly S/A transaction, it <i><b>WILL NOT UPDATE IT</b></i> at a later date.  This also applies to <i><b>MANUALLY CREATED BONUS TRANSACTIONS</b></i>.  If you manually create a bonus transaction for a time period, Emaki will <i><b>NOT</b></i> update it.
        <br />Example: On December 11th, Emaki determines Tier 1 is met, but not Tier 2, it will not generate a transaction.  If active sessions gained by those articles would change the average to meet Tier 2 in the following days, a transaction for Tier 2 will generate.  Otherwise, 31 days after month end, it will generate a transaction for the Tier 1 amount.
        </p>
    `;

    protected effectiveDateTooltipContent = `
        <p><strong>EFFECTIVE MONTH</strong> is the first month eligible for the configured Bonus to apply.  If set to a future month, any articles/republishes published before then would <strong>NOT</strong> be considered for bonus transactions and the minimum output target would not apply to them.  If the month set is the <em>current month, in the past, or left empty</em>, then all articles/republishes <strong>GOING FORWARD</strong> would have bonus rules applied to them.
        <br /><br />
        <em><strong>NOTE:</strong> The system will not delete any existing transactions.  So, if you want this to take effect in the current month, you will have to manually remove any article or bonus transactions that already exists.</em></p>
    `;

    protected getTemplateHtml(): string {

        return /*html*/ `
            <div class="form-header">
                <input id="user-id" data-bind="value: idUser" type="hidden">
                <!-- ko ifnot: $data.idUser() -->
                <h3 class="form-title icon i-user-add">Add User</h3>
                <!-- /ko -->

                <!-- ko if: $data.idUser() -->
                <h3 class="form-title icon i-user-add">Edit User</h3>
                <!-- /ko -->

                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
            </div>

            ${this.embedder.getHtmlBuild()}

            <div class="form-pagination">
                <button data-bind="event: { click: onClickShowUserInfosTab }, css: { 'is-activated':  isShowUserInfosTab}" class="btn icon i-user" type="button"><span class="btn-text">User Info</span></button>
                <!-- ko if: brandInfo().length > 0 -->
                    <button data-bind="event: { click: onClickShowUserRatesTab }, css: { 'is-activated': isShowUserRatesTab, 'is-hidden': !permissions()['users_form_rates'].read }" class="btn icon i-edit" type="button"><span class="btn-text">Payment Rate</span></button>
                    <button data-bind="event: { click: onClickShowAuthorDetailsTab }, css: { 'is-activated': isShowAuthorDetailsTab }" class="btn icon i-role is-showing" type="button"><span class="btn-text">Author Details</span></button>
                    <button data-bind="event: { click: onClickShowPinnedArticlesTab }, css: { 'is-activated': isShowPinnedArticlesTab }" class="btn icon i-pin-choice is-showing" type="button"><span class="btn-text">Pinned Sections</span></button>
                <!-- /ko -->
                <!-- <button data-bind="event: { click: onClickShowUserPreferencesTab }, css: { 'is-activated': isShowUserPreferencesTab }" class="btn icon i-role is-showing" type="button"><span class="btn-text">User Preferences</span></button> -->
            </div>

            <div class="ww-form-body user-edit-form" data-bind="css: { 'is-showing': isShowUserRatesTab }">

                <div class="form-group" style="margin: 1.5rem auto -1rem; max-width: 940px">
                    <p class="form-text" style="border-radius: 4px; width: fit-content; padding: 1.25rem; background: #f2f2f2;">
                        <span class="default">Rates</span> have not been modified from default value<br>
                        <span class="modify">Rates</span> have been modified<br>
                        <span class="unsaved">Rates</span> have just been modified but not saved yet
                    </p>
                </div>

                <div class="w-form-body" style="overflow-x: scroll" data-bind="foreach: userRates">

                    <div class="form-body full-width w-payment-rate" data-bind="visible: $parent.isBrandSelected($data)">

                        <table class="list-action payment-rate">
                            <thead>
                                <tr>
                                    <th colspan="8">
                                        <div style="padding: .5rem">
                                            <span class="" data-bind="text: $data.brand, css: $data.icon"></span >
                                            <button type="button" class="btn-form icon i-multi" style="gap:.5rem;" data-bind="event: {click: $parents[0].onShowBrandRateCategoryPanel }">Add/Remove Category</button>
                                        </div>
                                        <div class="w-lightbox light-theme" data-bind="css: { 'is-visible': $data.isVisible }">
                                            <div class="lightbox-content">
                                                <div class="w-form lightbox-form">
                                                    <div class="form-header">
                                                        <h3 class="form-title">Add/Remove Category</h3>
                                                        <button type="button" class="close-button icon i-close-2" data-bind="event: { click: $parents[0].onClickCancelRateCategoriesPanel }" ></button>
                                                    </div>

                                                    <div class="form-body">
                                                        <div class="form-group">
                                                             <div data-bind="foreach: $data.rateCategories" class="form-group" style="padding-left: 4rem; padding-bottom: 1rem; flex-wrap: wrap;">
                                                                <div class="multi-row" style="flex: 1 33%;margin-bottom: 0;">
                                                                    <input data-bind="value: id, checked: $parent.selectedCategories, attr:{id: $parent.brand + '_categoryFilter_' + $data.name + '_' + id}, event: { click: $parents[1].onFilterCategories.bind($data,$parent)}" type="checkbox">
                                                                    <label class="form-label icon i-check" data-bind="text: name, attr:{for: $parent.brand + '_categoryFilter_' + name + '_' + id}"></label>
                                                                </div>
                                                             </div>
                                                        </div>
                                                     </div>

                                                     <div class="form-footer">
                                                        <button type="button" class="btn" data-bind="event: { click: $parents[0].onClickCancelRateCategoriesPanel }">Cancel</button>
                                                        <button  data-bind="event: { click: $parents[0].onClickAcceptRateCategoriesPanel }" class="btn icon highlight">OK</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </th>
                                </tr>

                                <!-----
                                <tr class="mid">
                                    <th class="align-center" colspan="1" style="border-bottom:1px solid #fff;">
                                        <span>Article</span>
                                    </th>
                                    <th class="align-center" colspan="1" style="border-bottom:1px solid #fff;">
                                        <span>Article</span>
                                    </th>
                                </tr>
                                ----->

                                <tr class="mid green">
                                    <th style="padding-bottom:7px !important; vertical-align: bottom; background: #f2f2f2;" data-bind="attr: {rowspan: $data.writerHasSABonus || $data.editorHasSABonus ? '9' : '4'}" >
                                        <span>Payment Category</span>
                                    </th>
                                    <th colspan="1" class="align-center" style="border-bottom:1px solid #fff;">
                                        <div class="form-check-inline" style="padding:0;">
                                            <input data-bind="checked: $data.writerHasSABonus, attr:{id: 's-a-bonus-writer_'  + $data.brand}, click: $parents[0].onClickWriterSABonus", type="checkbox">
                                            <label data-bind="attr:{for:'s-a-bonus-writer_' + $data.brand}" class="form-label icon i-check">Monthly S/A Bonus</label>
                                        </div>
                                        <div class="form-check-inline" style="padding:0;" data-bind="visible: $data.writerHasSABonus">
                                            <input data-bind="checked: $data.writerIncludesRepublishSessions, attr:{id: 's-a-republish-writer_'  + $data.brand}", type="checkbox">
                                            <label data-bind="attr:{for:'s-a-republish-writer_' + $data.brand}" class="form-label icon i-check">Include Republish S/A</label>
                                        </div>
                                    </th>

                                    <th colspan="1" class="align-center" style="border-bottom:1px solid #fff;">
                                        <div class="form-check-inline" style="padding:0;">
                                            <input data-bind="checked: $data.writerHasUSSession, attr:{id: 's-a-us-session_'  + $data.brand}, click: $parents[0].onClickWriterHasUSSession", type="checkbox">
                                            <label data-bind="attr:{for:'s-a-us-session_' + $data.brand}" class="form-label icon i-check">Pay Per US Session</label>
                                        </div>

                                    </th>

                                    <th colspan="1" class="align-center" style="border-bottom:1px solid #fff;">
                                        <div class="form-check-inline" style="padding:0;">
                                            <input data-bind="checked: $data.editorHasSABonus, attr:{id: 's-a-bonus-editor_'  + $data.brand}, click: $parents[0].onClickEditorSABonus", type="checkbox">
                                            <label data-bind="attr:{for:'s-a-bonus-editor_'  + $data.brand}" class="form-label icon i-check">Monthly S/A Bonus</label>
                                        </div>
                                        <div class="form-check-inline" style="padding:0;" data-bind="visible: $data.editorHasSABonus">
                                            <input data-bind="checked: $data.editorIncludesRepublishSessions, attr:{id: 's-a-republish-editor_'  + $data.brand}", type="checkbox">
                                            <label data-bind="attr:{for:'s-a-republish-editor_' + $data.brand}" class="form-label icon i-check">Include Republish S/A</label>
                                        </div>
                                    </th>

                                    <th colspan="1" class="align-center" style="border-bottom:1px solid #fff;">
                                        <div class="form-check-inline" style="padding:0;">
                                            <input data-bind="checked: $data.editorHasUSSession, attr:{id: 's-a-us-session-editor_'  + $data.brand}, click: $parents[0].onClickEditorHasUSSession", type="checkbox">
                                            <label data-bind="attr:{for:'s-a-us-session-editor_' + $data.brand}" class="form-label icon i-check">Editor Pay Per US Session</label>
                                        </div>

                                    </th>
                                </tr>

                                <tr class="mid green" data-bind="visible: $data.writerHasSABonus || $data.editorHasSABonus">

                                    <th colspan="1" style="border-bottom:1px solid #fff;" >
                                        <!-- ko if: $data.writerHasSABonus -->
                                        <div class="flex" style="gap: .25rem; justify-content: space-between;">
                                            <div class="flex">
                                                <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.writerOutputMinimumTargetHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                                <label for="" class="form-label">Min. Output Target</label>
                                            </div>
                                            <input style="width: 30%;" name="" class="input-text input-number" data-bind="value: $data.writerOutputMinimumTarget" type="text">
                                        </div>
                                        <!-- /ko -->
                                    </th>
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                    </th>

                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                        <!-- ko if: $data.editorHasSABonus -->
                                        <div class="flex" style="gap: .25rem; justify-content: space-between;">
                                            <div class="flex">
                                                <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.editorOutputMinimumTargetHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                                <label for="" class="form-label">Min. Output Target</label>
                                            </div>
                                            <input style="width: 30%;" name="" class="input-text input-number" data-bind="value: $data.editorOutputMinimumTarget" type="text">
                                        </div>
                                        <!-- /ko -->
                                    </th>
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                    </th>
                                </tr>

                                <tr class="mid green" data-bind="visible: $data.writerHasSABonus || $data.editorHasSABonus">

                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                        <!-- ko if: $data.writerHasSABonus -->
                                        <div class="flex" style="gap: .25rem; justify-content: space-between;">
                                            <div class="flex">
                                                <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.writerTier1TargetSAHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                                <label for="" class="form-label">Tier 1 Target Active S/A</label>
                                            </div>
                                            <input style="width: 30%;" name="" placeholder="Brand Default" class="input-text input-number" data-bind="value: $data.writerTier1Target" type="text">
                                        </div>
                                        <!-- /ko -->
                                    </th>
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                    </th>

                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                        <!-- ko if: $data.editorHasSABonus -->
                                        <div class="flex" style="gap: .25rem; justify-content: space-between;">
                                            <div class="flex">
                                                <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.editorTier1TargetSAHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                                <label for="" class="form-label">Tier 1 Target Active S/A</label>
                                            </div>
                                            <input style="width: 30%;" name="" placeholder="Brand Default" class="input-text input-number" data-bind="value: $data.editorTier1Target" type="text">
                                        </div>
                                        <!-- /ko -->
                                    </th>
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                    </th>
                                </tr>

                                <tr class="mid green" data-bind="visible: $data.writerHasSABonus || $data.editorHasSABonus">
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                        <!-- ko if: $data.writerHasSABonus -->
                                        <div class="flex" style="gap: .25rem; justify-content: space-between;">
                                            <div class="flex">
                                                <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.writerTier1BonusPercentageHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                                <label for="" class="form-label">Tier 1 Bonus</label>
                                            </div>

                                            <div class="form-check-inline width-auto">
                                                <input type="radio" value="percentage" data-bind="checked: $data.writerTier1BonusType, attr: { name: 'writerTier1BonusType'  + $data.brand, id: 'writerTier1BonusTypePercentage'  + $data.brand  }" />
                                                <label class="form-label" data-bind="attr: { for: 'writerTier1BonusTypePercentage'  + $data.brand }">% of base</label>
                                            </div>
                                            <div class="form-check-inline width-auto">
                                                <input type="radio" value="amount" data-bind="checked: $data.writerTier1BonusType, attr: { name: 'writerTier1BonusType'  + $data.brand, id: 'writerTier1BonusTypeAmount'  + $data.brand  }" />
                                                <label class="form-label" data-bind="attr: { for: 'writerTier1BonusTypeAmount'  + $data.brand }">flat amount</label>
                                            </div>

                                            <input style="width: 30%;" name="" class="input-text input-number" data-bind="value: $data.writerTier1Bonus" type="text">
                                        </div>
                                        <!-- /ko -->
                                    </th>
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                    </th>
                                    <th colspan="1" style="border-bottom:1px solid #fff;" >
                                        <!-- ko if: $data.editorHasSABonus -->
                                        <div class="flex" style="gap: .25rem; justify-content: space-between;">
                                            <div class="flex">
                                                <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.editorTier1BonusPercentageHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                                <label for="" class="form-label">Tier 1 Bonus</label>
                                            </div>

                                            <div class="form-check-inline width-auto">
                                                <input type="radio" value="percentage" data-bind="checked: $data.editorTier1BonusType, attr: { name: 'editorTier1BonusType'  + $data.brand, id: 'editorTier1BonusTypePercentage'  + $data.brand }" />
                                                <label class="form-label" data-bind="attr: { for: 'editorTier1BonusTypePercentage'  + $data.brand }">% of base</label>
                                            </div>
                                            <div class="form-check-inline width-auto">
                                                <input type="radio" value="amount" data-bind="checked: $data.editorTier1BonusType, attr: { name: 'editorTier1BonusType'  + $data.brand, id: 'editorTier1BonusTypeAmount'  + $data.brand }" />
                                                <label class="form-label" data-bind="attr: { for: 'editorTier1BonusTypeAmount'  + $data.brand }">flat amount</label>
                                            </div>

                                            <input style="width: 30%;" name="" class="input-text input-number" data-bind="value: $data.editorTier1Bonus" type="text">
                                        </div>
                                        <!-- /ko -->
                                    </th>
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                    </th>
                                </tr>

                                <tr class="mid green" data-bind="visible: $data.writerHasSABonus || $data.editorHasSABonus">
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                        <!-- ko if: $data.writerHasSABonus -->
                                        <div class="flex" style="gap: .25rem; justify-content: space-between;">
                                            <div class="flex">
                                                <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.writerTier2TargetSAHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                                <label for="" class="form-label">Tier 2 % Increase S/A</label>
                                            </div>
                                            <input style="width: 30%;" name="" placeholder="No Tier 2 Goal" class="input-text input-number" data-bind="value: $data.writerTier2Target" type="text">
                                        </div>
                                        <!-- /ko -->
                                    </th>
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                    </th>
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                         <!-- ko if: $data.editorHasSABonus -->
                                        <div class="flex" style="gap: .25rem; justify-content: space-between;">
                                            <div class="flex">
                                                <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.editorTier2TargetSAHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                                <label for="" class="form-label">Tier 2 % Increase S/A</label>
                                            </div>
                                            <input style="width: 30%;" name="" placeholder="No Tier 2 Goal" class="input-text input-number" data-bind="value: $data.editorTier2Target" type="text">
                                        </div>
                                        <!-- /ko -->
                                    </th>
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                    </th>
                                </tr>

                                <tr class="mid green" data-bind="visible: $data.writerHasSABonus || $data.editorHasSABonus">
                                    <th colspan="1" style="border-bottom:1px solid #fff;" >
                                        <!-- ko if: $data.writerHasSABonus -->
                                        <div class="flex" style="gap: .25rem; justify-content: space-between;">
                                            <div class="flex">
                                                <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.writerTier2BonusPercentageHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                                <label for="" class="form-label">Tier 2 Bonus</label>
                                            </div>

                                            <div class="form-check-inline width-auto">
                                                <input type="radio" value="percentage" data-bind="checked: $data.writerTier2BonusType, attr: { name: 'writerTier2BonusType'  + $data.brand, id: 'writerTier2BonusTypePercentage'  + $data.brand }" />
                                                <label class="form-label" data-bind="attr: { for: 'writerTier2BonusTypePercentage'  + $data.brand }">% of base</label>
                                            </div>
                                            <div class="form-check-inline width-auto">
                                                <input type="radio" value="amount" data-bind="checked: $data.writerTier2BonusType, attr: { name: 'writerTier2BonusType'  + $data.brand, id: 'writerTier2BonusTypeAmount'  + $data.brand }" />
                                                <label class="form-label" data-bind="attr: { for: 'writerTier2BonusTypeAmount'  + $data.brand }">flat amount</label>
                                            </div>

                                            <input style="width: 30%;" name="" placeholder="No Tier 2 Goal" class="input-text input-number" data-bind="value: $data.writerTier2Bonus" type="text">
                                        </div>
                                        <!-- /ko -->
                                    </th>
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                    </th>

                                    <th colspan="1" style="border-bottom:1px solid #fff;" >
                                         <!-- ko if: $data.editorHasSABonus -->
                                         <div class="flex" style="gap: .25rem; justify-content:space-between;">
                                            <div class="flex">
                                                <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.editorTier2BonusPercentageHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                                <label for="" class="form-label">Tier 2 Bonus</label>
                                            </div>

                                            <div class="form-check-inline width-auto">
                                                <input type="radio" value="percentage" data-bind="checked: $data.editorTier2BonusType, attr: { name: 'editorTier2BonusType'  + $data.brand, id: 'editorTier2BonusTypePercentage'  + $data.brand }" />
                                                <label class="form-label" data-bind="attr: { for: 'editorTier2BonusTypePercentage'  + $data.brand }">% of base</label>
                                            </div>
                                            <div class="form-check-inline width-auto">
                                                <input type="radio" value="amount" data-bind="checked: $data.editorTier2BonusType, attr: { name: 'editorTier2BonusType'  + $data.brand, id: 'editorTier2BonusTypeAmount'  + $data.brand }" />
                                                <label class="form-label" data-bind="attr: { for: 'editorTier2BonusTypeAmount'  + $data.brand }">flat amount</label>
                                            </div>

                                            <input style="width: 30%;" name="" placeholder="No Tier 2 Goal" class="input-text input-number" data-bind="value: $data.editorTier2Bonus" type="text">
                                        </div>
                                         <!-- /ko -->
                                    </th>
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                    </th>
                                </tr>

                                <tr class="mid green" data-bind="visible: $data.writerHasSABonus || $data.editorHasSABonus">

                                    <th colspan="1" style="border-bottom:1px solid #fff;" >
                                        <!-- ko if: $data.writerHasSABonus -->
                                        <div class="flex" style="gap: .25rem; justify-content: space-between;">
                                            <div class="flex">
                                                <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.writerEffectiveDateHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                                <label for="" class="form-label">Effective Month</label>
                                            </div>
                                            <input placeholder="YYYY-MM" style="width: 30%;" name="" class="input-text input-number" data-bind="value: $data.writerEffectiveDate" type="text">
                                        </div>
                                        <!-- /ko -->
                                    </th>
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                    </th>

                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                        <!-- ko if: $data.editorHasSABonus -->
                                        <div class="flex" style="gap: .25rem; justify-content: space-between;">
                                            <div class="flex">
                                                <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.editorEffectiveDateHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                                <label for="" class="form-label">Effective Month</label>
                                            </div>
                                            <input placeholder="YYYY-MM" style="width: 30%;" name="" class="input-text input-number" data-bind="value: $data.editorEffectiveDate" type="text">
                                        </div>
                                        <!-- /ko -->
                                    </th>
                                    <th colspan="1" style="border-bottom:1px solid #fff;">
                                    </th>
                                </tr>

                                <tr class="light">
                                    <th colspan="1">
                                        <div class="flex" style="justify-content: center;">
                                            <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.writerCommissionHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                            <span>Writer Commision</span>
                                        </div>
                                    </th>

                                    <th colspan="1">
                                        <div class="flex" style="justify-content: center;">
                                            <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.writerSessionCommissionHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                            <!-- ko if : $data.writerHasUSSession -->
                                            <span>Pay Per US Session</span>
                                            <!-- /ko -->
                                            <!-- ko ifnot : $data.writerHasUSSession -->
                                            <span>Pay Per Session</span>
                                            <!-- /ko -->
                                        </div>
                                    </th>

                                    <th colspan="1">
                                        <div class="flex" style="justify-content: center;">
                                            <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.editorCommissionHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                            <span >Editor Commision</span>
                                        </div>
                                    </th>

                                    <th colspan="1">
                                        <div class="flex" style="justify-content: center;">
                                            <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.editorSessionCommissionHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                            <!-- ko if : $data.editorHasUSSession -->
                                            <span>Editor Pay Per US Session</span>
                                            <!-- /ko -->
                                            <!-- ko ifnot : $data.editorHasUSSession -->
                                            <span>Editor Pay Per Session</span>
                                            <!-- /ko -->
                                        </div>
                                    </th>
                                </tr>

                                <!------
                                <tr class="mid">
                                    <th style="vertical-align: top; padding-top: .5rem !important; background: #ffffff; border-right: 1px solid #efefef;">
                                        <div class="flex">
                                            <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.writerCommissionHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                            <span>Commission</span>
                                        </div>
                                    </th>
                                    <th style="vertical-align: top;padding-top: .5rem !important;">
                                        <div class="flex">
                                            <span>Performance</span>
                                            <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.writerPerformanceHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                        </div>
                                    </th>

                                    <th style="vertical-align: top;padding-top: .5rem !important;">
                                        <div class="flex">
                                            <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.writerArticlegroupHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                            <span>Article Group</span>
                                        </div>
                                        <select data-bind="options: ['bi-monthly', 'monthly'], value: articleGroupType"></select>
                                    </th>
                                    <th style="vertical-align: top;padding-top: .5rem !important; background: #ffffff; border-right: 1px solid #efefef;">
                                        <div class="flex">
                                        <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.editorCommissionHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                            <span>Commission</span>
                                        </div>
                                    </th>
                                    <th style="vertical-align: top;padding-top: .5rem !important;">
                                        <div class="flex">
                                            <span>Performance</span>
                                             <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.editorPerformanceHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                        </div>
                                    </th>

                                    <th style="vertical-align: top;padding-top: .5rem !important;">
                                        <div class="flex">
                                            <span>Article Group</span>
                                            <div class="w-tooltips-adv pos-bottom short" data-bind="template: { name: 'infoButton-template', data: $data.editorArticlegroupHeaderTooltipBtn.getTemplateViewModel() }"></div>
                                        </div>
                                        <select data-bind="options: ['bi-monthly', 'monthly'], value: articleGroupType"></select>
                                    </th>
                                </tr>
                                ----->

                            </thead>
                            <tbody data-bind="foreach: $data.rates" >
                                <tr data-bind="visible: showRow">
                                    <td class="align-left"><span data-bind="text: category"></span></td>
                                    <td style="padding: .5rem .5rem .5rem 1.25rem;">
                                        <div class="flex start" style="gap: .5rem;" data-bind="css: {'disabledDiv':  !$data.writerArticleGroupDisabled() }">
                                            <input class="input-text input-number" data-bind="value: $data.articleCommission, valueUpdate: 'afterkeydown', event: { keyup: $parents[1].onChangeRateField.bind($data, 'writerArticleCommission') }, css: $data.articleCommissionStateStatus" type="text">
                                            <div class="option-dropdown" data-bind="css: {'is-hidden': $data.hideArticleCommissionResetBtn()}">
                                                <button class="btn-form option-dropdown-toggle icon i-refresh" type="button"></button>
                                                <ul class="option-dropdown-list">
                                                    <li class="option-dropdown-item">
                                                        <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertArticleCommission">Reset to Default</button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </td>

                                    <!-- Pay Per Session -->
                                    <td style="padding: .5rem .5rem .5rem 1.25rem;">
                                        <div class="w-rate-setting" style="gap: .5rem; margin: auto; width: auto !important;" data-bind="css: {'disabledDiv':  !$data.payPerSessionGroupDisabled() }">
                                            <!-- ko if : $parents[0].writerHasUSSession -->
                                            <!-- Rate field for US Session -->
                                            <div class="inside-label">
                                                <label for="" class="form-label">Rate</label>
                                                <input class="input-text input-number"
                                                      data-bind="value: $data.payPerUSSession,
                                                                 valueUpdate: 'afterkeydown',
                                                                 event: { keyup: $parents[1].onChangeRateField.bind($data, 'payPerUSSession') },
                                                                 css: $data.payPerUSSessionStateStatus"
                                                      type="text">
                                                <div class="option-dropdown" data-bind="css: {'is-hidden': $data.hidePayPerUSSessionResetBtn()}">
                                                    <button class="btn-form option-dropdown-toggle icon i-refresh" type="button"></button>
                                                    <ul class="option-dropdown-list">
                                                        <li class="option-dropdown-item">
                                                            <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertPayPerUSSession">Reset to Default</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <!-- Min field for US Session -->
                                            <div class="inside-label">
                                                <label for="" class="form-label">Min</label>
                                                <input class="input-text input-number"
                                                    data-bind="value: $data.minPayPerUSSession,
                                                               valueUpdate: 'afterkeydown',
                                                               event: { keyup: $parents[1].onChangeRateField.bind($data, 'minPayPerUSSession') },
                                                               css: $data.minPayPerUSSessionStateStatus"
                                                    type="text">
                                                <div class="option-dropdown" data-bind="css: {'is-hidden': $data.hideMinPayPerUSSessionResetBtn()}">
                                                    <button class="btn-form option-dropdown-toggle icon i-refresh" type="button"></button>
                                                    <ul class="option-dropdown-list">
                                                        <li class="option-dropdown-item">
                                                            <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertMinPayPerUSSession">Reset to Default</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <!-- Max field for US Session -->
                                            <div class="inside-label">
                                                <label for="" class="form-label">Max</label>
                                                <input class="input-text input-number"
                                                        data-bind="value: $data.maxPayPerUSSession,
                                                                   valueUpdate: 'afterkeydown',
                                                                   event: { keyup: $parents[1].onChangeRateField.bind($data, 'maxPayPerUSSession') },
                                                                   css: $data.maxPayPerUSSessionStateStatus"
                                                        type="text">
                                                <div class="option-dropdown" data-bind="css: {'is-hidden': $data.hideMaxPayPerUSSessionResetBtn()}">
                                                    <button class="btn-form option-dropdown-toggle icon i-refresh" type="button"></button>
                                                    <ul class="option-dropdown-list">
                                                        <li class="option-dropdown-item">
                                                            <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertMaxPayPerUSSession">Reset to Default</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <!-- /ko -->

                                            <!-- ko ifnot : $parents[0].writerHasUSSession -->
                                            <!-- Rate field for Regular Session -->
                                            <div class="inside-label">
                                                <label for="" class="form-label">Rate</label>
                                                <input class="input-text input-number"
                                                      data-bind="value: $data.payPerSession,
                                                                 valueUpdate: 'afterkeydown',
                                                                 event: { keyup: $parents[1].onChangeRateField.bind($data, 'payPerSession') },
                                                                 css: $data.payPerSessionStateStatus"
                                                      type="text">
                                                <div class="option-dropdown" data-bind="css: {'is-hidden': $data.hidePayPerSessionResetBtn()}">
                                                    <button class="btn-form option-dropdown-toggle icon i-refresh" type="button"></button>
                                                    <ul class="option-dropdown-list">
                                                        <li class="option-dropdown-item">
                                                            <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertPayPerSession">Reset to Default</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <!-- Min field for Regular Session -->
                                            <div class="inside-label">
                                                <label for="" class="form-label">Min</label>
                                                <input class="input-text input-number"
                                                    data-bind="value: $data.minPayPerSession,
                                                               valueUpdate: 'afterkeydown',
                                                               event: { keyup: $parents[1].onChangeRateField.bind($data, 'minPayPerSession') },
                                                               css: $data.minPayPerSessionStateStatus"
                                                    type="text">
                                                <div class="option-dropdown" data-bind="css: {'is-hidden': $data.hideMinPayPerSessionResetBtn()}">
                                                    <button class="btn-form option-dropdown-toggle icon i-refresh" type="button"></button>
                                                    <ul class="option-dropdown-list">
                                                        <li class="option-dropdown-item">
                                                            <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertMinPayPerSession">Reset to Default</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <!-- Max field for Regular Session -->
                                            <div class="inside-label">
                                                <label for="" class="form-label">Max</label>
                                                <input class="input-text input-number"
                                                        data-bind="value: $data.maxPayPerSession,
                                                                   valueUpdate: 'afterkeydown',
                                                                   event: { keyup: $parents[1].onChangeRateField.bind($data, 'maxPayPerSession') },
                                                                   css: $data.maxPayPerSessionStateStatus"
                                                        type="text">
                                                <div class="option-dropdown" data-bind="css: {'is-hidden': $data.hideMaxPayPerSessionResetBtn()}">
                                                    <button class="btn-form option-dropdown-toggle icon i-refresh" type="button"></button>
                                                    <ul class="option-dropdown-list">
                                                        <li class="option-dropdown-item">
                                                            <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertMaxPayPerSession">Reset to Default</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <!-- /ko -->

                                        </div>
                                    </td>
                                    <!--<td>
                                        <div class="w-rate-setting" data-bind="css: {'is-open': $data.performancePanelOpen(), 'disabledDiv':  !$data.writerArticleGroupDisabled() }">
                                            <div class="rate-setting">
                                                <div class="inside-label">
                                                    <label for="" class="form-label">Rate</label>
                                                    <input class="input-text input-number" data-bind="value: $data.articlePerformance, valueUpdate: 'afterkeydown', event: { keyup: $parents[1].onChangeRateField.bind($data, 'writerArticlePerformance')}, css: $data.articlePerformanceStateStatus" type="text">

                                                </div>

                                                <button type="button" class="btn-form icon i-dropdown-simple" data-bind="event: {click: $parents[1].onToggleRatePanel.bind($data, 'writerArticlePerformance')}"/><span data-bind="text: $data.optionsWriterPerformanceToggleText()" style="text-decoration: underline"></span></button>
                                            </div>
                                            <div class="option-dropdown with-rate" style="display: block;" data-bind="css: {'is-hidden': $data.hideArticlePerformanceResetBtn()}">
                                                <button  class="btn-form option-dropdown-toggle icon i-kebab" type="button"></button>
                                                <ul class="option-dropdown-list">
                                                    <li class="option-dropdown-item">
                                                        <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertArticlePerformance">Reset to Default</button>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div class="threshold" >
                                                <div class="w-input">

                                                    <div class="inside-label" style="position:relative;">
                                                        <label for="" class="form-label tall">Min<br>Tresh</label>
                                                        <input class="input-text input-number" type="text"  data-bind="value: $data.minArticlePerformance, enable: ($data.minRateFilledType() == 'custom' && $data.articlePerformanceStateStatus() != 'default')"/>
                                                        <div class="w-tooltips-adv pos-bottom short" style="position:absolute;top:-1.25rem;right:-.5rem;" data-bind="template: { name: 'infoButton-template', data: $data.minPerformanceTooltip.getTemplateViewModel() }"></div>
                                                    </div>

                                                    <div class="option-dropdown" style="margin-right: 1rem" data-bind="if: $data.articlePerformanceStateStatus() != 'default'">
                                                        <button class="btn-form option-dropdown-toggle icon i-kebab" type="button"></button>
                                                        <ul class="option-dropdown-list">
                                                            <li class="option-dropdown-item">
                                                                <button class="btn" data-bind="text: ($data.minRateFilledType() == 'auto') ? 'Set Threshold To Custom' : 'Set Threshold To Auto', event: {click: $parents[1].onChangeArticlePerformanceMinSource.bind($data, 'writerArticlePerformance')}" type="button">Set Threshold to Custom</button>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div class="inside-label" style="position:relative;">
                                                        <label for="" class="form-label tall">Max<br>Pay</label>
                                                        <input class="input-text input-number" type="text" data-bind="value: $data.maxArticlePerformance, enable: $data.articlePerformanceStateStatus() != 'default'">
                                                        <div class="w-tooltips-adv pos-bottom short" style="position:absolute;top:-1.25rem;right:-.5rem;" data-bind="template: { name: 'infoButton-template', data: $data.maxPerformanceTooltip.getTemplateViewModel() }"></div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="w-rate-setting" data-bind="css: {'is-open': $data.writerArticleGroupPanelOpen()}">
                                            <div class="rate-setting">
                                                <div class="inside-label">
                                                    <label for="" class="form-label">Rate</label>
                                                    <input class="input-text input-number" data-bind="value: $data.writerArticleGroup, valueUpdate: 'afterkeydown', event: { keyup: $parents[1].onChangeRateField.bind($data, 'writerArticleGroup')}, css: $data.writerArticleGroupStateStatus" type="text">
                                                </div>
                                                <button type="button" class="btn-form icon i-dropdown-simple" data-bind="event: {click: $parents[1].onToggleRatePanel.bind($data, 'writerArticleGroup')}"/><span data-bind="text: $data.optionsWriterArticleGroupToggleText()" style="text-decoration: underline"></span></button>
                                            </div>
                                            <div class="option-dropdown with-rate" style="display: block;" data-bind="css: {'is-hidden': $data.hideWriterArticleGroupResetBtn()}">
                                                <button  class="btn-form option-dropdown-toggle icon i-kebab" type="button"></button>
                                                <ul class="option-dropdown-list">
                                                    <li class="option-dropdown-item">
                                                        <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertWriterArticleGroup">Reset to Default</button>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div class="threshold" >
                                                <div class="w-input">

                                                    <div class="inside-label" style="position:relative;">
                                                        <label for="" class="form-label tall">Min<br>Tresh</label>
                                                        <input class="input-text input-number" type="text"  data-bind="value: $data.minWriterArticleGroup, enable: ($data.minRateFilledType() == 'custom')"/>
                                                        <div class="w-tooltips-adv pos-bottom short" style="position:absolute;top:-1rem;right:-.5rem;" data-bind="template: { name: 'infoButton-template', data: $data.minWriterArticleGroupTooltip.getTemplateViewModel() }"></div>
                                                    </div>



                                                    <div class="inside-label" style="position:relative;">
                                                        <label for="" class="form-label tall">Max<br>Pay</label>
                                                        <input class="input-text input-number" type="text" data-bind="value: $data.maxWriterArticleGroup">
                                                        <div class="w-tooltips-adv pos-bottom short" style="position:absolute;top:-1rem;right:-.5rem;" data-bind="template: { name: 'infoButton-template', data: $data.maxWriterArticleGroupTooltip.getTemplateViewModel() }"></div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="padding: .5rem .5rem .5rem 1.25rem;">

                                        <div class="flex start" style="gap: .5rem;"  data-bind="css: { 'disabledDiv':  !$data.writerArticleGroupDisabled() }">
                                            <input class="input-text input-number" data-bind="value: $data.tldrCommission, valueUpdate: 'afterkeydown', event: { keyup: $parents[1].onChangeRateField.bind($data, 'writerTldrCommission') }, css: $data.tldrCommissionStateStatus" type="text">
                                            <div class="option-dropdown" data-bind="css:{'is-hidden': $data.hideTldrCommissionResetBtn()}">
                                                <button class="btn-form option-dropdown-toggle icon i-kebab" type="button"></button>
                                                <ul class="option-dropdown-list">
                                                    <li class="option-dropdown-item">
                                                        <button class="btn" style="text-decoration: underline" type="button" data-bind="click: $parents[1].onClickRevertTldrCommission">Reset to Default</button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                    </td>-->
                                    <td style="padding: .5rem .5rem .5rem 1.25rem;">
                                        <div class="flex start" style="gap: .5rem;" data-bind="css: {'disabledDiv':  !$data.editorArticleGroupDisabled() }">
                                            <input class="input-text input-number" data-bind="value: $data.editorArticleCommission, valueUpdate: 'afterkeydown', event: { keyup: $parents[1].onChangeRateField.bind($data, 'editorArticleCommission') }, css: $data.editorArticleCommissionStateStatus" type="text">
                                            <div class="option-dropdown" data-bind="css: {'is-hidden': $data.hideEditorArticleCommissionResetBtn()}">
                                                <button class="btn-form option-dropdown-toggle icon i-refresh" type="button"></button>
                                                <ul class="option-dropdown-list">
                                                    <li class="option-dropdown-item">
                                                        <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertEditorArticleCommission">Reset to Default</button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </td>

                                    <!-- Pay Per Session -->
                                    <td style="padding: .5rem .5rem .5rem 1.25rem;">
                                        <div class="w-rate-setting" style="gap: .5rem; margin: auto; width: auto !important;" data-bind="css: {'disabledDiv':  !$data.editorPayPerSessionGroupDisabled() }">
                                            <!-- ko if : $parents[0].editorHasUSSession -->
                                            <!-- Rate field for US Session -->
                                            <div class="inside-label">
                                                <label for="" class="form-label">Rate</label>
                                                <input class="input-text input-number"
                                                      data-bind="value: $data.editorPayPerUSSession,
                                                                 valueUpdate: 'afterkeydown',
                                                                 event: { keyup: $parents[1].onChangeRateField.bind($data, 'editorPayPerUSSession') },
                                                                 css: $data.editorPayPerUSSessionStateStatus"
                                                      type="text">
                                                <div class="option-dropdown" data-bind="css: {'is-hidden': $data.hideEditorPayPerUSSessionResetBtn()}">
                                                    <button class="btn-form option-dropdown-toggle icon i-refresh" type="button"></button>
                                                    <ul class="option-dropdown-list">
                                                        <li class="option-dropdown-item">
                                                            <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertEditorPayPerUSSession">Reset to Default</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <!-- Min field for US Session -->
                                            <div class="inside-label">
                                                <label for="" class="form-label">Min</label>
                                                <input class="input-text input-number"
                                                    data-bind="value: $data.minEditorPayPerUSSession,
                                                               valueUpdate: 'afterkeydown',
                                                               event: { keyup: $parents[1].onChangeRateField.bind($data, 'minEditorPayPerUSSession') },
                                                               css: $data.minEditorPayPerUSSessionStateStatus"
                                                    type="text">
                                                <div class="option-dropdown" data-bind="css: {'is-hidden': $data.hideMinEditorPayPerUSSessionResetBtn()}">
                                                    <button class="btn-form option-dropdown-toggle icon i-refresh" type="button"></button>
                                                    <ul class="option-dropdown-list">
                                                        <li class="option-dropdown-item">
                                                            <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertMinEditorPayPerUSSession">Reset to Default</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <!-- Max field for US Session -->
                                            <div class="inside-label">
                                                <label for="" class="form-label">Max</label>
                                                <input class="input-text input-number"
                                                        data-bind="value: $data.maxEditorPayPerUSSession,
                                                                   valueUpdate: 'afterkeydown',
                                                                   event: { keyup: $parents[1].onChangeRateField.bind($data, 'maxEditorPayPerUSSession') },
                                                                   css: $data.maxEditorPayPerUSSessionStateStatus"
                                                        type="text">
                                                <div class="option-dropdown" data-bind="css: {'is-hidden': $data.hideMaxEditorPayPerUSSessionResetBtn()}">
                                                    <button class="btn-form option-dropdown-toggle icon i-refresh" type="button"></button>
                                                    <ul class="option-dropdown-list">
                                                        <li class="option-dropdown-item">
                                                            <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertMaxEditorPayPerUSSession">Reset to Default</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <!-- /ko -->

                                            <!-- ko ifnot : $parents[0].editorHasUSSession -->
                                            <!-- Rate field for Regular Session -->
                                            <div class="inside-label">
                                                <label for="" class="form-label">Rate</label>
                                                <input class="input-text input-number"
                                                      data-bind="value: $data.editorPayPerSession,
                                                                 valueUpdate: 'afterkeydown',
                                                                 event: { keyup: $parents[1].onChangeRateField.bind($data, 'editorPayPerSession') },
                                                                 css: $data.editorPayPerSessionStateStatus"
                                                      type="text">
                                                <div class="option-dropdown" data-bind="css: {'is-hidden': $data.hideEditorPayPerSessionResetBtn()}">
                                                    <button class="btn-form option-dropdown-toggle icon i-refresh" type="button"></button>
                                                    <ul class="option-dropdown-list">
                                                        <li class="option-dropdown-item">
                                                            <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertEditorPayPerSession">Reset to Default</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <!-- Min field for Regular Session -->
                                            <div class="inside-label">
                                                <label for="" class="form-label">Min</label>
                                                <input class="input-text input-number"
                                                    data-bind="value: $data.minEditorPayPerSession,
                                                               valueUpdate: 'afterkeydown',
                                                               event: { keyup: $parents[1].onChangeRateField.bind($data, 'minEditorPayPerSession') },
                                                               css: $data.minEditorPayPerSessionStateStatus"
                                                    type="text">
                                                <div class="option-dropdown" data-bind="css: {'is-hidden': $data.hideMinEditorPayPerSessionResetBtn()}">
                                                    <button class="btn-form option-dropdown-toggle icon i-refresh" type="button"></button>
                                                    <ul class="option-dropdown-list">
                                                        <li class="option-dropdown-item">
                                                            <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertMinEditorPayPerSession">Reset to Default</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <!-- Max field for Regular Session -->
                                            <div class="inside-label">
                                                <label for="" class="form-label">Max</label>
                                                <input class="input-text input-number"
                                                        data-bind="value: $data.maxEditorPayPerSession,
                                                                   valueUpdate: 'afterkeydown',
                                                                   event: { keyup: $parents[1].onChangeRateField.bind($data, 'maxEditorPayPerSession') },
                                                                   css: $data.maxEditorPayPerSessionStateStatus"
                                                        type="text">
                                                <div class="option-dropdown" data-bind="css: {'is-hidden': $data.hideMaxEditorPayPerSessionResetBtn()}">
                                                    <button class="btn-form option-dropdown-toggle icon i-refresh" type="button"></button>
                                                    <ul class="option-dropdown-list">
                                                        <li class="option-dropdown-item">
                                                            <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertMaxEditorPayPerSession">Reset to Default</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <!-- /ko -->
                                        </div>
                                    </td>
                                    <!--<td>
                                        <div class="w-rate-setting" data-bind="css: {'is-open': $data.editorPerformancePanelOpen(), 'disabledDiv':  !$data.editorArticleGroupDisabled() }">
                                            <div class="rate-setting">
                                                <div class="inside-label" style="position:relative;">
                                                    <label for="" class="form-label">Rate</label>
                                                    <input class="input-text input-number" data-bind="value: $data.editorArticlePerformance, valueUpdate: 'afterkeydown', event: { keyup: $parents[1].onChangeRateField.bind($data, 'editorArticlePerformance')}, css: $data.editorArticlePerformanceStateStatus" type="text" />
                                                </div>
                                                <button type="button" class="btn-form icon i-dropdown-simple" data-bind="event: {click: $parents[1].onToggleRatePanel.bind($data, 'editorArticlePerformance')}" ><span style="text-decoration: underline" data-bind="text: $data.optionsEditorPerformanceToggleText()"></span></button>
                                            </div>
                                            <div class="option-dropdown with-rate" style="display: block;" data-bind="css: {'is-hidden': $data.hideEditorArticlePerformanceResetBtn()}">
                                                <button class="btn-form option-dropdown-toggle icon i-kebab" type="button"></button>
                                                <ul class="option-dropdown-list">
                                                    <li class="option-dropdown-item">
                                                        <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertEditorArticlePerformance">Reset to Default</button>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="threshold">
                                                <div class="w-input">
                                                    <div class="inside-label" style="position:relative;"  data-bind="if: $data.editorMinRateFilledType() == 'custom' && $data.editorArticlePerformanceStateStatus() != 'default'">
                                                        <label for="" class="form-label tall">Min<br>Tresh</label>
                                                        <input class="input-text input-number" type="text"  data-bind="value: $data.minEditorArticlePerformance, enable: ($data.editorMinRateFilledType() == 'custom' && $data.editorArticlePerformanceStateStatus() != 'default')"/>
                                                        <div class="w-tooltips-adv pos-bottom short" style="position:absolute;top:-1.25rem;right:-.5rem;" data-bind="template: { name: 'infoButton-template', data: $data.editorMinPerformanceTooltip.getTemplateViewModel() }"></div>
                                                    </div>
                                                    <div class="option-dropdown" style="margin-right: 1rem" data-bind="if: $data.editorArticlePerformanceStateStatus() != 'default'">
                                                        <button class="btn-form option-dropdown-toggle icon i-kebab" type="button"></button>
                                                        <ul class="option-dropdown-list">
                                                            <li class="option-dropdown-item">
                                                                <button class="btn" data-bind="text:  ($data.editorMinRateFilledType() == 'auto') ? 'Set Threshold To Custom' : 'Set Threshold To Auto', event: {click: $parents[1].onChangeArticlePerformanceMinSource.bind($data, 'editorArticlePerformance')}" type="button">Set Threshold to Custom</button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="inside-label" style="position:relative;">
                                                        <label for="" class="form-label tall">Max<br>Pay</label>
                                                        <input class="input-text input-number" type="text" data-bind="value: $data.maxEditorArticlePerformance, enable: $data.editorArticlePerformanceStateStatus() != 'default'">
                                                        <div class="w-tooltips-adv pos-bottom short" style="position:absolute;top:-1.25rem;right:-.5rem;" data-bind="template: { name: 'infoButton-template', data: $data.maxPerformanceTooltip.getTemplateViewModel() }"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="w-rate-setting" data-bind="css: {'is-open': $data.editorArticleGroupPanelOpen()}">
                                            <div class="rate-setting">
                                                <div class="inside-label" style="position:relative;">
                                                    <label for="" class="form-label">Rate</label>
                                                    <input class="input-text input-number" data-bind="value: $data.editorArticleGroup, valueUpdate: 'afterkeydown', event: { keyup: $parents[1].onChangeRateField.bind($data, 'editorArticleGroup')}, css: $data.editorArticleGroupStateStatus" type="text" />
                                                </div>
                                                <button type="button" class="btn-form icon i-dropdown-simple" data-bind="event: {click: $parents[1].onToggleRatePanel.bind($data, 'editorArticleGroup')}" ><span style="text-decoration: underline" data-bind="text: $data.optionsEditorArticleGroupToggleText()"></span></button>
                                            </div>
                                            <div class="option-dropdown with-rate" style="display: block;" data-bind="css: {'is-hidden': $data.hideEditorArticleGroupResetBtn()}">
                                                <button class="btn-form option-dropdown-toggle icon i-kebab" type="button"></button>
                                                <ul class="option-dropdown-list">
                                                    <li class="option-dropdown-item">
                                                        <button class="btn" type="button" data-bind="click: $parents[1].onClickRevertEditorArticleGroup">Reset to Default</button>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="threshold">
                                                <div class="w-input">
                                                    <div class="inside-label" style="position:relative;">
                                                        <label for="" class="form-label tall">Min<br>Tresh</label>
                                                        <input class="input-text input-number" type="text"  data-bind="value: $data.minEditorArticleGroup, enable: ($data.editorMinRateFilledType() == 'custom')"/>
                                                        <div class="w-tooltips-adv pos-bottom short" style="position:absolute;top:-1rem;right:-.5rem;" data-bind="template: { name: 'infoButton-template', data: $data.editorMinArticleGroupTooltip.getTemplateViewModel() }"></div>
                                                    </div>
                                                    <div class="inside-label" style="position:relative;">
                                                        <label for="" class="form-label tall">Max<br>Pay</label>
                                                        <input class="input-text input-number" style="padding-right: 1.5rem!important" type="text" data-bind="value: $data.maxEditorArticleGroup">
                                                        <div class="w-tooltips-adv pos-bottom short" style="position:absolute;top:-1rem;right:-.5rem;" data-bind="template: { name: 'infoButton-template', data: $data.editorMaxArticleGroupTooltip.getTemplateViewModel() }"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>-->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="ww-form-body" data-bind="css: { 'is-showing': isShowUserInfosTab }">
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">personal info</strong>

                        <div class="form-group" data-bind="visible: permissions()['users_form_role'].write">
                            <legend class="form-legend">active</legend>
                            <div class="form-check-inline width-auto">
                                <input type="radio" name="isActive" id="active_yes" value="1" data-bind="checked: isActive, disable: disableActive" />
                                <label class="form-label" for="active_yes">Yes</label>
                            </div>
                            <div class="form-check-inline width-auto">
                                <input type="radio" name="isActive" id="active_no" value="0" data-bind="checked: isActive, disable: disableActive" />
                                <label class="form-label" for="active_no">No</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="fullName" class="form-label">Full Name</label>
                            <input id="fullName" data-bind="value: fullName" type="text" class="input-text">
                        </div>
                        <div class="form-group">
                            <label for="legalFullName" class="form-label">Full Legal Name</label>
                            <input id="legalFullName" data-bind="value: fullLegalName" type="text" class="input-text">
                        </div>
                        <div class="form-group">
                            <label for="email" class="form-label">Email</label>
                            <input id="email" data-bind="value: email, event: { blur: onBlurEmail }" type="email" class="input-text">
                        </div>
                         <div class="form-group">
                            <label for="address" class="form-label">Street Address</label>
                            <input id="address" data-bind="value: address" type="text" class="input-text">
                        </div>

                        <div class="form-group">
                            <label for="address2" class="form-label">Street Address Line 2</label>
                            <input id="address2" data-bind="value: addressLine2" type="text" class="input-text">
                        </div>

                        <div class="form-group">
                            <label for="city" class="form-label">City</label>
                            <input id="city" data-bind="value: city" type="text" class="input-text">
                        </div>

                        <div class="w-form-group-two">

                            ${ this.countryGroups.getHtmlBuild() }

                            <div class="form-group">
                                <label for="postalCode" class="form-label">Zip/Postal Code</label>
                                <input id="postalCode" data-bind="value: postalCode" type="text" class="input-text">
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="country" class="form-label">Country</label>
                            <select id="country-select" name="country" data-bind="
                                optionsCaption: 'Select',
                                options: countries,
                                optionsValue: 'id',
                                optionsText: 'name',
                                value: idCountry,
                                event: {change: onChangeCountry}
                                ">
                            </select>
                        </div>

                        <div data-bind="visible: permissions()['users_form_role'].write">
                            <strong class="form-sub-title">Roles</strong>
                            <div data-bind="foreach: groupedRoles">
                                <div class="form-group" style="margin: 0 2rem 0.5rem;border-bottom: 1px solid #efefef;padding-bottom: 0.5rem;" data-bind="foreach: roles">
                                    <div class="form-check-inline" data-bind="attr: { group: idgroup }">
                                        <input data-bind="value: id, checked: $parents[1].selectedRoles, attr:{id: 'role_' + id}, disable: disabled", type="checkbox">
                                        <label data-bind="text: name, attr:{for:'role_' + id}" class="form-label icon i-check"></label>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="form-body">

                        <!-- ko if: !hidePaymentSetting() -->
                            <strong class="form-sub-title">Payment Info</strong>

                             <!--
                            <div class="form-group">
                                <legend class="form-legend">active</legend>
                                <div class="form-check-inline width-auto">
                                    <input type="radio" id="test1" name="radio-group" checked>
                                    <label class="form-label" for="test1">PPP/PPV</label>
                                </div>
                                <div class="form-check-inline width-auto">
                                    <input type="radio" id="test2" name="radio-group" checked>
                                    <label class="form-label" for="test2">PPV</label>
                                </div>
                                <div class="form-check-inline width-auto">
                                    <input type="radio" id="test3" name="radio-group" checked>
                                    <label class="form-label" for="test3">PPP</label>
                                </div>
                            </div>
                             -->

                             <div class="w-form-group-two">

                                <div class="form-group row">
                                    <label for="paymentCurrency" class="form-label">Payment <br>Currency</label>
                                    <select id="paymentCurrency" data-bind="options: options_currencies, value: idCurrency, optionsText: 'currency', optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true, disable: disablePaymentSetting">
                                    </select>
                                </div>
                                <div class="form-group row">
                                    <label for="paymentFrequency" class="form-label">Payment Frequency</label>
                                    <select id="paymentFrequency" data-bind="options: options_frequencies, value: paymentFrequency, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true, disable: disablePaymentSetting">
                                    </select>
                                </div>
                                <div class="form-group row">
                                    <label for="paymentMethod" class="form-label">Payment Method</label>
                                    <select id="paymentMethod" data-bind="options: options_methods, value: idPaymentMethod, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true, disable:  disablePaymentSetting, event:{ change: onChangePaymentMethod}">
                                    </select>
                                </div>

                             <!-- ko if: isPaymentMethodId() -->
                                <div class="form-group extra-margin" data-bind="visible: isPayPalCheckboxVisible">
                                    <input id="same-email" data-bind="checked: isEmailSameAsPayPal" type="checkbox">
                                    <label for="same-email" data-bind="click: onClickSameEmail" class="form-label icon i-check">Is Payment Method ID same as email?</label>
                                </div>
                            <!-- /ko -->
                            </div>

                             <!-- ko if: isPaymentMethodId() -->
                                <div class="form-group">
                                    <label for="PaymentEmail" class="form-label">Payment Method ID</label>
                                    <input id="PaymentEmail" data-bind="value: emailPayment, disable: disablePaymentSetting" type="email" class="input-text">
                                </div>
                            <!-- /ko -->



                            <!-- ko if: isPaymentBank() -->

                            <div class="form-group">
                                <label for="bankName" class="form-label">Bank Name</label>
                                <input id="bankName" data-bind="value: bankName, disable: disablePaymentSetting" type="text" class="input-text">
                            </div>

                            <div class="form-group">
                                <label for="bankAddress" class="form-label">Bank Address</label>
                                <input id="bankAddress" data-bind="value: bankAddress, disable: disablePaymentSetting" type="text" class="input-text">
                            </div>

                            <div class="form-group" data-bind="visible: idPaymentMethod() == 4">
                                <label for="bankCity" class="form-label">Bank City</label>
                                <input id="bankCity" data-bind="value: bankCity, disable: disablePaymentSetting" type="text" class="input-text">
                            </div>

                            <div class="w-form-group-two" data-bind="visible: idPaymentMethod() == 4">

                                ${ this.bankCountryGroups.getHtmlBuild() }

                                <div class="form-group">
                                    <label for="bankPostalCode" class="form-label">Bank Zip/Postal Code</label>
                                    <input id="bankPostalCode" data-bind="value: bankPostalCode" type="text" class="input-text">
                                </div>
                            </div>

                            <div class="form-group row" data-bind="visible: idPaymentMethod() == 4">
                                <label for="bankCountry" class="form-label">Bank Country</label>
                                <select id="bankCountry" name="bankCountry" data-bind="
                                    options: bankCountries,
                                    optionsValue: 'id',
                                    optionsText: 'name',
                                    value: idBankCountry,
                                    disable: disablePaymentSetting,
                                    event: {change: onChangeBankCountry}
                                    ">
                                </select>
                            </div>

                            <div class="form-group">
                                <label for="bankAccountNumber" class="form-label">Bank Account Number</label>
                                <input id="bankAccountNumber" data-bind="value: bankAccountNumber, disable: disablePaymentSetting" type="text" class="input-text">
                            </div>

                            <div class="form-group" data-bind="visible: idPaymentMethod() == 2">
                                <label for="bankNumber" class="form-label">Bank ID/SWIFT/SORT Code</label>
                                <input id="bankNumber" data-bind="value: bankNumber, disable: disablePaymentSetting" type="text" class="input-text">
                            </div>

                            <div class="form-group" data-bind="visible: idPaymentMethod() == 2 || (idPaymentMethod() == 4 && idBankCountry() == 32)">
                                <label for="bankTransit" class="form-label">Bank Transit</label>
                                <input id="bankTransit" data-bind="value: bankTransit, disable: disablePaymentSetting" type="text" class="input-text">
                            </div>
                            <!-- For Canada Banks -->
                            <div class="form-group" data-bind="visible: idPaymentMethod() == 4 && idBankCountry() == 32">
                                <label for="bankInstitutionNumber" class="form-label">Bank Institution Number</label>
                                <input id="bankInstitutionNumber" data-bind="value: bankInstitutionNumber, disable: disablePaymentSetting" type="text" class="input-text">
                            </div>
                            <!-- For Canada -->

                            <!-- For US Banks -->
                            <div class="form-group" data-bind="visible: idPaymentMethod() == 4 && idBankCountry() == 197">
                                <label for="bankABARoutingNumber" class="form-label">ABA Routing Number</label>
                                <input id="bankABARoutingNumber" data-bind="value: bankABARoutingNumber, disable: disablePaymentSetting" type="text" class="input-text">
                            </div>
                            <!-- For US -->

                            <!-- /ko -->
                            <strong class="form-sub-title ">Payment Classification</strong>
                            <div class="form-group row">
                                <label for="paymentClassification" class="form-label">Payment Classification</label>
                                <select id="paymentClassification-select" name="paymentClassification" data-bind="
                                    optionsCaption: 'Select',
                                    options: paymentClassifications,
                                    optionsValue: 'id',
                                    optionsText: 'name',
                                    value: idPaymentClassification,
                                    enable: permissions()['users_form_payment_settings'].write,
                                    event:{ change : onChangePaymentClassification}
                                    ">
                                </select>
                            </div>

                            <div class="form-group row">
                                <label class="form-label">Effective Date</label>
                                ${ this.effectiveDatePicker.getHtmlBuild() }
                            </div>
                        <!-- /ko -->

                        <strong class="form-sub-title ">Account Settings</strong>

                        <div class="form-group">
                            <label class="form-label" for="profile-pic">Profile Picture</label>
                            <div id="dropzone">
                                <div id="my-drop-zone" class="dropzone needsclick dz-clickable"></div>
                                <input id="profile-pic" data-bind="value: pictureUrl" type="hidden">
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="loginName" class="form-label">User Name</label>
                            <input id="loginName" data-bind="value: loginName" type="text" class="input-text">
                        </div>


                        <!-- ko if: idUser() -->
                         <div class="form-group extra-margin" data-bind="visible: permissions()['users_form_password_update'].write || (idUser() == loggedUserId() )">
                            <input id="change-password" type="checkbox" class="input-text" data-bind="checked: isChangingPassword">
                            <label for="change-password" class="form-label icon i-check">Change Emaki Password?</label>
                        </div>
                        <!-- /ko -->

                        <div class="form-group-password" id="form-group-password" data-bind="css: { 'is-open': !idUser()}">
                            <div class="form-group">
                                <label for="" class="form-label">Password</label>
                                <input id="password" data-bind="value: password" type="password" class="input-pass">
                            </div>
                            <div class="form-group">
                                <label for="passwordConfirmation" class="form-label">New Password Confirmation</label>
                                <input id="passwordConfirmation" data-bind="value: passwordConfirmation" type="password" class="input-pass">
                            </div>
                            <div class="form-group">
                                <label for="oldPassword" class="form-label">Password of Logged User</label><br />
                                <span>Enter your OLD password here, INCASE you are changing to a new password</span>
                                <input id="oldPassword" data-bind="value: oldPassword" type="password" class="input-pass">
                            </div>

                        </div>

                        <div class="form-group">
                            <label for="2FA-select" class="form-label width-tooltip">
                                Two-Factor Authentication
                                <div class="w-tooltips-adv pos-top short">
                                  ${ this.twoFactorAuthenticationTooltip.getHtmlBuild() }
                                </div>
                            </label>
                            <select id="2FA-select" name="2FA" class="form-control" data-bind="value: twoFactorMethod">
                                <option value="disabled" data-bind="attr: { disabled: !permissions()['users_form_admin'].write }">Disabled</option>
                                <option value="email">Enabled via Email</option>
                            </select>
                        </div>

                         <div class="form-group">
                            <label class="form-label width-tooltip">
                                Spell Checker
                                <div class="w-tooltips-adv pos-top short">
                                  ${ this.SpellcheckTooltip.getHtmlBuild() }
                                </div>
                            </label>
                            <div class="form-check-inline width-auto">
                                <input type="radio" name="spellcheckActive" id="spellcheck_yes" value="1" data-bind="checked: spellcheck, event: { change: onClickShowRefreshMessage }"/>
                                <label class="form-label" for="spellcheck_yes">On</label>
                            </div>
                            <div class="form-check-inline width-auto">
                                <input type="radio" name="spellcheckActive" id="spellcheck_no" value="0" data-bind="checked: spellcheck, event: { change: onClickShowRefreshMessage }" />
                                <label class="form-label" for="spellcheck_no">Off</label>
                            </div>

                        </div>

                        <div data-bind="visible: permissions()['users_form_brand'].write">
                            <strong class="form-sub-title">Company</strong>
                            <div class="form-group row">
                                <label for="company" class="form-label">Company</label>
                                <select id="company-select" name="company" data-bind="
                                    optionsCaption: 'Select',
                                    options: companies,
                                    optionsValue: 'id',
                                    optionsText: 'name',
                                    value: idCompany,
                                    enable: permissions()['users_form_payment_settings'].write,
                                    event:{ change: onChangeCompany}
                                    ">
                                </select>
                            </div>

                            <strong class="form-sub-title">Brands</strong>
                            <div  class="form-group">
                                <legend class="form-legend"></legend>
                                <div data-bind="foreach: groupedBrands">
                                    <div class="form-group" style="margin: 0 2rem 0.5rem;border-bottom: 1px solid #efefef;padding-bottom: 0.5rem;" data-bind="foreach: brands">
                                        <div class="form-check-inline" data-bind="attr: { group: idCategory }">
                                            <input data-bind="value: id, checked: $parents[1].selectedBrands, attr:{id: 'brand_' + id}" type="checkbox">
                                            <label class="form-label icon i-check" data-bind="click: $parents[1].onClickBrand, text: name, attr:{for: 'brand_' + id}"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="ww-form-body author-details"  data-bind="css: { 'is-showing': isShowAuthorDetailsTab }">
                <strong class="form-sub-title parent" style="margin-bottom: 0">Network</strong>

                <div class="w-form-body author-social">

                    <div class="form-body">
                        <strong class="form-sub-title">Social Media</strong>

                        <div class="sub-header w-justify">
                            ${ this.socialMediaFilter.getHtmlBuild() }
                        </div>

                        <div id="selected-socialMedias" style="display: none"></div>

                        <div class="w-form-group-two">

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('facebook') > -1">
                                <label for="" class="form-label icon i-facebook">Facebook</label>
                                <input id=""  type="url" class="input-text" data-bind="value: facebook">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('instagram') > -1">
                                <label for="" class="form-label icon i-insta">Instagram</label>
                                <input id=""  type="url" class="input-text" data-bind="value: instagram">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('twitter') > -1">
                                <label for="" class="form-label icon i-twitter"></label>
                                <input id=""  type="url" class="input-text" data-bind="value: twitter">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('linkedIn') > -1">
                                <label for="" class="form-label icon i-linkedin">LinkedIn</label>
                                <input id=""  type="url" class="input-text" data-bind="value: linkedIn">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('tiktok') > -1">
                                <label for="" class="form-label icon i-tiktok">Tiktok</label>
                                <input id=""  type="url" class="input-text" data-bind="value: tiktok">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('weChat') > -1">
                                <label for="" class="form-label icon i-wechat">WeChat</label>
                                <input id=""  type="url" class="input-text" data-bind="value: weChat">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('youtube') > -1">
                                <label for="" class="form-label icon i-youtube">YouTube</label>
                                <input id=""  type="url" class="input-text" data-bind="value: youtube">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('twitch') > -1">
                                <label for="" class="form-label icon i-twitch">Twitch</label>
                                <input id=""  type="url" class="input-text" data-bind="value: twitch">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('discord') > -1">
                                <label for="" class="form-label icon i-discord">Discord</label>
                                <input id=""  type="url" class="input-text" data-bind="value: discord">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('pinterest') > -1">
                                <label for="" class="form-label icon i-pinterest">Pinterest</label>
                                <input id=""  type="url" class="input-text" data-bind="value: pinterest">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('whatsApp') > -1">
                                <label for="" class="form-label icon i-whatsapp">WhatsApp</label>
                                <input id=""  type="url" class="input-text" data-bind="value: whatsApp">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('reddit') > -1">
                                <label for="" class="form-label icon i-reddit">Reddit</label>
                                <input id=""  type="url" class="input-text" data-bind="value: reddit">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('snapchat') > -1">
                                <label for="" class="form-label icon i-snapchat">Snapchat</label>
                                <input id=""  type="url" class="input-text" data-bind="value: snapchat">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('substack') > -1">
                                <label for="" class="form-label icon i-substack">Substack</label>
                                <input id=""  type="url" class="input-text" data-bind="value: substack">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('medium') > -1">
                                <label for="" class="form-label icon i-medium">Medium</label>
                                <input id=""  type="url" class="input-text" data-bind="value: medium">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('tumblr') > -1">
                                <label for="" class="form-label icon i-tumblr">Tumblr</label>
                                <input id=""  type="url" class="input-text" data-bind="value: tumblr">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('signalSocial') > -1">
                                <label for="" class="form-label icon i-signal">Signal</label>
                                <input id=""  type="url" class="input-text" data-bind="value: signalSocial">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('telegram') > -1">
                                <label for="" class="form-label icon i-telegram">Telegram</label>
                                <input id=""  type="url" class="input-text" data-bind="value: telegram">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('muckrack') > -1">
                                <label for="" class="form-label icon i-muckrack">Muck Rack</label>
                                <input id=""  type="url" class="input-text" data-bind="value: muckrack">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('openCritic') > -1">
                                <label for="" class="form-label icon i-opencritic">OpenCritic</label>
                                <input id=""  type="url" class="input-text" data-bind="value: openCritic">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('mastodon') > -1">
                                <label for="" class="form-label icon i-mastodon">Mastodon</label>
                                <input id=""  type="url" class="input-text" data-bind="value: mastodon">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('threads') > -1">
                                <label for="" class="form-label icon i-threads">Threads</label>
                                <input id=""  type="url" class="input-text" data-bind="value: threads">
                            </div>

                            <div class="form-group" data-bind="visible: socialMedia.indexOf('sm_email') > -1">
                                <label for="" class="form-label icon i-mail">Email</label>
                                <input id=""  type="email" class="input-text" data-bind="value: sm_email">
                            </div>

                            <div class="form-group websites" data-bind="visible: socialMedia.indexOf('websites') > -1">
                                <label for="" class="form-label icon i-website">Website</label>
                                <input id=""  type="url" class="input-text" data-bind="value: website">
                                <input id=""  type="url" class="input-text" data-bind="value: website2, visible: isWebsite2Visible">
                                <input id=""  type="url" class="input-text" data-bind="value: website3, visible: isWebsite3Visible">
                                <button data-bind="event: {click: addSite}, visible: isAddSiteVisible" class="btn highlight">ADD SITE</button>
                                <button data-bind="event: {click: removeSite}, visible: isRemoveSiteVisible" class="btn">REMOVE SITE</button>
                            </div>
                        </div>

                    </div>

                </div>
                <strong class="form-sub-title parent" style="margin-bottom: 0">Brand Specific</strong>
                <div class="w-form-body author-info" data-bind="foreach: brandInfo">

                    <div class="form-body full-width">
                        <strong class="form-sub-title dark" data-bind="text: $data.brand.name, css: $data.brand.iconImage"></strong>

                            <div class="form-group flex">
                                <div class="flex-item">

                                    <!-- ko if: $parent.permissions()['users_form_author_active_indexed_slug'].write -->

                                        <div class="form-group row absolute">
                                            <div>
                                                <input type="checkbox" class="input-text" data-bind="checked: $data.isAuthorDetailActive, click: $parent.onClickInitBrandCKE($data), enable: ($data.id == null), attr: {id: 'isAuthorDetailActive' + $index()}">
                                                <label for="isAuthorDetailActive" class="form-label icon i-check" data-bind="attr: {for: 'isAuthorDetailActive' + $index()}">Active</label>
                                            </div>
                                            <div  data-bind="visible: $data.isAuthorDetailActive">
                                                <input type="checkbox" class="input-text" data-bind="checked: isIndex, attr: {id: 'indexed' + $index()}">
                                                <label for="indexed" class="form-label icon i-check" data-bind="attr: {for: 'indexed' + $index()}">indexed</label>
                                            </div>
                                        </div>
                                    <!-- /ko -->


                                    <div class="form-group" data-bind="visible: $data.isAuthorDetailActive">
                                        <label class="form-label" for="">Display Name</label>
                                        <input class="input-text" type="text" data-bind="value: $data.displayName">
                                    </div>


                                    <!-- ko if: $parent.permissions()['users_form_author_active_indexed_slug'].write -->

                                        <div class="form-group" data-bind="visible: $data.isAuthorDetailActive">
                                            <label class="form-label width-tooltip" for="">Slug
                                                <div class="w-tooltips-adv pos-far-right short" data-bind="template: { name: 'infoButton-template', data: $data.userSlugToolTip.getTemplateViewModel() }"></div>
                                            </label>
                                            <input class="input-text" type="text" data-bind="value: $data.niceName">
                                        </div>
                                    <!-- /ko -->

                                    <div class="form-group" data-bind="visible: $data.isAuthorDetailActive">
                                        <label class="form-label" for="profile-pic_2">Profile Picture</label>
                                        <div id="dropzone_2">
                                            <div class="dropzone needsclick dz-clickable" data-bind="attr: {id: 'drop-zone' + $data.brand.id}"></div>
                                            <input type="hidden" data-bind="attr: {id: 'profile-pic' + $data.brand.id}">
                                        </div>
                                    </div>

                                    <div class="form-group" data-bind="visible: $data.isAuthorDetailActive">
                                        <label class="form-label" for="profile-banner">Profile Banner</label>
                                        <div id="dropzone_3">
                                            <div class="dropzone needsclick dz-clickable" data-bind="attr: {id: 'drop-zone-banner' + $data.brand.id}"></div>
                                            <input type="hidden" data-bind="attr: {id: 'profile-banner' + $data.brand.id}">
                                        </div>
                                    </div>

                                    <div class="form-group" data-bind="visible: $data.isAuthorDetailActive">
                                        <label class="form-label" for="">Job Title</label>
                                        <!-- ko if: $parent.permissions()['users_form_author_job_title'].write -->
                                            <input class="input-text" type="text" data-bind="value: $data.jobTitle, attr: { id: 'jobTitleInput-' + $data.brand.id }">
                                            <!-- ko if: $data.brandJobTitleList && $data.brandJobTitleList.length > 0 -->
                                                <select data-bind="attr: { id: 'jobTitleSelect-' + $data.brand.id }, visible: $data.brandJobTitleList.length > 0, options: $data.brandJobTitleList, optionsCaption: 'Select a job title', valueAllowUnset: true, event: { change: $parent.handleJobTitleChange($data.brand.id) }">
                                                </select>
                                            <!-- /ko -->
                                            <!-- /ko -->
                                        <!-- ko if: !$parent.permissions()['users_form_author_job_title'].write -->
                                            <!-- ko if: $data.brandJobTitleList && $data.brandJobTitleList.length > 0 -->
                                                <select id="jobTitleSelect" data-bind="visible: $data.brandJobTitleList.length > 0, options: $data.brandJobTitleList, value: $data.jobTitle, optionsCaption: 'Select a job title', valueAllowUnset: true">
                                                </select>
                                            <!-- /ko -->
                                        <!-- /ko -->
                                    </div>
                                    <div class="form-group" data-bind="visible: $data.isAuthorDetailActive">
                                        <label class="form-label" for="">Qualifications</label>
                                        <label style="display: block" class="form-label" for="">
                                            <sub>150 Characters Max.</sub>
                                        </label>
                                        <input class="input-text" maxlength="150" type="text" data-bind="value: $data.qualification">
                                        <small class="form-error"></small>
                                    </div>

                                    <!-- ko if: $data.topicExpertise -->
                                     <div class="form-group" data-bind="visible: $data.isAuthorDetailActive">
                                        <!-- ko if: $data.userTopicExpertiseToolTip -->
                                        <label class="form-label width-tooltip" for="">Topic Expertise
                                            <div class="w-tooltips-adv pos-far-right short" data-bind="template: { name: 'infoButton-template', data: $data.userTopicExpertiseToolTip.getTemplateViewModel() }"></div>
                                        </label>
                                        <!-- /ko -->

                                        <div data-bind="template: { name: 'filterAutocomplete_template', data: $data.topicExpertise.getTemplateViewModel() }"></div>

                                        <div class="form-group" data-bind="foreach: $data.topicExpertiseList" style="margin-top: -2rem">
                                            <div class="btn-selection">
                                                <span data-bind="text: name"></span>
                                                <button class="icon i-x-after" type="button" data-bind="click: function() { $parents[1].onClickRemoveTopicExpertise($data, $parent); }"></button>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /ko -->


                                    <!-- ko if: $data.startDatePicker -->
                                        <div class="form-group" data-bind="visible: $data.isAuthorDetailActive">
                                            <label class="form-label">Start Date</label>
                                            <div data-bind="template: { name: 'filterSingleDate_template', data: $data.startDatePicker.getTemplateViewModel() }"></div>
                                        </div>
                                    <!-- /ko -->


                                </div>
                                <div class="flex-item">
                                    <div class="w-form-group-two">
                                        <div class="form-group margin-bottom" data-bind="visible: $data.isAuthorDetailActive">
                                          <label class="form-label" for="">About You</label>
                                          <label class="form-label" for=""><sub>A third-person description of who you are and why people should trust you.</sub></label>
                                          <textarea data-bind="value: $data.bio, attr: {id: 'bio-' + $data.brand.id}"></textarea>
                                        </div>

                                        <div class="form-group" data-bind="visible: $data.isAuthorDetailActive">
                                            <label class="form-label" for="">SEO Bio</label>
                                            <label style="display: block" class="form-label" for="">
                                                <sub>Seo-focused Third-person Description Of Who You Are And Why People Should Trust You. 150 Characters Max.</sub>
                                            </label>
                                            <textarea
                                                style="height: 21.125rem;"
                                                class="input-text"
                                                maxlength="150"
                                                data-bind="value: $data.seoBio, attr: {id: 'seoBio-' + $data.brand.id}">
                                            </textarea>
                                       </div>

                                        <div class="form-group" data-bind="visible: $data.isAuthorDetailActive">
                                            <label class="form-label  width-tooltip" for="">
                                                Author Tone
                                                 <div class="w-tooltips-adv pos-far-right short" data-bind="template: { name: 'infoButton-template', data: $data.authorToneToolTip.getTemplateViewModel() }"></div>
                                            </label>

                                            <label style="display: block" class="form-label" for="">

                                                <sub>Describe your personal writing style. Used internally to help the assistant match your tone.</sub>

                                            </label>
                                            <textarea
                                                style="height: 21.125rem;"
                                                class="input-text"
                                                data-bind="value: $data.authorTone, attr: {id: 'authorTone-' + $data.brand.id}"
                                                placeholder="">
                                            </textarea>
                                       </div>


                                        <!-- ko if: $parent.additionalAuthorInfo()[$data.brand.id] -->
                                            <!-- ko if: $parent.additionalAuthorInfo()[$data.brand.id][0] -->
                                                <div class="form-group margin-bottom" data-bind="visible: $data.isAuthorDetailActive">
                                                    <label for="authorQuestion" class="form-label">Select Question</label>
                                                    <select data-bind="attr: {id: 'authorQuestion-1-' + $data.brand.id}, value: $data.authorQuestion1, foreach: $parent.additionalAuthorInfo()[$data.brand.id], optionsCaption: 'Select', valueAllowUnset: true">
                                                        <option data-bind="attr: { disabled: ($parent.authorQuestion2 == name || $parent.authorQuestion3 == name), value: name}, text: name"></option>
                                                    </select>
                                                  <textarea data-bind="value: $data.authorInfo1, attr: {id: 'authorInfo-1-' + $data.brand.id}"></textarea>
                                                </div>
                                            <!-- /ko -->
                                            <!-- ko if: $parent.additionalAuthorInfo()[$data.brand.id][1] -->
                                                <div class="form-group margin-bottom" data-bind="visible: $data.isAuthorDetailActive">
                                                    <label for="authorQuestion" class="form-label">Select Question</label>
                                                    <select data-bind="attr: {id: 'authorQuestion-2-' + $data.brand.id}, value: $data.authorQuestion2, foreach: $parent.additionalAuthorInfo()[$data.brand.id], optionsCaption: 'Select', valueAllowUnset: true">
                                                        <option data-bind="attr: { disabled: ($parent.authorQuestion1 == name || $parent.authorQuestion3 == name), value: name}, text: name"></option>
                                                    </select>
                                                  <textarea data-bind="value: $data.authorInfo2, attr: {id: 'authorInfo-2-' + $data.brand.id}"></textarea>
                                                </div>
                                            <!-- /ko -->
                                            <!-- ko if: $parent.additionalAuthorInfo()[$data.brand.id][2] -->
                                                <div class="form-group margin-bottom" data-bind="visible: $data.isAuthorDetailActive">
                                                    <label for="authorQuestion" class="form-label">Select Question</label>
                                                    <select data-bind="attr: {id: 'authorQuestion-3-' + $data.brand.id}, value: $data.authorQuestion3, foreach: $parent.additionalAuthorInfo()[$data.brand.id], optionsCaption: 'Select', valueAllowUnset: true">
                                                        <option data-bind="attr: { disabled: ($parent.authorQuestion1 == name || $parent.authorQuestion2 == name), value: name}, text: name"></option>
                                                    </select>
                                              <textarea data-bind="value: $data.authorInfo3, attr: {id: 'authorInfo-3-' + $data.brand.id}"></textarea>
                                            </div>
                                            <!-- /ko -->
                                        <!-- /ko -->
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>

            <div class="ww-form-body author-details"  data-bind="css: { 'is-showing': isShowPinnedArticlesTab }">

                <div class="w-form-body">
                    <div class="form-body no-border">
                        <div class="form-group">
                            <label for="brandInfoBrandSelector" class="form-label">Select Brand</label>
                            <select style="display: block;width: 48%;" id="brandInfoBrandSelector" data-bind="options: brandInfo().filter(function(item){return item.isAuthorDetailActive();}), optionsText: function(item) { return item.brand.name; }, optionsValue: function(item) { return item; }, value: selectedBrandInfo, event: { change: onChangeSelectedBrandInfo }"></select>
                            <!-- ko if: brandInfo().filter((item) => item.isAuthorDetailActive()).length == 0 -->
                            <em>Activate a brand on the Author Details tab to enable selection.</em>
                            <!-- /ko -->
                        </div>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title pinned-articles">Pinned Articles</strong>
                        <div class="form-group">
                           <div class="w-pinned">
                            <div class="pinned-form">
                                <label for="articleFilter" class="form-label">Pinned Articles</label>
                                ${this.articleFilter.getHtmlBuild()}
                                <div style="display:flex;justify-content: flex-end;">
                                    <button class="btn secondary" type="button" data-bind="event:{click: onClickAddPinnedArticle }, text: 'Add Pinned Article', disable: brandInfo().filter((item) => item.isAuthorDetailActive()).length == 0"></button>
                                </div>
                            </div>
                            <!-- ko if: selectedBrandInfo -->
                                <div class="form-body no-border" data-bind="foreach: selectedBrandInfo().pinnedArticles">
                                    <div class="pinned-form article-pinned entry">
                                        <div class="w-btn">
                                            <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDelete }"><span class="hidden-text">Delete</span></button>
                                        </div>
                                        <div class="w-title">
                                            <div>
                                                <span class="pinned-info">ID :<span data-bind="text: $data.id"></span></span>
                                                <span class="pinned-info">Last Published :<span data-bind="text: $data.dateLastPublishStatus"></span></span>
                                            </div>
                                            <span class="pinned-title" data-bind="text: $data.title"></span>
                                        </div>
                                    </div>
                                </div>
                                <!-- /ko -->
                           </div>
                        </div>
                    </div>
                    <div class="form-body">
                        <strong class="form-sub-title pinned-articles">Embeds</strong>
                            <div class="form-group">
                                <div class="form-body embed no-padding">
                                    <div class="form-group">
                                        <label for="onClickOpenEmbeds" class="form-label">Pinned Embeds</label>

                                        <div style="display:flex;">
                                            <button class="btn secondary" type="button" data-bind="event:{click: onClickOpenEmbeds }, text: 'Add Pinned Embed', disable: brandInfo().filter((item) => item.isAuthorDetailActive()).length == 0"></button>
                                        </div>
                                    </div>
                                    <div class="form-group" style="margin-bottom: 0;">
                                        <!-- ko if: selectedBrandInfo -->
                                            <div  data-bind="foreach: selectedBrandInfo().embeds">
                                                <div class="form-embed">
                                                    <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickRemoveEmbed }"><span class="hidden-text">Delete</span></button>
                                                    <span class="pinned-title" data-bind="html: $data"></span>
                                                </div>
                                            </div>
                                        <!-- /ko -->
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>

            <!-- <div class="ww-form-body" data-bind="css: { 'is-showing': isShowUserPreferencesTab }">

                <div class="form-body">

                    <strong class="form-sub-title">User Preferences</strong>

                    <legend class="form-legend">Spell Checker</legend>
                    <div class="form-check-inline width-auto">
                        <input type="radio" name="spellcheckActive" id="spellcheck_yes" value="1" data-bind="checked: spellcheck" />
                        <label class="form-label" for="spellcheck_yes">On</label>
                    </div>
                    <div class="form-check-inline width-auto">
                        <input type="radio" name="spellcheckActive" id="spellcheck_no" value="0" data-bind="checked: spellcheck" />
                        <label class="form-label" for="spellcheck_no">Off</label>
                </div>

                    <br><br>
                    <span class="tooltips bottom">Please refresh the page after saving for the changes to take effect.</span>

                </div>

            </div> -->

            <div class="form-footer">
                <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save User</button>
            </div>

            <div id="refreshMessage" class="w-lightbox light-theme">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Attention</h3>
                            <button type="button"  data-bind="event: { click: onClickShowRefreshMessage }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">Please refresh the page after saving for the changes to the Spell Checker to take effect. </p>
                            </div>
                         </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickShowRefreshMessage }" class="btn border only-icon icon">OK</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="negative-rate-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title" data-bind="text: paymentRateError().brand"></h3>
                            <button type="button"  data-bind="event: { click: onClickHidePopUp.bind('negative-rate-dialog') }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group" data-bind="foreach: paymentRateError().messages">
                                <p class="form-text" data-bind="text: $data"></p>
                            </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp.bind('negative-rate-dialog') }" class="btn border only-icon icon">OK</button>
                        </div>
                    </div>
                </div>
            </div>
            </div>

            <div id="classification-change-dialog"  class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Confirm User Classfication Change</h3>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text" data-bind="text: classificationChangeMessage"></p>
                            </div>
                         </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickConfirmClassificationChange}" class="btn highlight">Confirm</button>
                            <button type="button" data-bind="event: { click: onClickCancelClassificationChange}" class="btn ">Cancel</button>
                        </div>
                    </div>

                </div>
            </div>

            <div id="offboarding-dialog"  class="w-lightbox light-theme rejection-pop-up">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Confirm Brand Update</h3>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <h3 class="form-text"> <span data-bind="html: offboardingMessage"></span></h2>
                            </div>
                            <div class="offboarding-form">
                                <div class="form-group row header">
                                    <div class="form-label">
                                        <label>Brand</label>
                                    </div>
                                    <div class="form-label">
                                        <label>Is this an offboarding?</label>
                                    </div>
                                    <div class="form-label">
                                        <label>Reason for offboarding?</label>
                                    </div>
                                </div>
                                <div data-bind="foreach: offboardingData">
                                    <div class="form-group row top">
                                        <div class="form-check-inline" style="display:inline-flex">
                                            <span class="dark full-icon" data-bind="css: iconImage"></span>
                                            <div class="form-check-inline width-auto">
                                                <input data-bind="checked: isOffboarding, attr: {id: 'offboarding_yes_' + idBrand, name: 'offboarding_' + idBrand}" type="radio" value="1">
                                                <label class="form-label" data-bind="attr: {for: 'offboarding_yes_' + idBrand}">yes</label>
                                            </div>
                                            <div class="form-check-inline width-auto">
                                                <input data-bind="checked: isOffboarding, attr: {id: 'offboarding_no_' + idBrand, name: 'offboarding_' + idBrand}" type="radio" value="0">
                                                <label class="form-label icon i-check" data-bind="attr: {for: 'offboarding_no_' + idBrand}">No</label>
                                            </div>
                                        </div>
                                        <div class="d-flex">
                                            <div class="form-label disabled" style="position:relative" data-bind="css: { 'active': isOffboarding() != 0 }, event: { change: function(){ if(isOffboarding() == 0){ reason(0); } } }">
                                                <label>
                                                    <select data-bind="css: reasonColor , value: reason, options: $parent.offboardingReasons, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select'"></select>
                                                </label>
                                                <span class="error" data-bind="text: warning"></span>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickConfirmOffboardingDialog}" class="btn highlight">Confirm</button>
                            <button type="button" data-bind="event: { click: onClickCancelOffboardingDialog}" class="btn ">Cancel</button>
                        </div>
                    </div>

                </div>
            </div>
            `;
    }

    protected initPartial(): void {
        this.embedHelper = new EmbedHelper(this.caller);

        this.SpellcheckTooltipContent = `
        <p>
        Turning off this setting will prevent the integrated spell checker from ever loading in the Article Edit interface or any other rich text editors in Emaki.
        </p>
        `

        this.SpellcheckTooltip = new infoButton_template('spellcheckTooltip', this.getTemplateViewModel(), this.caller)
        this.SpellcheckTooltip.setTitle('Spellcheck');
        this.SpellcheckTooltip.setContent(this.SpellcheckTooltipContent);

        this.twoFactorAuthenticationTooltipContent = `
        <p>
        If 2FA is enabled, the additional configured authentication method will be prompted if the user’s device, browser, user agent, location, or connection are different from their previous login attempts in the last 30 days or if a login with 2FA has not occurred in the last 30 days.
        </p>
        `;

        this.twoFactorAuthenticationTooltip = new infoButton_template('twoFactorAuthenticationTooltip', this.getTemplateViewModel(), this.caller)
        this.twoFactorAuthenticationTooltip.setTitle('Two-Factor Authentication');
        this.twoFactorAuthenticationTooltip.setContent(this.twoFactorAuthenticationTooltipContent);

        this.socialMediaFilter = new multipleSelector_template("socialMediaFilter", this.getTemplateViewModel(), this.caller);
        this.socialMediaFilter.setLabel("Social Media");
        this.socialMediaFilter.setFilterContainerClass('margin-neg');
        this.socialMediaFilter.setTagContainerId('selected-socialMedias');
        this.socialMediaFilter.setTagContainerCaption('Selected Social Medias:');

        this.effectiveDatePicker = new filterSingleDate_template("effectiveDatePicker", this.getTemplateViewModel(), this);
        this.effectiveDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());

        this.articleFilter =  new filterArticle_template('articleFilter', this.getTemplateViewModel(), this.caller);
        this.articleFilter.setShowDetails(true);
        this.articleFilter.setIsLoadingAnimationEnable(true);

        this.embedder = new embedder_template("embedder", this.getTemplateViewModel(), this.caller);
        this.embedder.getTemplateViewModel().embedType_options(this.getEmbedType_options());
        this.embedHelper.setEmbedType_options(this.getEmbedType_options());

        this.countryGroups = new countryStates_template('countryGroups', this.getTemplateViewModel(), this.caller);

        this.bankCountryGroups = new countryStates_template('bankCountryGroups', this.getTemplateViewModel(), this.caller);
        this.bankCountryGroups.setLabel('Bank State/Province/Region');
    }

    protected getEmbedType_options(): Array<embedType>
    {
        return [
            {'name': 'Facebook', 'type': 'embed_facebook'},
            {'name': 'Instagram', 'type': 'embed_instagram'},
            {'name': 'LinkedIn', 'type': 'embed_linkedin'},
            {'name': 'Bluesky', 'type': 'embed_bluesky'},
            {'name': 'Tiktok', 'type': 'embed_tiktok'},
            {'name': 'Twitter', 'type': 'embed_twitter'}
        ]
    }

    protected getTemplateName(): string {

        return "usersEdit-form-template";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form", "w-form-large"];
    }

    protected buildViewModel(): any {

        let self = this;
        let viewModel = {
            idUser: ko.observable(""),
            loggedUserId: ko.observable(""),
            permissions: ko.observableArray(this.initPermissions(['users_form_brand', 'users_form_rates', 'users_form_role', 'users_form_currency', 'users_form_admin', 'users_form_website_manager', 'users_form_password_update', 'users_form_author_active_indexed_slug', 'user_payment_frequency', 'users_form_payment_settings', 'users_form_general_manager'])),
            fullName: ko.observable(""),
            fullLegalName: ko.observable(""),
            affiliateBrands: ko.observableArray([42,41,29,20,21,23,27,28,31,6,4]),
            loginName: ko.observable(""),
            email: ko.observable(""),
            pictureUrl: ko.observable(null),
            password: ko.observable(""),
            roles: ko.observableArray([]),
            groupedRoles: ko.observableArray([]),
            brands: ko.observableArray([]),
            groupedBrands: ko.observableArray([]),
            allBrands: ko.observableArray([]),
            countries: ko.observableArray([]),
            provinces: ko.observableArray([]),
            taxCodes: ko.observableArray([]),
            taxNumbers: ko.observableArray([]),
            otherCountries: ko.observableArray([]),
            otherCountriesDataList: ko.observableArray([]),
            idCountry: ko.observable(),
            idProvince: ko.observable(),
            otherCountryName: ko.observable(""),
            idOtherCountry: ko.observable(),
            selectedRoles: ko.observableArray([]),
            selectedBrands: ko.observableArray([]),
            initialSelectedBrands: ko.observableArray([]),
            offboardingData: ko.observableArray([]),
            offboardingReasons: ko.observableArray([]),
            offboardingMessage: ko.observable(''),
            emailPayment: ko.observable(""),
            passwordConfirmation: ko.observable(""),
            oldPassword: ko.observable(""),
            options_currencies: ko.observableArray([]),
            allCurrencies: ko.observableArray([]),
            options_methods: ko.observableArray([]),
            options_frequencies: ko.observableArray([]),
            idCurrency: ko.observable(),
            isActive: ko.observable("1"),
            spellcheck: ko.observable("1"),
            spellcheckChanged: ko.observable("1"),
            paymentName: ko.observable(""),
            paymentAddress: ko.observable(""),
            bankAddress: ko.observable(""),
            bankCity: ko.observable(""),
            bankPostalCode: ko.observable(""),
            bankAccountNumber: ko.observable(""),
            bankInstitutionNumber : ko.observable(""),
            bankABARoutingNumber : ko.observable(""),
            bankNumber: ko.observable(""),
            bankName: ko.observable(""),
            bankTransit: ko.observable(""),
            bankCountries: ko.observableArray([]),
            idBankCountry: ko.observable(),
            paymentClassifications: ko.observableArray([]),
            idPaymentClassification: ko.observable(),
            idPaymentClassificationChanged: ko.observable(false),
            address: ko.observable(""),
            addressLine2: ko.observable(""),
            city: ko.observable(""),
            postalCode: ko.observable(""),
            instagram: ko.observable(""),
            twitter: ko.observable(""),
            facebook: ko.observable(""),
            website: ko.observable(""),
            website2: ko.observable(""),
            website3: ko.observable(""),
            linkedIn: ko.observable(""),
            tiktok: ko.observable(""),
            muckrack: ko.observable(""),
            openCritic: ko.observable(""),
            mastodon: ko.observable(""),
            threads: ko.observable(""),
            weChat: ko.observable(""),
            youtube: ko.observable(""),
            twitch: ko.observable(""),
            discord: ko.observable(""),
            pinterest: ko.observable(""),
            whatsApp: ko.observable(""),
            reddit: ko.observable(""),
            snapchat: ko.observable(""),
            substack: ko.observable(""),
            medium: ko.observable(""),
            tumblr: ko.observable(""),
            signalSocial: ko.observable(""),
            telegram: ko.observable(""),
            sm_email: ko.observable(""),
            showRefresh: ko.observable(0),
            idPaymentMethod: ko.observable(),
            paymentFrequency: ko.observable(),
            paymentRateError:ko.observable({}),
            userRates: ko.observableArray([]),
            allUserRates: ko.observableArray([]),
            disablePaymentSetting: ko.observable(true),
            hidePaymentSetting: ko.observable(true),
            disableActive: ko.observable(true),
            isCountryDisabled: ko.observable(false),
            isClassificationConfirmVisible: ko.observable(false),
            classificationChangeMessage: ko.observable(''),
            isClassificationConfirmed: ko.observable(false),
            isClassificationChanged: ko.observable(false),
            isEmailSameAsPayPal: ko.observable(false),
            isPayPalCheckboxVisible: ko.observable(true),
            isShowUserRatesTab: ko.observable(false),
            isShowAuthorDetailsTab: ko.observable(false),
            isShowPinnedArticlesTab: ko.observable(false),
            //isShowUserPreferencesTab: ko.observable(false),
            isShowUserInfosTab: ko.observable(true),
            isPaymentEmailDisabled: ko.observable(false),
            isChangingPassword: ko.observable(false),
            isClaimingTax: ko.observable(false),
            isTaxVisible: ko.observable(false),
            isPaymentBank: ko.observable(false),
            isPaymentMethodId: ko.observable(false),
            hasAdminRole: ko.observable(false),
            idCompany: ko.observable(),
            oldIdCompany: ko.observable(),
            companies: ko.observableArray([]),
            brandInfo: ko.observableArray([]),
            brandJobTitleList: ko.observableArray([]),
            isAddSiteVisible: ko.observable(true),
            isRemoveSiteVisible: ko.observable(false),
            additionalAuthorInfo: ko.observableArray([]),
            selectedAuthorQuestions: ko.observableArray([]),
            isWebsite2Visible: ko.observable(false),
            isWebsite3Visible: ko.observable(false),
            socialMedia: ko.observableArray([]),
            selectedBrandInfo: ko.observable(),
            twoFactorMethod: ko.observable('email'),
            hasBrandSelected: ko.pureComputed(function () {
                console.log('hasBrandSelected -- selectedBrandInfo', self.getTemplateViewModel().selectedBrandInfo());
                return !!self.getTemplateViewModel().selectedBrandInfo()
            }),
            onClickSave: (data, event) => {
                self.onClickSave();
            },
            onClickCancel: (data, event) => {
                self.onClickCancel();
            },
            onChangePaymentMethod: (data, event) => {
                self.onChangePaymentMethod(data);
            },
            onClickSameEmail: (data, event) => {
                self.onClickSameEmail();
            },
            onClickClaimTax: (data, event) => {
                self.onClickClaimTax();
            },
            onClickBrand: (data, event) => {
                self.onClickBrand(data);
            },
            onBlurEmail: (data, event) => {
                self.onBlurEmail();
            },
            /*onClickShowUserPreferencesTab: function (data, event) {
                self.onClickShowUserPreferencesTab();
            },*/
            onClickEditArticleCommission: (data, event) => {
                self.onClickEditArticleCommission(data);
            },
            onClickShowUserRatesTab: (data, event) => {
                self.onClickShowUserRatesTab();
            },
            onClickShowUserInfosTab: (data, event) => {
                self.onClickShowUserInfosTab();
            },
            onClickShowAuthorDetailsTab: (data, event) => {
                self.onClickShowAuthorDetailsTab();
            },
            onClickShowPinnedArticlesTab: (data, event) => {
                self.onClickShowPinnedArticlesTab();
            },
            onChangeRateField: (rateType, data,  event) => {
                self.onChangeRateField(rateType, data,  event);
            },
            onToggleRatePanel: (section, data, event) => {
                self.onToggleRatePanel(section, data, event);
            },
            onClickRevertArticleCommission: (data, event) => {
                self.onClickRevertArticleCommission(data);
            },
            onClickRevertPayPerSession: (data, event) => {
                self.onClickRevertPayPerSession(data);
            },
            onClickRevertMinPayPerSession: (data, event) => {
                self.onClickRevertMinPayPerSession(data);
            },
            onClickRevertMaxPayPerSession: (data, event) => {
                self.onClickRevertMaxPayPerSession(data);
            },
            onClickRevertPayPerUSSession: (data, event) => {
                self.onClickRevertPayPerUSSession(data);
            },
            onClickRevertMinPayPerUSSession: (data, event) => {
                self.onClickRevertMinPayPerUSSession(data);
            },
            onClickRevertMaxPayPerUSSession: (data, event) => {
                self.onClickRevertMaxPayPerUSSession(data);
            },
            onClickRevertEditorPayPerSession: (data, event) => {
                self.onClickRevertEditorPayPerSession(data);
            },
            onClickRevertMinEditorPayPerSession: (data, event) => {
                self.onClickRevertMinEditorPayPerSession(data);
            },
            onClickRevertMaxEditorPayPerSession: (data, event) => {
                self.onClickRevertMaxEditorPayPerSession(data);
            },
            onClickRevertEditorPayPerUSSession: (data, event) => {
                self.onClickRevertEditorPayPerUSSession(data);
            },
            onClickRevertEditorMinPayPerUSSession: (data, event) => {
                self.onClickRevertMinEditorPayPerUSSession(data);
            },
            onClickRevertEditorMaxPayPerUSSession: (data, event) => {
                self.onClickRevertMaxEditorPayPerUSSession(data);
            },

            onClickRevertArticlePerformance: (data, event) => {
                self.onClickRevertArticlePerformance(data);
            },
            onClickRevertEditorArticlePerformance: (data, event) => {
                self.onClickRevertEditorArticlePerformance(data);
            },
            onClickRevertEditorArticleCommission: (data, event) => {
                self.onClickRevertEditorArticleCommission(data);
            },
            onClickRevertTldrCommission: (data, event) => {
                self.onClickRevertTldrCommission(data);
            },
            onClickConfirmEditTldrCommission: (data, event) => {
                self.onClickConfirmEditTldrCommission(data, event);
            },
            isBrandSelected: (data,event) => {
                return self.isBrandSelected(data);
            },
            onFilterCategories: (parentData, data) => {
                self.onFilterCategories(data, parentData);return true;
            },
            onClickHidePopUp: (data,event)=> {
                self.toggleDialogVisibility('negative-rate-dialog');
            },
            onChangeArticlePerformanceMinSource: (section, data, event) => {
                self.onChangeArticlePerformanceMinSource(section, data, event);
            },
            onShowBrandRateCategoryPanel: (data, event) => {
                self.onShowBrandRateCategoryPanel(data, event);
            },
            onClickCancelRateCategoriesPanel: (data, evt) => {

                self.onClickCancelRateCategoriesPanel(data, evt);
            },
            onClickAcceptRateCategoriesPanel: (data, evt) => {

                self.onClickAcceptRateCategoriesPanel(data, evt);
            },
            onClickConfirmClassificationChange: (data, evt) => {

                self.onClickConfirmClassificationChange();
            },
            onClickCancelClassificationChange: (data, evt) => {

                self.onClickCancelClassificationChange();
            },
            onClickShowRefreshMessage: (event) => {
                self.toggleRefreshMessageVisibility();
            },
            onClickInitBrandCKE: (data, event) => {
                self.onClickInitBrandCKE(data);
            },
            addSite: (event) => {
                self.addSite();
            },
            removeSite: (event) => {
                self.removeSite();
            },
            onChangePaymentClassification: (event) => {
                self.onChangePaymentClassification();
            },
            onChangeCompany: (data, event) => {
                self.onChangeCompany(data);
            },
            onChangeSelectedBrandInfo: (data, event) => {
                self.onChangeSelectedBrandInfo();
            },
            onClickAddPinnedArticle: (data, event) => {
                self.onClickAddPinnedArticle();
            },
            onClickDelete: (data, event) => {
                self.onClickDelete(data);
            },
            onClickRemoveEmbed: (data) => {
                self.onClickRemoveEmbed(data);
            },
            onClickOpenEmbeds: (data) => {
                if (self.getTemplateViewModel().hasBrandSelected()) {
                    self.embedder.toggleEmbedPopUp(true);
                }
            },
            onClickCloseEmbeds: (data) => {
                self.embedder.toggleEmbedPopUp(false);
            },
            setEmbedHTML: (data) => {
                self.setEmbedHTML(data);
            },
            onChangeCountry: (data, event) => {
                self.onChangeCountry(data);
            },
            onChangeBankCountry: (data, event) => {
                self.onChangeBankCountry(data);
            },

            onClickRemoveTopicExpertise: (data, context) => {
                self.onClickRemoveTopicExpertise(data, context)
            },
            onClickWriterSABonus: (data, context) => {
                return self.onClickWriterSABonus(data, context)
            },
            onClickEditorSABonus: (data, context) => {
                return self.onClickEditorSABonus(data, context)
            },
            onClickWriterHasUSSession: (data, context) => {
                return self.onClickWriterHasUSSession(data, context)
            },
            onClickEditorHasUSSession: (data, context) => {
                return self.onClickEditorHasUSSession(data, context)
            },
            handleJobTitleChange: (data) => {
                self.handleJobTitleChange(data)
            },
            onClickConfirmOffboardingDialog: (data, event) => {
                self.onClickConfirmOffboardingDialog();

            },
            onClickCancelOffboardingDialog: (data, event) => {
                self.onClickCancelOffboardingDialog();
            },
            getReasonColor: (data, event) => {
                self.getReasonColor(data);
            }
        };

        viewModel.isChangingPassword.subscribe(function (checked) {
            self.displayChangePassword(checked);
        }, viewModel);

        return viewModel;
    }

    public buildDatePickerCalendar() {

        this.effectiveDatePicker.buildCalendarWithoutTime();

        //for each brandinfo, build the calendar for the datepicker
        this.getTemplateViewModel().brandInfo().forEach(brandInfo => {
            if(brandInfo.startDatePicker){
                brandInfo.startDatePicker.toggleClearButton(true);
                if(brandInfo.dateContributingSince && brandInfo.dateContributingSince.date){
                    brandInfo.startDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime(brandInfo.dateContributingSince.date));
                    brandInfo.startDatePicker.buildCalendarWithoutTime();
                }else{
                    brandInfo.startDatePicker.buildCalendarWithoutTime();
                    brandInfo.startDatePicker.onClickClearDatePicker();
                }
            }
        })
    }

    private getBrandName(brandId: number): string {
        const allBrands = this.getTemplateViewModel().allBrands();
        const brand = allBrands.find(b => b.id === brandId);
        return brand ? brand.name : `Unknown Brand (ID: ${brandId})`;
    }
    private getBrandIcon(brandId: number): string {
        const allBrands = this.getTemplateViewModel().allBrands();
        const brand = allBrands.find(b => b.id === brandId);
        return brand ? brand.iconImage : `Unknown Brand (ID: ${brandId})`;
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        this.clearPerformanceTooltips();
        const brandInfo = this.getTemplateViewModel().brandInfo()
        brandInfo.forEach(bi =>
            {
                delete bi.userSlugToolTip;
                delete bi.authorToneToolTip;
                delete bi.topicExpertise;
                delete bi.userTopicExpertiseToolTip;
                if(bi.startDatePicker){
                    bi.dateContributingSince = bi.startDatePicker.getTemplateViewModel().singleDatePicker();
                    delete bi.startDatePicker;
                }
            }
        )

        return {
            idUser: this.getTemplateViewModel().idUser(),
            editForm: {
                idUser: this.getTemplateViewModel().idUser(),
                loggedUserId: this.getTemplateViewModel().loggedUserId(),
                permissions: this.getTemplateViewModel().permissions(),
                fullName: this.getTemplateViewModel().fullName(),
                fullLegalName: this.getTemplateViewModel().fullLegalName(),
                loginName: this.getTemplateViewModel().loginName(),
                email: this.getTemplateViewModel().email(),
                pictureUrl: this.getTemplateViewModel().pictureUrl(),
                password: this.getTemplateViewModel().password(),
                roles: this.getTemplateViewModel().roles(),
                groupedRoles: this.getTemplateViewModel().groupedRoles(),
                brands: this.getTemplateViewModel().brands(),
                groupedBrands: this.getTemplateViewModel().groupedBrands(),
                allBrands: this.getTemplateViewModel().allBrands(),
                countries: this.getTemplateViewModel().countries(),
                provinces: this.getTemplateViewModel().provinces(),
                taxCodes: this.getTemplateViewModel().taxCodes(),
                taxNumbers: this.getTemplateViewModel().taxNumbers(),
                otherCountries: this.getTemplateViewModel().otherCountries(),
                otherCountriesDataList: this.getTemplateViewModel().otherCountriesDataList(),
                idCountry: this.countryGroups.getCountryId(),
                idProvince: this.getTemplateViewModel().idProvince(),
                otherCountryName: this.getTemplateViewModel().otherCountryName(),
                idOtherCountry: this.getTemplateViewModel().idOtherCountry(),
                selectedRoles: this.getTemplateViewModel().selectedRoles(),
                selectedBrands: this.getTemplateViewModel().selectedBrands(),
                emailPayment: this.getTemplateViewModel().emailPayment(),
                passwordConfirmation: this.getTemplateViewModel().passwordConfirmation(),
                oldPassword: this.getTemplateViewModel().oldPassword(),
                options_currencies: this.getTemplateViewModel().options_currencies(),
                options_methods: this.getTemplateViewModel().options_methods(),
                idCurrency: this.getTemplateViewModel().idCurrency(),
                isActive: this.getTemplateViewModel().isActive(),
                spellcheck: this.getTemplateViewModel().spellcheck(),
                paymentName: this.getTemplateViewModel().paymentName(),
                paymentAddress: this.getTemplateViewModel().paymentAddress(),
                bankAddress: this.getTemplateViewModel().bankAddress(),
                bankAccountNumber: this.getTemplateViewModel().bankAccountNumber(),
                bankNumber: this.getTemplateViewModel().bankNumber(),
                bankName: this.getTemplateViewModel().bankName(),
                bankTransit: this.getTemplateViewModel().bankTransit(),
                bankCity: this.getTemplateViewModel().bankCity(),
                bankPostalCode: this.getTemplateViewModel().bankPostalCode(),
                bankState: this.bankCountryGroups.getSelectedState(),
                idBankCountry: this.getTemplateViewModel().idBankCountry(),
                paymentClassifications: this.getTemplateViewModel().paymentClassifications(),
                idPaymentClassification: this.getTemplateViewModel().idPaymentClassification(),
                effectiveDate: this.getTemplateViewModel().effectiveDatePicker.singleDatePicker(),
                address: this.getTemplateViewModel().address(),
                addressLine2: this.getTemplateViewModel().addressLine2(),
                state: this.countryGroups.getSelectedState(),
                city: this.getTemplateViewModel().city(),
                postalCode: this.getTemplateViewModel().postalCode(),
                instagram: this.getTemplateViewModel().instagram(),
                twitter: this.getTemplateViewModel().twitter(),
                facebook: this.getTemplateViewModel().facebook(),
                website: this.getTemplateViewModel().website(),
                website2: this.getTemplateViewModel().website2(),
                website3: this.getTemplateViewModel().website3(),
                linkedIn: this.getTemplateViewModel().linkedIn(),
                tiktok: this.getTemplateViewModel().tiktok(),
                muckrack: this.getTemplateViewModel().muckrack(),
                openCritic: this.getTemplateViewModel().openCritic(),
                mastodon: this.getTemplateViewModel().mastodon(),
                threads: this.getTemplateViewModel().threads(),
                weChat: this.getTemplateViewModel().weChat(),
                youtube: this.getTemplateViewModel().youtube(),
                twitch: this.getTemplateViewModel().twitch(),
                discord: this.getTemplateViewModel().discord(),
                pinterest: this.getTemplateViewModel().pinterest(),
                whatsApp: this.getTemplateViewModel().whatsApp(),
                reddit: this.getTemplateViewModel().reddit(),
                snapchat: this.getTemplateViewModel().snapchat(),
                substack: this.getTemplateViewModel().substack(),
                medium: this.getTemplateViewModel().medium(),
                tumblr: this.getTemplateViewModel().tumblr(),
                signalSocial: this.getTemplateViewModel().signalSocial(),
                telegram: this.getTemplateViewModel().telegram(),
                sm_email: this.getTemplateViewModel().sm_email(),
                idPaymentMethod: this.getTemplateViewModel().idPaymentMethod(),
                paymentFrequency: this.getTemplateViewModel().paymentFrequency(),
                paymentRateError: this.getTemplateViewModel().paymentRateError(),
                userRates: this.getTemplateViewModel().userRates(),
                disableActive: this.getTemplateViewModel().disableActive(),
                isCountryDisabled: this.getTemplateViewModel().isCountryDisabled(),
                isEmailSameAsPayPal: this.getTemplateViewModel().isEmailSameAsPayPal(),
                isPayPalCheckboxVisible: this.getTemplateViewModel().isPayPalCheckboxVisible(),
                isShowUserRatesTab: this.getTemplateViewModel().isShowUserRatesTab(),
                isShowAuthorDetailsTab: this.getTemplateViewModel().isShowAuthorDetailsTab(),
                isShowPinnedArticlesTab: this.getTemplateViewModel().isShowPinnedArticlesTab(),
                isShowUserInfosTab: this.getTemplateViewModel().isShowUserInfosTab(),
                isPaymentEmailDisabled: this.getTemplateViewModel().isPaymentEmailDisabled(),
                isChangingPassword: this.getTemplateViewModel().isChangingPassword(),
                isClaimingTax: this.getTemplateViewModel().isClaimingTax(),
                isTaxVisible: this.getTemplateViewModel().isTaxVisible(),
                isPaymentBank: this.getTemplateViewModel().isPaymentBank(),
                isPaymentMethodId: this.getTemplateViewModel().isPaymentMethodId(),
                hasAdminRole: this.getTemplateViewModel().hasAdminRole(),
                idCompany: this.getTemplateViewModel().idCompany(),
                companies: this.getTemplateViewModel().companies(),
                brandInfo: brandInfo,
                isWebsite2Visible: this.getTemplateViewModel().isWebsite2Visible(),
                isWebsite3Visible: this.getTemplateViewModel().isWebsite3Visible(),
                isAddSiteVisible: this.getTemplateViewModel().isAddSiteVisible(),
                isRemoveSiteVisible: this.getTemplateViewModel().isRemoveSiteVisible(),
                additionalAuthorInfo: this.getTemplateViewModel().additionalAuthorInfo(),
                socialMedia: this.getTemplateViewModel().socialMediaFilter.selectedItems,
                twoFactorMethod: this.getTemplateViewModel().twoFactorMethod(),
                offboardingData: this.getTemplateViewModel().offboardingData(),
                bankInstitutionNumber: this.getTemplateViewModel().bankInstitutionNumber(),
                bankABARoutingNumber: this.getTemplateViewModel().bankABARoutingNumber(),
            }
        }
    }

    public setSelectedRoles(selectedRoles: Array<{ id: number }>) {

        let roles = [];
        for (let r of selectedRoles) {
            roles.push(r.id);
        }
        this.getTemplateViewModel().selectedRoles(roles);
        this.validateBrands();
    }

    public setSelectedBrands(selectedBrands: Array<{ id: number }>) {

        let brands = [];
        for (let b of selectedBrands) {
            brands.push(b.id);
        }
        this.getTemplateViewModel().selectedBrands(brands);

    }


    public setinitialSelectedBrands(selectedBrands: Array<{ id: number }>) {

        let brands = [];
        for (let b of selectedBrands) {
            brands.push(b.id);
        }
        this.getTemplateViewModel().initialSelectedBrands(brands);

    }

    public setSelectedCountryAndState(idCountry: number, state?: string) {

        if (idCountry) {
            let countries = this.getTemplateViewModel().countries();
            let hasCountry = countries.some(c => c.id === idCountry);
            if (!hasCountry) {
                //add country to dropdown if it does not exist (get it from other country list)
                let otherCountries = this.getTemplateViewModel().otherCountries();
                let country = otherCountries.find(c => c.id === idCountry);
                if (country) {
                    countries.push(country);
                    this.getTemplateViewModel().countries(countries);
                }
            }
            this.getTemplateViewModel().idCountry(idCountry);
            this.countryGroups.setCountryAndState(idCountry, state);
        }
    }

    public setSelectedBankCountryAndState(idBankCountry: number, state?: string) {

        if (idBankCountry) {

            this.getTemplateViewModel().idBankCountry(idBankCountry);
            this.bankCountryGroups.setCountryAndState(idBankCountry, state);
        }else{
            this.bankCountryGroups.setCountryAndState(32, '');
        }
    }


    public isShowTldrCommissionRevertButton(data){

        let show = false;

        if(data.tldrCommission && data.default_tldrCommission && data.editTldrCommission && !data.editTldrCommission() && data.tldrCommission() != data.default_tldrCommission() && data.tldrCommission() != null){
            show = true;
        }

        return show;
    }

    public isShowArticlePerformanceRevertButton(data){

        let show = false;

        if( data.default_articlePerformance && {}.toString.call(data.default_articlePerformance) === '[object Function]' && data.articlePerformance && {}.toString.call(data.articlePerformance) === '[object Function]' && data.articlePerformance() != data.default_articlePerformance() ){
            show = true;
        }

        return show;
    }

    public setSelectedProvince(idProvince: number) {

        if (idProvince) {
            this.getTemplateViewModel().idProvince(idProvince);
        }
    }

    public setPictureUrl(pictureUrl: string) {

        this.getTemplateViewModel().pictureUrl(pictureUrl)
    }

    public setSelectedCurrency(idCurrency: number) {

        if (idCurrency) {
            this.getTemplateViewModel().idCurrency(idCurrency);
        }
    }

    public setSelectedPaymentMethod(idPaymentMethod: number) {

        if(idPaymentMethod ===0){
            this.getTemplateViewModel().idPaymentMethod(0);
        }
        if (idPaymentMethod) {
            this.getTemplateViewModel().idPaymentMethod(idPaymentMethod);
        }
    }

    public setIsTaxVisible(isTaxVisible: boolean) {

        this.getTemplateViewModel().isTaxVisible(isTaxVisible);
    }

    protected onClickSave(brandOffboardingValidated = false) {

        let removedBrands = [];
        if(!brandOffboardingValidated){
                if(this.getTemplateViewModel().isActive()==0 ){
                removedBrands = this.getTemplateViewModel().initialSelectedBrands();
           }else{
               const currentSelectedBrands = this.getTemplateViewModel().selectedBrands();
                removedBrands = this.getTemplateViewModel().initialSelectedBrands().filter(brand => !currentSelectedBrands.includes(brand));

           }
        }

        let effectiveDate = new Date(this.getTemplateViewModel().effectiveDatePicker.singleDatePicker());

        if(this.getTemplateViewModel().idPaymentClassification() == 2 && (this.getTemplateViewModel().isClassificationChanged() || this.getTemplateViewModel().idPaymentClassificationChanged())&& !this.getTemplateViewModel().isClassificationConfirmed()){
            let message = "You are changing this user’s classification to employee. By doing this, all their pending transactions, article rates, and recurring rules will be removed immediately. The removed, pending amounts can be consulted in the Freelancer Offboard list. For cost reporting, new recurring rules and transactions should be created with their payroll costs and with the “Payroll” account selected. Are you sure you want to implement this change?";
            if(effectiveDate > new Date()){
                message = "You are changing this user’s classification to employee. By doing this, all their pending transactions, article rates, and recurring rules will be removed on " + this.getTemplateViewModel().effectiveDatePicker.singleDatePicker() + ". The removed, pending amounts can be consulted in the Freelancer Offboard list. For cost reporting, new recurring rules and transactions should be created with their payroll costs and with the “Payroll” account selected. Are you sure you want to implement this change?";
            }
            this.getTemplateViewModel().classificationChangeMessage(message);
            this.toggleDialogVisibility('classification-change-dialog');
        }else if (removedBrands.length > 0 ) {
            removedBrands.forEach(brand => {
                let brandName = this.getBrandName(brand);
                let brandIcon  =  this.getBrandIcon(brand);
                let offboardingData = {
                    idBrand:  brand,
                    brandName: brandName,
                    offboardingReasons : this.getTemplateViewModel().offboardingReasons(),
                    reasonColor:  ko.observable(""),
                    isOffboarding:  ko.observable(false),
                    reason:  ko.observable(null),
                    warning:  ko.observable(""),
                    iconImage: ko.observable(brandIcon), // dynamic image
                };
                offboardingData.reasonColor = ko.computed(function() {

                    const allReasons = offboardingData.offboardingReasons;
                    const reasonObj = allReasons.find(r => r.id === offboardingData.reason());
                    let color =  reasonObj ? reasonObj.color : '';
                    return color;
                }, offboardingData);
                this.getTemplateViewModel().offboardingData.push(offboardingData);
            });
            if(this.getTemplateViewModel().isActive() == 0){
                 let message = "<b>" + this.getTemplateViewModel().fullName() + "</b> will be denied access to the following brand(s) due to being set as inactive by <b>" + this.caller.getVnAppZone().app.loggedUser.user.valnet_user.fullName + "</b> at <b>" + new Date().toLocaleString() + "</b>.";
                 this.getTemplateViewModel().offboardingMessage(message);

            }else{
                let message = "<b>" + this.getTemplateViewModel().fullName() + "</b> will be denied access to the following brand(s) due to being removed by <b>" + this.caller.getVnAppZone().app.loggedUser.user.valnet_user.fullName + "</b> at <b>" + new Date().toLocaleString() + "</b>.";
                this.getTemplateViewModel().offboardingMessage(message);
            }

            this.toggleDialogVisibility('offboarding-dialog');
        } else {
            let isValid = this.areRatesValid();
            if (isValid) {
                this.caller.saveEditUser();
            }
        }
    }

    protected onBlurCountry(data) {

        //set currency based on selected country
        let selectedCountry = data.otherCountries().find(c => c.name.toLowerCase() === data.otherCountryName().toLowerCase());
        if (selectedCountry) {
            data.idOtherCountry(selectedCountry.id);
            data.idCurrency(selectedCountry.idCurrency);
        } else {
            data.idOtherCountry("");
            data.otherCountryName("");
            //reset currency id to what it was before (default country)
            let selectedCountry = data.countries().find(country => country.id === data.idCountry());
            if (selectedCountry) {
                data.idCurrency(selectedCountry.idCurrency);
            }
        }
    }

    public toggleDialogVisibility(dialogId) {
        document.getElementById(dialogId).classList.toggle('is-visible');
    }

    public toggleRefreshMessageVisibility() {

        document.getElementById('refreshMessage').classList.toggle('is-visible');
    }

    protected onKeyupCountry(data) {

        if (data.otherCountryName().length > 1 && data.otherCountriesDataList().length == 0) {
            data.otherCountriesDataList(data.otherCountries());
        }
    }

    protected onClickCancel() {

        this.caller.cancelEditUser();
    }

    protected onClickClaimTax() {

        this.getTemplateViewModel().isClaimingTax(!this.getTemplateViewModel().isClaimingTax());
        //this.caller.cancelEditUser();
    }

    protected onClickBrand(data) {

        let selectedBrands = this.getTemplateViewModel().selectedBrands();
        let brandInfo = this.getTemplateViewModel().brandInfo();
        let b = null;

        if (selectedBrands.indexOf(data.id) > -1) {

            selectedBrands = selectedBrands.filter(function (brand) {
                return brand != data.id;
            });

            brandInfo = brandInfo.filter(function (b) {
                return (b.brand.id != data.id || (b.brand.id == data.id && b.isAuthorDetailActive()));
            });

        } else {

            selectedBrands.push(data.id);

            if (brandInfo.filter(b => b.brand.id === data.id).length == 0) {

                let brandJobTitleList = [];
                if(this.getTemplateViewModel().brandJobTitleList().hasOwnProperty(data.id)){
                    brandJobTitleList = this.getTemplateViewModel().brandJobTitleList()[data.id];
                }

                b = {
                    id: null,
                    brand: data,
                    brandJobTitleList: brandJobTitleList,
                    bio: null,
                    pictureUrl: null,
                    bannerPictureUrl: null,
                    isIndex: true,
                    isAuthorDetailActive: ko.observable(false),
                    niceName: this.getTemplateViewModel().fullName() ? slugify(this.getTemplateViewModel().fullName()) : null,
                    displayName: this.getTemplateViewModel().fullName(),
                    jobTitle: null,
                    authorQuestion1: null,
                    authorInfo1: null,
                    authorQuestion2: null,
                    authorInfo2: null,
                    authorQuestion3: null,
                    authorInfo3: null,
                    pinnedArticles: ko.observableArray([]),
                    embeds: ko.observableArray([]),
                    seoBio : null,
                    authorTone : null,
                    topicExpertiseList : ko.observableArray([]),
                };

                b = this.addStartDatePicker(b, b.brand.id);
                b = this.createUserSlugToolTip(b, b.brand.id);
                b = this.createAuthorToneToolTip(b, b.brand.id);
                b = this.createUserTopicExpertiseToolTip(b, b.brand.id);
                b = this.createAuthorTopicExpertise(b, b.brand.id);

                b.topicExpertiseMaxItemReached = ko.computed(function () {
                    return b.topicExpertiseList().length >= 3
                }, b)



                brandInfo.push({...b });
            }
        }

        this.getTemplateViewModel().brandInfo(brandInfo);
        this.getTemplateViewModel().selectedBrands(selectedBrands);

        if(b){
            this.generateBrandDropzone([b]);
        }
    }

    private createAuthorTopicExpertise(userObject, brandId) {
        if(!userObject.topicExpertise){
            const authorTopicExpertise = new filterAutocomplete_template(`filterAutoComplete_${brandId}`, this.getTemplateViewModel(), this.caller)
            authorTopicExpertise.setPlaceholderAndLabel('Topic Expertise')
            authorTopicExpertise.setNumberOfChars(2)
            userObject.topicExpertise = authorTopicExpertise;

            return userObject
        }

    }

    private createUserSlugToolTip(userObject, brandId) {
        if(!userObject.userSlugToolTip){
            const userSlugToolTip = new infoButton_template(`userSlugToolTip_${brandId}`, this.getTemplateViewModel(), this);
            userSlugToolTip.setTitle('Author Slug')
            const content = `<p>An author’s slug specifies the portion of the URL that follows /author/. Given “slug” as an example, the resulting URL will be website.com/author/slug.</p>`;
            userSlugToolTip.setContent(content)
            userObject.userSlugToolTip = userSlugToolTip

            return userObject
        }
    }


    private createAuthorToneToolTip(userObject, brandId) {
        if(!userObject.authorToneToolTip){
            const authorToneToolTip = new infoButton_template(`authorToneToolTip_${brandId}`, this.getTemplateViewModel(), this);
            authorToneToolTip.setTitle('Author Tone')
            const content = `<p>The assistant uses this to better align suggestions with your personal writing style. It’s recommended to include the following: </br>
                    - Voice Personality: “Witty and enthusiastic,” “Direct and serious,” etc.</br>
                    - Stylistic Choices: “Uses analogies,” “Prefers short paragraphs,” etc.</br>
                    - Favorite Conventions: Rhetorical questions, emojis, storytelling, CTA style.</br>
                    - Audience Specificity: Niche usually written for (e.g., beginners, executives, students).</p>`;
            authorToneToolTip.setContent(content)
            userObject.authorToneToolTip = authorToneToolTip
            return userObject
        }
    }
    private createUserTopicExpertiseToolTip(userObject, brandId){
        if(!userObject.userTopicExpertiseToolTip){
            const userTopicExpertiseToolTip = new infoButton_template(`userTopicExpertiseToolTip_${brandId}`, this.getTemplateViewModel(), this);
            userTopicExpertiseToolTip.setTitle(`Topic Expertise`)
            userTopicExpertiseToolTip.setContent(`<p>Using tags, list up to 3 topics the author is knowledgable about</p>`)
            userObject.userTopicExpertiseToolTip = userTopicExpertiseToolTip;
            return userObject
        }
    }
    protected onClickSameEmail() {

        this.getTemplateViewModel().isEmailSameAsPayPal(!this.getTemplateViewModel().isEmailSameAsPayPal());
        let isEmailSameAsPayPal = this.getTemplateViewModel().isEmailSameAsPayPal();
        if (isEmailSameAsPayPal) {
            this.getTemplateViewModel().emailPayment(this.getTemplateViewModel().email());
        } else {
            this.getTemplateViewModel().emailPayment("");
        }
        return true;
    }

    protected onBlurEmail() {

        //set currency based on selected country
        let isEmailSameAsPayPal = this.getTemplateViewModel().isEmailSameAsPayPal();
        if (isEmailSameAsPayPal) {
            this.getTemplateViewModel().emailPayment(this.getTemplateViewModel().email());
        }
    }

    protected displayChangePassword(checked) {


        let element = document.querySelector("#form-group-password");

        if (checked) {
            element.classList.add('is-open');
        } else {
            element.classList.remove('is-open');

            this.getTemplateViewModel().password("");
            this.getTemplateViewModel().oldPassword("");
            this.getTemplateViewModel().passwordConfirmation("");
        }

    }

    protected onFocusCountry() {

        let isCountryDisabled = this.getTemplateViewModel().isCountryDisabled();
        if (isCountryDisabled) {
            var element = <HTMLInputElement>document.getElementById("country-select");
            element.disabled = true;
            this.caller.showCountryMessage();
        }
        return true;
    }

    public onChangeCountry(data) {

        let idCountry = data.idCountry();
        this.countryGroups.setCountryAndState(idCountry, '');
    }

    public onChangeBankCountry(data) {

        let idCountry = data.idBankCountry();
        this.bankCountryGroups.setCountryAndState(idCountry, '');
    }

    public onChangeCountryAction(data) {

        data.idOtherCountry("");
        data.otherCountryName("");
        data.isTaxVisible(false);
        //set currency based on selected country
        let selectedCountry = data.countries().find(country => country.id === data.idCountry());
        if (selectedCountry) {
            data.idCurrency(selectedCountry.idCurrency);
        } else {
            data.idCurrency("");
        }
        if (data.idCountry() == 32 || data.idCountry() == null) {
            data.isTaxVisible(true);
        }
    }

    public onChangePaymentMethod(data) {

        let display = this.getDisplayForPaymentMethod(data.idPaymentMethod());

        this.clearPaymentFields();

        data.isPaymentBank(display.isPaymentBank);
        data.isPaymentMethodId(display.isPaymentMethodId);
    }

    private clearPaymentFields() {


        this.getTemplateViewModel().emailPayment(null);
        this.getTemplateViewModel().bankName(null);
        this.getTemplateViewModel().bankAccountNumber(null);
        this.getTemplateViewModel().bankNumber(null);
        this.getTemplateViewModel().bankTransit(null);
        this.getTemplateViewModel().bankCity(null);
        this.getTemplateViewModel().bankAddress(null);
        this.getTemplateViewModel().bankPostalCode(null);
        this.getTemplateViewModel().idBankCountry(32);
        this.bankCountryGroups.setCountryAndState(32, '');

    }

    public onChangeCompany(data){

        this.caller.validateCompanyChange();
    }

    public changeCompany(){

        let companyBrands = [];
        let brandUserRates = this.getTemplateViewModel().allUserRates();

        if(this.getTemplateViewModel().idCompany()){

            let brands = this.getTemplateViewModel().allBrands();
            let idCompany = this.getTemplateViewModel().idCompany();

            brands.forEach(brand => {

                if(brand.idCompany == idCompany){

                    companyBrands.push(brand);
                }else{

                    brandUserRates = brandUserRates.filter(function (value) {

                        return value.idBrand != brand.id;
                    });
                }
            });

            //Company = 1: Valnet, 2: PL, 3: Snack.
            //Classification = 1: Freelance, 2: Employee
            //Currency = 1: usd, 2: cad, 3: gbp, 4: eur
            let idPaymentClassification = this.getTemplateViewModel().idPaymentClassification();
            let selectableIdCurrency = [];

            let companyCurrency = [
                {"idCompany": 1, "idPaymentClassification": 1, "currencies": [1, 2, 3, 4]},
                {"idCompany": 1, "idPaymentClassification": 2, "currencies": [1, 2, 3, 4]},
                {"idCompany": 2, "idPaymentClassification": 1, "currencies": [1, 3]},
                {"idCompany": 2, "idPaymentClassification": 2, "currencies": [3]}
            ];

            companyCurrency.forEach(value => {

                if(idCompany == value.idCompany && idPaymentClassification == value.idPaymentClassification){

                    selectableIdCurrency = value.currencies;
                }
            });

            let currencies = this.getTemplateViewModel().allCurrencies();
            currencies = currencies.filter(function (value) {

                return selectableIdCurrency.indexOf(value.id) > -1;
            });

            if(selectableIdCurrency.indexOf(this.getTemplateViewModel().idCurrency()) == -1){

                this.getTemplateViewModel().idCurrency(null);
            }

            this.getTemplateViewModel().options_currencies(currencies);

            this.getTemplateViewModel().oldIdCompany(idCompany);
        }

        this.getTemplateViewModel().userRates(brandUserRates);
    }

    public getDisplayForPaymentMethod(idPaymentMethod: number): PaymentMethodDisplay {

        let isPaymentBank: boolean = false;
        let isPaymentMethodId: boolean = false;
        switch(idPaymentMethod) {
            case PaymentMethod.PAYPAL:
                isPaymentBank = false;
                isPaymentMethodId = true;
                break;
            case PaymentMethod.WIRE_TRANSFER:
                isPaymentBank = true;
                isPaymentMethodId = false;
                break;
            case PaymentMethod.PAYONEER:
                isPaymentBank = false;
                isPaymentMethodId = true;
                break;
            case PaymentMethod.DIRECT_BANK_TRANSFER:
                isPaymentBank = true;
                isPaymentMethodId = false;
                break;
            case PaymentMethod.NONE:
                isPaymentBank = false;
                isPaymentMethodId = false;
                break;
            default:
                isPaymentBank = false;
                isPaymentMethodId = false;
                break;
        }

        return {
            isPaymentBank: isPaymentBank,
            isPaymentMethodId: isPaymentMethodId
        };
    }

    public setupForm(data) {

        let disableActive = false;
        let user = data.user;
        const loggedUser = this.caller.getVnAppZone().app.loggedUser.user.valnet_user;
        const isAdmin = loggedUser.roles && loggedUser.roles.find(r => r.id === 1);

        let permissions = this.getTemplateViewModel().permissions();
        if ((permissions['users_form_payment_settings'] && permissions['users_form_payment_settings'].write)) {
            this.getTemplateViewModel().disablePaymentSetting(false);
            this.getTemplateViewModel().hidePaymentSetting(false);
        }else if ((permissions['users_form_payment_settings'] && permissions['users_form_payment_settings'].read)) {
            this.getTemplateViewModel().hidePaymentSetting(false);
        }

        // objectify groupedRoles
        let objGroupedRoles = Object.keys(data.groupedRoles).map((key) => {
            return { key: key, roles: this.getDisabledRoles(data.groupedRoles[key], permissions) };
        });

        // objectify groupedBrands
        let objGroupedBrands= Object.keys(data.groupedBrands).map(function(key) {
            return { key: key, brands: data.groupedBrands[key] };
        });

        this.getTemplateViewModel().roles(data.roles);
        this.getTemplateViewModel().groupedRoles(objGroupedRoles);
        this.getTemplateViewModel().allBrands(data.brands);
        this.getTemplateViewModel().brands(data.brands);
        this.getTemplateViewModel().groupedBrands(objGroupedBrands);
        this.getTemplateViewModel().options_currencies(data.currencies);
        this.getTemplateViewModel().allCurrencies(data.currencies);
        const paymentMethods = !isAdmin ? data.methods.filter(m => m.id !== PaymentMethod.DIRECT_BANK_TRANSFER) : data.methods;
        this.getTemplateViewModel().options_methods(paymentMethods);
        this.getTemplateViewModel().disableActive(disableActive);
        this.getTemplateViewModel().countries(data.countries);
        const bankCountries = data.countries.filter((value) => value.id === CountryBankId.CA || value.id === CountryBankId.US);
        this.getTemplateViewModel().bankCountries(bankCountries);
        this.getTemplateViewModel().paymentClassifications([{"id": 1, "name": "Freelance"}, {"id": 2, "name": "Employee"}]);
        this.getTemplateViewModel().provinces(data.provinces);
        this.getTemplateViewModel().taxCodes(data.taxCodes);
        this.getTemplateViewModel().options_frequencies(data.frequencies);
        this.getTemplateViewModel().companies(data.companies);
        this.getTemplateViewModel().brandJobTitleList(data.brandJobTitles);
        this.getTemplateViewModel().offboardingReasons(data.offboardingReasons);
        if(user.valnet_paymentInfo.bankInstitutionNumber){
            this.getTemplateViewModel().bankInstitutionNumber(user.valnet_paymentInfo.bankInstitutionNumber)
        }
        if(user.valnet_paymentInfo.bankABARoutingNumber){
            this.getTemplateViewModel().bankABARoutingNumber(user.valnet_paymentInfo.bankABARoutingNumber)
        }
        if(user.valnet_user.idCountry == null){
            this.setIsTaxVisible(true);
        }
        if(user.valnet_user.id !== undefined){
            this.setSelectedRoles(user.valnet_user.roles);
            this.setSelectedBrands(user.brands);
            this.setinitialSelectedBrands(user.brands);
            this.setPictureUrl(user.valnet_user.pictureUrl);

            this.setSelectedCountryAndState(user.valnet_user.idCountry, user.valnet_user.state);
            this.setSelectedProvince(user.valnet_user.idProvince);
            this.updateElementForm(user);

            if(user.idCountry == 32){

                this.setIsTaxVisible(true);
            }

            if(user.valnet_paymentInfo !== undefined && user.valnet_paymentInfo.id !== undefined) {
                this.setSelectedPaymentMethod(user.valnet_paymentInfo.idMethod);

                let methodDisplay = this. getDisplayForPaymentMethod(user.valnet_paymentInfo.idMethod);

                this.getTemplateViewModel().isPaymentBank(methodDisplay.isPaymentBank);
                this.getTemplateViewModel().isPaymentMethodId(methodDisplay.isPaymentMethodId);

            }
            if(user.valnet_paymentInfo.idMethod == null && user.valnet_user.id != null){
                this.setSelectedPaymentMethod(0);
            }

            this.setSelectedBankCountryAndState(user.valnet_paymentInfo.idBankCountry, user.valnet_paymentInfo.state);
        }

        if (data.userPreferences != null && data.user.id != null){

            let activeSpellcheck = (data.userPreferences.preferences.spellcheck) ? "1" : "0";
            this.getTemplateViewModel().spellcheck(activeSpellcheck);
        }else{

            let activeSpellcheck = "1";
            this.getTemplateViewModel().spellcheck(activeSpellcheck)
        }

        if(data.userConfigs){

            this.setAdditionalAuthorInfo(data.userConfigs);
        }

        if(!permissions['users_form_payment_settings'].write){

            this.effectiveDatePicker.setIsPickerDisabled(true);
        }

        this.setAuthorDetails(data.brandInfo, user.brands, data.brandJobTitles);
        this.setUserRates(data.userRates);

        this.generateDropzone(user);
    }

    protected getReasonColor(reason){
        const allReasons = this.getTemplateViewModel().offboardingReasons();
        const reasonObj = allReasons.find(r => r.id === reason);
        let color =  reasonObj ? reasonObj.color : 'yellow';

        return ko.observable(color);
    }

    protected getDisabledRoles(roles: Array<any>, permissions: Array<any>){
        let roleId = null;
        let rolesToValidate = [];

        roles.forEach((r) => {

            // the role is checkable by default.
            r['disabled'] = false;
            roleId = r['id'];
            rolesToValidate = [];

            //Admin
            rolesToValidate = [1, 44];
            if(rolesToValidate.indexOf(roleId) != -1) {
                r['disabled'] = !permissions['users_form_admin'].write;
                return;
            }

            //Website Manager, Accountant, Ad Manager, Hiring Manager, Commerce manager
            rolesToValidate = [2, 7, 8, 21, 35, 49];
            if(rolesToValidate.indexOf(roleId) != -1) {
                r['disabled'] = !permissions['users_form_website_manager'].write;
                return;
            }

            //General Manager, Payroll Accountant
            rolesToValidate = [28, 36];
            if(rolesToValidate.indexOf(roleId) != -1) {
                r['disabled'] = !permissions['users_form_general_manager'].write;
                return;
            }

            //Hiring Coordinator
            rolesToValidate = [13];
            if(rolesToValidate.indexOf(roleId) != -1) {
                r['disabled'] = !permissions['users_form_hiring_coordinator'].write;
                return;
            }

            //Payment Auditor, Accounting Support
            rolesToValidate = [15, 34];
            if(rolesToValidate.indexOf(roleId) != -1) {
                r['disabled'] = !permissions['users_form_payment_auditor'].write;
                return;
            }

            //Managing Editor, Job Application Reviewer, Sales Director, Account Manager, Sales Support, Embargo Writer, Static Page Editor
            rolesToValidate = [12, 22, 29, 30, 31, 33, 37];
            if(rolesToValidate.indexOf(roleId) != -1) {
                r['disabled'] = !permissions['users_form_content_management'].write;
                return;
            }
        });

        return roles;
    }

    public onClickWriterSABonus(data, event) {

        let userRates = this.getTemplateViewModel().userRates();
        this.getTemplateViewModel().userRates([]);
        this.getTemplateViewModel().userRates(userRates);

        return false;
    }

    public onClickEditorSABonus(data, event) {

        let userRates = this.getTemplateViewModel().userRates();
        this.getTemplateViewModel().userRates([]);
        this.getTemplateViewModel().userRates(userRates);

        return false;
    }


    public onClickWriterHasUSSession(data, event) {

        let userRates = this.getTemplateViewModel().userRates();
        let writerHasUSSession = data.writerHasUSSession;
        this.getTemplateViewModel().userRates([]);
        this.getTemplateViewModel().userRates(userRates);

        return false;
    }

    public onClickEditorHasUSSession(data, event) {

        let userRates = this.getTemplateViewModel().userRates();
        let editorHasUSSession = data.editorHasUSSession;
        this.getTemplateViewModel().userRates([]);
        this.getTemplateViewModel().userRates(userRates);

        return false;
    }


    protected updateElementForm(user){

        let vnApp = this.caller.getVnAppZone().app;
        this.getTemplateViewModel().loggedUserId(vnApp.loggedUser.user.id);
        this.getTemplateViewModel().idUser(user.id);
        this.getTemplateViewModel().fullName(user.valnet_user.fullName);
        this.getTemplateViewModel().city(user.valnet_user.city);
        this.getTemplateViewModel().fullLegalName(user.valnet_user.fullLegalName);
        this.getTemplateViewModel().postalCode(user.valnet_user.postalCode);
        this.getTemplateViewModel().addressLine2(user.valnet_user.addressLine2);
        this.getTemplateViewModel().address(user.valnet_user.address);
        this.getTemplateViewModel().loginName(user.valnet_user.loginName);
        this.getTemplateViewModel().email(user.valnet_user.email);
        this.getTemplateViewModel().pictureUrl(user.valnet_user.pictureUrl);
        this.getTemplateViewModel().twoFactorMethod(user.valnet_user.twoFactorMethod || "email");

        this.getTemplateViewModel().twitter(user.twitter);
        this.getTemplateViewModel().instagram(user.instagram);
        this.getTemplateViewModel().facebook(user.facebook);
        this.getTemplateViewModel().linkedIn(user.linkedIn);
        this.getTemplateViewModel().tiktok(user.tiktok);
        this.getTemplateViewModel().muckrack(user.muckrack);
        this.getTemplateViewModel().openCritic(user.openCritic);
        this.getTemplateViewModel().mastodon(user.mastodon);
        this.getTemplateViewModel().threads(user.threads);
        this.getTemplateViewModel().weChat(user.wechat);
        this.getTemplateViewModel().youtube(user.youtube);
        this.getTemplateViewModel().twitch(user.twitch);
        this.getTemplateViewModel().discord(user.discord);
        this.getTemplateViewModel().pinterest(user.pinterest);
        this.getTemplateViewModel().whatsApp(user.whatsapp);
        this.getTemplateViewModel().reddit(user.reddit);
        this.getTemplateViewModel().snapchat(user.snapchat);
        this.getTemplateViewModel().substack(user.substack);
        this.getTemplateViewModel().medium(user.medium);
        this.getTemplateViewModel().tumblr(user.tumblr);
        this.getTemplateViewModel().signalSocial(user.signalSocial);
        this.getTemplateViewModel().telegram(user.telegram);
        this.getTemplateViewModel().sm_email(user.email);

        this.setSocialMediaFilterItems();
        this.setSocialMediaSelectedItems(user);

        if(user.websites){

            let objWebsites = JSON.parse(user.websites);
            if(objWebsites.website){

                this.getTemplateViewModel().website(objWebsites.website);
                if(objWebsites.website2){

                    this.getTemplateViewModel().website2(objWebsites.website2);
                    this.getTemplateViewModel().isWebsite2Visible(true);
                    this.getTemplateViewModel().isRemoveSiteVisible(true);
                    if(objWebsites.website3){

                        this.getTemplateViewModel().website3(objWebsites.website3);
                        this.getTemplateViewModel().isWebsite3Visible(true);
                        this.getTemplateViewModel().isAddSiteVisible(false);
                    }
                }
            }
        }

        if(user.valnet_paymentInfo) {
            this.getTemplateViewModel().emailPayment(user.valnet_paymentInfo.email);
            this.getTemplateViewModel().idCurrency(user.valnet_paymentInfo.idCurrency);
            this.getTemplateViewModel().bankAddress(user.valnet_paymentInfo.bankAddress);
            this.getTemplateViewModel().bankCity(user.valnet_paymentInfo.city);
            this.getTemplateViewModel().bankPostalCode(user.valnet_paymentInfo.postalCode);
            this.getTemplateViewModel().bankAccountNumber(user.valnet_paymentInfo.bankAccountNumber);
            this.getTemplateViewModel().bankNumber(user.valnet_paymentInfo.bankNumber);
            this.getTemplateViewModel().bankName(user.valnet_paymentInfo.bankName);
            this.getTemplateViewModel().bankTransit(user.valnet_paymentInfo.bankTransit);
            this.getTemplateViewModel().paymentFrequency(user.valnet_paymentInfo.frequency);
        }

        this.getTemplateViewModel().idPaymentClassification(user.idPaymentClassification);
        if(user.effectiveDate){

            let uTMEffectiveDate = user.effectiveDate.replace(/\s/, 'T'); // format date so it is supported by safari
            this.effectiveDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime(uTMEffectiveDate));

        }else{
            this.effectiveDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());
        }

        this.getTemplateViewModel().password("");
        this.getTemplateViewModel().passwordConfirmation("");
        this.getTemplateViewModel().idCountry(user.valnet_user.idCountry);
        if (user.id != null){
            //if user already exists (not new)
            let userRoles: Array<number> = user.valnet_user.roles;
            let idUser = vnApp.loggedUser.user.id;

            this.getTemplateViewModel().isPayPalCheckboxVisible(false);
            if((userRoles.indexOf(3) > -1 || userRoles.indexOf(2) > -1) && userRoles.indexOf(1) < 0 && idUser != user.id) {
                //disable PayPal ID if user is a QA or CM
                this.getTemplateViewModel().isPaymentEmailDisabled(true);
            }
        }

        if(user.idCompany){

            this.getTemplateViewModel().idCompany(user.idCompany);
            this.getTemplateViewModel().oldIdCompany(user.idCompany);
            this.onChangeCompany(this.getTemplateViewModel());
        }

        let isActive:string = (user.valnet_user.isActive != null) ? (user.valnet_user.isActive).toString() : "1";
        this.getTemplateViewModel().isActive(isActive);
    }

    public setCanEditRoles(canEditRoles) {

        this.getTemplateViewModel().canEditRoles(canEditRoles);
    }

    public setCanEditRates(canEditRates) {

        this.getTemplateViewModel().canEditRates(canEditRates);
    }

    public setCanEditBrands(canEditBrands) {

        this.getTemplateViewModel().canEditBrands(canEditBrands);
    }

    public setCanUpdatePassword(canUpdatePassword) {

        this.getTemplateViewModel().canUpdatePassword(canUpdatePassword);
    }

    public setCanCreateWebsiteManager(canCreateWebsiteManager) {

        this.getTemplateViewModel().canCreateWebsiteManager(canCreateWebsiteManager);
    }

    public setCanCreateAdmin(canCreateAdmin) {

        this.getTemplateViewModel().canCreateAdmin(canCreateAdmin);
    }

    public onClickShowUserRatesTab() {

        this.getTemplateViewModel().isShowAuthorDetailsTab(false);
        this.getTemplateViewModel().isShowPinnedArticlesTab(false);
        this.getTemplateViewModel().isShowUserInfosTab(false);
        this.getTemplateViewModel().isShowUserRatesTab(true);
        //this.getTemplateViewModel().isShowUserPreferencesTab(false);
    }

    public onClickShowUserInfosTab() {

        this.getTemplateViewModel().isShowAuthorDetailsTab(false);
        this.getTemplateViewModel().isShowPinnedArticlesTab(false);
        this.getTemplateViewModel().isShowUserRatesTab(false);
        this.getTemplateViewModel().isShowUserInfosTab(true);
        //this.getTemplateViewModel().isShowUserPreferencesTab(false);
    }

    public onClickShowAuthorDetailsTab() {

        this.getTemplateViewModel().isShowAuthorDetailsTab(true);
        this.getTemplateViewModel().isShowPinnedArticlesTab(false);
        this.getTemplateViewModel().isShowUserRatesTab(false);
        this.getTemplateViewModel().isShowUserInfosTab(false);
        //this.getTemplateViewModel().isShowUserPreferencesTab(false);
    }

    public onClickShowPinnedArticlesTab(){
        this.getTemplateViewModel().isShowAuthorDetailsTab(false);
        this.getTemplateViewModel().isShowPinnedArticlesTab(true);
        this.getTemplateViewModel().isShowUserRatesTab(false);
        this.getTemplateViewModel().isShowUserInfosTab(false);
    }

    /*public onClickShowUserPreferencesTab() {

        this.getTemplateViewModel().isShowAuthorDetailsTab(false);
        this.getTemplateViewModel().isShowUserRatesTab(false);
        this.getTemplateViewModel().isShowUserInfosTab(false);
        this.getTemplateViewModel().isShowUserPreferencesTab(true);
    }*/

    public onChangeShowRefreshMessage(){

        this.getTemplateViewModel().showRefresh(1);
    }

    protected validateBrands() {


        let checked = this.getTemplateViewModel().selectedRoles();
        if ((checked.indexOf(1) >= 0)) {
            this.getTemplateViewModel().hasAdminRole(true);
            this.setSelectedBrands([]);

        } else {
            this.getTemplateViewModel().hasAdminRole(false);
        }

    }

    public setUserRates(userRates) {

        let newList = [];
        for (let item of userRates) {
            let rateData: any = {};
            rateData.brand = item.brand;
            rateData.idBrand = item.idBrand;
            rateData.icon = item.icon;
            rateData.rates = ko.observableArray([]);
            rateData.rateCategories = item.rateCategories;
            rateData.isVisible = ko.observable(false);
            rateData.selectedCategories = ko.observableArray([]);
            rateData.originalSelectedCategories = ko.observableArray([]);
            rateData.articleGroupRate = ko.observable(item.articleGroupRate);
            rateData.articleGroupRole = ko.observable(item.articleGroupRole);
            rateData.articleGroupType = ko.observable(item.articleGroupType);
            rateData.writerOutputMinimumTarget = ko.observable(item.writerOutputMinimumTarget);
            rateData.editorOutputMinimumTarget = ko.observable(item.editorOutputMinimumTarget);

            rateData.writerHasSABonus = item.writerHasSABonus;
            rateData.writerHasUSSession = item.writerHasUSSession;
            rateData.editorHasSABonus = item.editorHasSABonus;
            rateData.editorHasUSSession = item.editorHasUSSession;

            rateData.writerEffectiveDate = ko.observable(item.writerEffectiveDate);
            rateData.editorEffectiveDate = ko.observable(item.editorEffectiveDate);

            rateData.writerIncludesRepublishSessions = item.writerIncludesRepublishSessions;
            rateData.editorIncludesRepublishSessions = item.editorIncludesRepublishSessions;

            rateData.writerTier1Target = ko.observable(item.writerTier1Target);
            rateData.writerTier1Bonus = ko.observable(item.writerTier1Bonus);

            rateData.editorTier1Target = ko.observable(item.editorTier1Target);
            rateData.editorTier1Bonus = ko.observable(item.editorTier1Bonus);

            rateData.writerTier2Target = ko.observable(item.writerTier2Target);
            rateData.writerTier2Bonus = ko.observable(item.writerTier2Bonus);

            rateData.editorTier2Target = ko.observable(item.editorTier2Target);
            rateData.editorTier2Bonus = ko.observable(item.editorTier2Bonus);

            rateData.writerTier1BonusType = item.writerTier1BonusType;
            rateData.writerTier2BonusType = item.writerTier2BonusType;
            rateData.editorTier1BonusType = item.editorTier1BonusType;
            rateData.editorTier2BonusType = item.editorTier2BonusType;

            let writerCommissionHeaderTooltipBtn = new infoButton_template('writerCommissionHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            writerCommissionHeaderTooltipBtn.setTitle('commission');
            writerCommissionHeaderTooltipBtn.setContent(this.writerCommissionButtonContent);
            rateData.writerCommissionHeaderTooltipBtn = writerCommissionHeaderTooltipBtn;

            let writerSessionCommissionHeaderTooltipBtn = new infoButton_template('writerSessionCommissionHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            writerSessionCommissionHeaderTooltipBtn.setTitle('Pay Per Session');
            writerSessionCommissionHeaderTooltipBtn.setContent(this.writerSessionCommissionButtonContent);
            rateData.writerSessionCommissionHeaderTooltipBtn = writerSessionCommissionHeaderTooltipBtn;

            let editorSessionCommissionHeaderTooltipBtn = new infoButton_template('editorSessionCommissionHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            editorSessionCommissionHeaderTooltipBtn.setTitle('Pay Per Session');
            editorSessionCommissionHeaderTooltipBtn.setContent(this.editorSessionCommissionButtonContent);
            rateData.editorSessionCommissionHeaderTooltipBtn = editorSessionCommissionHeaderTooltipBtn;

            let writerPerformanceHeaderTooltipBtn = new infoButton_template('writerPerformanceHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            writerPerformanceHeaderTooltipBtn.setTitle('Performance');
            writerPerformanceHeaderTooltipBtn.setContent(this.writerPerformanceButtonContent);
            rateData.writerPerformanceHeaderTooltipBtn = writerPerformanceHeaderTooltipBtn;

            let writerArticlegroupHeaderTooltipBtn = new infoButton_template('writerArticlegroupHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            writerArticlegroupHeaderTooltipBtn.setTitle('Article Group');
            writerArticlegroupHeaderTooltipBtn.setContent(this.writerArticlegroupButtonContent);
            rateData.writerArticlegroupHeaderTooltipBtn = writerArticlegroupHeaderTooltipBtn;

            let editorCommissionHeaderTooltipBtn = new infoButton_template('editorCommissionHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            editorCommissionHeaderTooltipBtn.setTitle('commission');
            editorCommissionHeaderTooltipBtn.setContent(this.editorCommissionButtonContent);
            rateData.editorCommissionHeaderTooltipBtn = editorCommissionHeaderTooltipBtn;

            let editorPerformanceHeaderTooltipBtn = new infoButton_template('editorPerformanceHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            editorPerformanceHeaderTooltipBtn.setTitle('Performance');
            editorPerformanceHeaderTooltipBtn.setContent(this.editorPerformanceButtonContent);
            rateData.editorPerformanceHeaderTooltipBtn = editorPerformanceHeaderTooltipBtn;

            let editorArticlegroupHeaderTooltipBtn = new infoButton_template('editorArticlegroupHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            editorArticlegroupHeaderTooltipBtn.setTitle('Article Group');
            editorArticlegroupHeaderTooltipBtn.setContent(this.editorArticlegroupButtonContent);
            rateData.editorArticlegroupHeaderTooltipBtn = editorArticlegroupHeaderTooltipBtn;

            let writerOutputMinimumTargetHeaderTooltipBtn = new infoButton_template('writerOutputMinimumTargetHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            writerOutputMinimumTargetHeaderTooltipBtn.setTitle('minimum output target');
            writerOutputMinimumTargetHeaderTooltipBtn.setContent(this.outputMinTargetTooltipContent);
            rateData.writerOutputMinimumTargetHeaderTooltipBtn = writerOutputMinimumTargetHeaderTooltipBtn;

            let editorOutputMinimumTargetHeaderTooltipBtn = new infoButton_template('editorOutputMinimumTargetHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            editorOutputMinimumTargetHeaderTooltipBtn.setTitle('minimum output target');
            editorOutputMinimumTargetHeaderTooltipBtn.setContent(this.outputMinTargetTooltipContent);
            rateData.editorOutputMinimumTargetHeaderTooltipBtn = editorOutputMinimumTargetHeaderTooltipBtn;

            let writerTier1TargetSAHeaderTooltipBtn = new infoButton_template('writerTier1TargetSAHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            writerTier1TargetSAHeaderTooltipBtn.setTitle('Tier 1 Target S/A');
            writerTier1TargetSAHeaderTooltipBtn.setContent(this.tier1TargetSATooltipContent);
            rateData.writerTier1TargetSAHeaderTooltipBtn = writerTier1TargetSAHeaderTooltipBtn;

            let editorTier1TargetSAHeaderTooltipBtn = new infoButton_template('editorTier1TargetSAHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            editorTier1TargetSAHeaderTooltipBtn.setTitle('Tier 1 Target S/A');
            editorTier1TargetSAHeaderTooltipBtn.setContent(this.tier1TargetSATooltipContent);
            rateData.editorTier1TargetSAHeaderTooltipBtn = editorTier1TargetSAHeaderTooltipBtn;

            let writerTier2TargetSAHeaderTooltipBtn = new infoButton_template('writerTier2TargetSAHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            writerTier2TargetSAHeaderTooltipBtn.setTitle('Tier 2 % Increase S/A');
            writerTier2TargetSAHeaderTooltipBtn.setContent(this.tier2TargetSATooltipContent);
            rateData.writerTier2TargetSAHeaderTooltipBtn = writerTier2TargetSAHeaderTooltipBtn;

            let editorTier2TargetSAHeaderTooltipBtn = new infoButton_template('editorTier2TargetSAHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            editorTier2TargetSAHeaderTooltipBtn.setTitle('Tier 2 % Increase S/A');
            editorTier2TargetSAHeaderTooltipBtn.setContent(this.tier2TargetSATooltipContent);
            rateData.editorTier2TargetSAHeaderTooltipBtn = editorTier2TargetSAHeaderTooltipBtn;

            let writerTier1BonusPercentageHeaderTooltipBtn = new infoButton_template('writerTier1BonusPercentageHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            writerTier1BonusPercentageHeaderTooltipBtn.setTitle('Tier 1 Bonus');
            writerTier1BonusPercentageHeaderTooltipBtn.setContent(this.tier1BonusPercentageTooltipContent);
            rateData.writerTier1BonusPercentageHeaderTooltipBtn = writerTier1BonusPercentageHeaderTooltipBtn;

            let editorTier1BonusPercentageHeaderTooltipBtn = new infoButton_template('editorTier1BonusPercentageHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            editorTier1BonusPercentageHeaderTooltipBtn.setTitle('Tier 1 Bonus');
            editorTier1BonusPercentageHeaderTooltipBtn.setContent(this.tier1BonusPercentageTooltipContent);
            rateData.editorTier1BonusPercentageHeaderTooltipBtn = editorTier1BonusPercentageHeaderTooltipBtn;

            let writerTier2BonusPercentageHeaderTooltipBtn = new infoButton_template('writerTier2BonusPercentageHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            writerTier2BonusPercentageHeaderTooltipBtn.setTitle('Tier 2 Bonus');
            writerTier2BonusPercentageHeaderTooltipBtn.setContent(this.tier2BonusPercentageTooltipContent);
            rateData.writerTier2BonusPercentageHeaderTooltipBtn = writerTier2BonusPercentageHeaderTooltipBtn;

            let editorTier2BonusPercentageHeaderTooltipBtn = new infoButton_template('editorTier2BonusPercentageHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            editorTier2BonusPercentageHeaderTooltipBtn.setTitle('Tier 2 Bonus');
            editorTier2BonusPercentageHeaderTooltipBtn.setContent(this.tier2BonusPercentageTooltipContent);
            rateData.editorTier2BonusPercentageHeaderTooltipBtn = editorTier2BonusPercentageHeaderTooltipBtn;

            let writerEffectiveDateHeaderTooltipBtn = new infoButton_template('writerEffectiveDateHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            writerEffectiveDateHeaderTooltipBtn.setTitle('Effective Month');
            writerEffectiveDateHeaderTooltipBtn.setContent(this.effectiveDateTooltipContent);
            rateData.writerEffectiveDateHeaderTooltipBtn = writerEffectiveDateHeaderTooltipBtn;

            let editorEffectiveDateHeaderTooltipBtn = new infoButton_template('editorEffectiveDateHeaderTooltipBtn' + item.brand, this.getTemplateViewModel(), this.caller);
            editorEffectiveDateHeaderTooltipBtn.setTitle('Effective Month');
            editorEffectiveDateHeaderTooltipBtn.setContent(this.effectiveDateTooltipContent);
            rateData.editorEffectiveDateHeaderTooltipBtn = editorEffectiveDateHeaderTooltipBtn;


            for (let rate of item.rates) {
                let newObj = {};

                // writer article group data
                newObj['writerArticleGroupPanelOpen'] = ko.observable(false);
                newObj['writerArticleGroup'] = ko.observable(rate.articleGroup);
                newObj['writerArticleGroupStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                newObj['optionsWriterArticleGroupToggleText'] = ko.observable('Add Options');
                newObj['hideWriterArticleGroupResetBtn'] = ko.observable(null);
                newObj['minWriterArticleGroup'] = ko.observable(rate.minArticleGroup);
                newObj['writerMinArticleGroupRateFilledType'] = ko.observable(MinPerformanceFilledType.CUSTOM);
                newObj['maxWriterArticleGroup'] = ko.observable(rate.maxArticleGroup);
                newObj['writerArticleGroupDisabled'] = ko.observable((rate.idCategory != 0));

                if (rate['minArticleGroup'] != null || rate['maxArticleGroup'] != null) {

                    newObj['writerArticleGroupPanelOpen'] = ko.observable(true);
                    newObj['optionsWriterArticleGroupToggleText'] = ko.observable('Remove Options');
                }

                // editor article group data
                newObj['editorArticleGroupPanelOpen'] = ko.observable(false);
                newObj['editorArticleGroup'] = ko.observable(rate.editorArticleGroup);
                newObj['editorArticleGroupStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                newObj['optionsEditorArticleGroupToggleText'] = ko.observable('Add Options');
                newObj['hideEditorArticleGroupResetBtn'] = ko.observable(null);
                newObj['minEditorArticleGroup'] = ko.observable(rate.minEditorArticleGroup);
                newObj['editorMinArticleGroupRateFilledType'] = ko.observable(MinPerformanceFilledType.CUSTOM);
                newObj['maxEditorArticleGroup'] = ko.observable(rate.maxEditorArticleGroup);
                newObj['editorArticleGroupDisabled'] = ko.observable((rate.idCategory != 0));


                newObj['payPerSessionGroupDisabled'] = ko.observable((rate.idSystem == 2));

                newObj['payPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                newObj['minPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                newObj['maxPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);

                newObj['payPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                newObj['minPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                newObj['maxPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);


                newObj['editorPayPerSessionGroupDisabled'] = ko.observable((rate.idSystem == 2));

                newObj['editorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                newObj['minEditorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                newObj['maxEditorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);

                newObj['editorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                newObj['minEditorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                newObj['maxEditorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);


                if (rate['minEditorArticleGroup'] != null || rate['maxEditorArticleGroup'] != null) {

                    newObj['editorArticleGroupPanelOpen'] = ko.observable(true);
                    newObj['optionsEditorArticleGroupToggleText'] = ko.observable('Remove Options');
                }

                let minPerformanceTooltipBtn = new infoButton_template('minPerformanceTooltipBtn_' + item.brand  + '_' + rate.category, this.getTemplateViewModel(), this.caller);
                minPerformanceTooltipBtn.setTitle('Writer Minimum');
                minPerformanceTooltipBtn.setContent(this.minTooltipButtonContent);

                let maxPerformanceTooltipBtn = new infoButton_template('maxPerformanceTooltipBtn_' + item.brand  + '_' + rate.category, this.getTemplateViewModel(), this.caller);
                maxPerformanceTooltipBtn.setTitle('Writer Maximum');
                maxPerformanceTooltipBtn.setContent(this.maxTooltipButtonContent);

                let editorMinPerformanceTooltipBtn = new infoButton_template('editorMinPerformanceTooltipBtn_' + item.brand  + '_' + rate.category, this.getTemplateViewModel(), this.caller);
                editorMinPerformanceTooltipBtn.setTitle('Editor Minimum');
                editorMinPerformanceTooltipBtn.setContent(this.minTooltipButtonContent);

                let editorMaxPerformanceTooltipBtn = new infoButton_template('editorMaxPerformanceTooltipBtn_' + item.brand  + '_' + rate.category, this.getTemplateViewModel(), this.caller);
                editorMaxPerformanceTooltipBtn.setTitle('Editor Maximum');
                editorMaxPerformanceTooltipBtn.setContent(this.maxTooltipButtonContent);

                let writerMinArticleGroupTooltipBtn = new infoButton_template('writerMinArticleGroupTooltipBtn_' + item.brand  + '_' + rate.category, this.getTemplateViewModel(), this.caller);
                writerMinArticleGroupTooltipBtn.setTitle('Writer Article Group Minimum');
                writerMinArticleGroupTooltipBtn.setContent(this.minTooltipButtonContent);

                let writerMaxArticleGroupTooltipBtn = new infoButton_template('writerMaxArticleGroupTooltipBtn_' + item.brand  + '_' + rate.category, this.getTemplateViewModel(), this.caller);
                writerMaxArticleGroupTooltipBtn.setTitle('Writer Article Group Maximum');
                writerMaxArticleGroupTooltipBtn.setContent(this.maxTooltipButtonContent);


                let editorMinArticleGroupTooltipBtn = new infoButton_template('editorMinArticleGroupTooltipBtn_' + item.brand  + '_' + rate.category, this.getTemplateViewModel(), this.caller);
                editorMinArticleGroupTooltipBtn.setTitle('Editor Article Group Minimum');
                editorMinArticleGroupTooltipBtn.setContent(this.minTooltipButtonContent);

                let editorMaxArticleGroupTooltipBtn = new infoButton_template('editorMaxArticleGroupTooltipBtn_' + item.brand  + '_' + rate.category, this.getTemplateViewModel(), this.caller);
                editorMaxArticleGroupTooltipBtn.setTitle('Editor Article Group Maximum');
                editorMaxArticleGroupTooltipBtn.setContent(this.maxTooltipButtonContent);

                // let commissionTooltipBtn = new infoButton_template('commissionTooltipBtn_' + item.brand  + '_' + rate.category, this.getTemplateViewModel(), this.caller);
                // commissionTooltipBtn.setTitle('commission');
                // commissionTooltipBtn.setContent(this.commissionButtonContent);
                //

                newObj['minPerformanceTooltip'] = minPerformanceTooltipBtn;
                newObj['maxPerformanceTooltip'] = maxPerformanceTooltipBtn;
                newObj['editorMinPerformanceTooltip'] = editorMinPerformanceTooltipBtn;
                newObj['editorMaxPerformanceTooltip'] = editorMaxPerformanceTooltipBtn;


                newObj['minWriterArticleGroupTooltip'] = writerMinArticleGroupTooltipBtn;
                newObj['maxWriterArticleGroupTooltip'] = writerMaxArticleGroupTooltipBtn;
                newObj['editorMinArticleGroupTooltip'] = editorMinArticleGroupTooltipBtn;
                newObj['editorMaxArticleGroupTooltip'] = editorMaxArticleGroupTooltipBtn;

                // ewObj['commissionTooltip'] = commissionTooltipBtn;

                let isSelected = false;
                newObj['articleCommission'] = ko.observable(null);
                newObj['default_articleCommission'] = ko.observable(null);
                newObj['articlePerformance'] = ko.observable(null);
                newObj['minArticlePerformance'] = ko.observable(null);
                newObj['maxArticlePerformance'] = ko.observable(null);
                newObj['minRateFilledType'] = ko.observable(MinPerformanceFilledType.CUSTOM);
                newObj['performancePanelOpen'] = ko.observable(false);

                newObj['optionsWriterPerformanceToggleText'] = ko.observable('Add Options');

                newObj['default_payPerSession'] = ko.observable(null);
                newObj['default_minPayPerSession'] = ko.observable(null);
                newObj['default_maxPayPerSession'] = ko.observable(null);

                newObj['payPerSession'] = ko.observable(null);
                newObj['minPayPerSession'] = ko.observable(null);
                newObj['maxPayPerSession'] = ko.observable(null);

                // same per session but for payPerUSSession
                newObj['default_payPerUSSession'] = ko.observable(null);
                newObj['default_minPayPerUSSession'] = ko.observable(null);
                newObj['default_maxPayPerUSSession'] = ko.observable(null);

                newObj['payPerUSSession'] = ko.observable(null);
                newObj['minPayPerUSSession'] = ko.observable(null);
                newObj['maxPayPerUSSession'] = ko.observable(null);

                newObj['default_editorPayPerSession'] = ko.observable(null);
                newObj['default_minEditorPayPerSession'] = ko.observable(null);
                newObj['default_maxEditorPayPerSession'] = ko.observable(null);

                newObj['editorPayPerSession'] = ko.observable(null);
                newObj['minEditorPayPerSession'] = ko.observable(null);
                newObj['maxEditorPayPerSession'] = ko.observable(null);

                // same per session but for editorPayPerUSSession
                newObj['default_editorPayPerUSSession'] = ko.observable(null);
                newObj['default_minEditorPayPerUSSession'] = ko.observable(null);
                newObj['default_maxEditorPayPerUSSession'] = ko.observable(null);

                newObj['editorPayPerUSSession'] = ko.observable(null);
                newObj['minEditorPayPerUSSession'] = ko.observable(null);
                newObj['maxEditorPayPerUSSession'] = ko.observable(null);


                // Open the min/max panel if the rate has a min/max or has auto rate
                if ((rate['articlePerformance'] != null && rate['idRateFormatPerformance'] == 1) || rate['minArticlePerformance'] != null || rate['maxArticlePerformance'] != null) {

                    newObj['performancePanelOpen'] = ko.observable(true);
                    newObj['optionsWriterPerformanceToggleText'] = ko.observable('Remove Options');
                }

                newObj['editorMinRateFilledType'] = ko.observable(MinPerformanceFilledType.CUSTOM);
                newObj['tldrCommission'] = ko.observable(null);
                newObj['editorArticleCommission'] = ko.observable(null);
                newObj['default_editorArticleCommission'] = ko.observable(null);
                newObj['default_articlePerformance'] = ko.observable(null);
                newObj['default_tldrCommission'] = ko.observable(null);
                newObj['default_editorArticlePerformance'] = ko.observable(null);

                newObj['editorArticlePerformance'] = ko.observable(null);
                newObj['minEditorArticlePerformance'] = ko.observable(null);
                newObj['maxEditorArticlePerformance'] = ko.observable(null);
                newObj['editorPerformancePanelOpen'] = ko.observable(false);
                newObj['optionsEditorPerformanceToggleText'] = ko.observable('Add Options');
                if(rate['default_idRateFormatArticlePerformance']){
                    newObj['default_idRateFormatArticlePerformance'] = ko.observable(rate['default_idRateFormatArticlePerformance'])
                } else {
                    newObj['default_idRateFormatArticlePerformance'] = ko.observable(null);
                }

                if(rate['default_idRateFormatEditorArticlePerformance']){
                    newObj['default_idRateFormatEditorArticlePerformance'] = ko.observable(rate['default_idEditorRateFormatArticlePerformance'])
                }else {
                    newObj['default_idRateFormatEditorArticlePerformance'] = ko.observable(null);
                }

                // Open the min/max panel if the rate has a min/max or has auto rate
                if ((rate['editorArticlePerformance'] != null && rate['idRateFormatPerformance'] == 1) || rate['minEditorArticlePerformance'] != null || rate['maxEditorArticlePerformance'] != null) {

                    newObj['editorPerformancePanelOpen'] = ko.observable(true);
                    newObj['optionsEditorPerformanceToggleText'] = ko.observable('Remove Options');
                }

                newObj['hideArticleCommissionResetBtn'] = ko.observable(false);
                newObj['hideTldrCommissionResetBtn'] = ko.observable(false);
                newObj['hideEditorArticleCommissionResetBtn'] = ko.observable(false);
                newObj['hideArticlePerformanceResetBtn'] = ko.observable(false);
                newObj['hideEditorArticlePerformanceResetBtn'] = ko.observable(false);

                newObj['hidePayPerSessionResetBtn'] = ko.observable(false);
                newObj['hideMinPayPerSessionResetBtn'] = ko.observable(false);
                newObj['hideMaxPayPerSessionResetBtn'] = ko.observable(false);

                newObj['hidePayPerUSSessionResetBtn'] = ko.observable(false);
                newObj['hideMinPayPerUSSessionResetBtn'] = ko.observable(false);
                newObj['hideMaxPayPerUSSessionResetBtn'] = ko.observable(false);

                newObj['hideEditorPayPerSessionResetBtn'] = ko.observable(false);
                newObj['hideMinEditorPayPerSessionResetBtn'] = ko.observable(false);
                newObj['hideMaxEditorPayPerSessionResetBtn'] = ko.observable(false);

                newObj['hideEditorPayPerUSSessionResetBtn'] = ko.observable(false);
                newObj['hideMinEditorPayPerUSSessionResetBtn'] = ko.observable(false);
                newObj['hideMaxEditorPayPerUSSessionResetBtn'] = ko.observable(false);


                // set min rate type for article performance
                if ((rate['minArticlePerformance'] == null && (rate['default_idRateFormatArticlePerformance'] == 1 || rate['idRateFormatPerformance'] == 1)) || (rate['minArticlePerformance'] && (Number(rate['minArticlePerformance']) == Number(rate['articleCommission']) || Number(rate['minArticlePerformance']) == Number(rate['default_articleCommission'])))) {
                    newObj['minRateFilledType'] = ko.observable(MinPerformanceFilledType.AUTO);
                }

                // set min rate type for editor article performance
                if ((rate['minEditorArticlePerformance'] == null && (rate['default_idRateFormatEditorArticlePerformance'] == 1 || rate['idRateFormatEditorPerformance'] == 1)) || (rate['minEditorArticlePerformance'] && (Number(rate['minEditorArticlePerformance']) == Number(rate['editorArticleCommission']) || Number(rate['minEditorArticlePerformance']) == Number(rate['default_editorArticleCommission'])))) {
                    newObj['editorMinRateFilledType'] = ko.observable(MinPerformanceFilledType.AUTO);
                }

                if ( rate['articleCommission'] != null) {

                    if (Number(rate['articleCommission']) == Number(rate['default_articleCommission'])) {
                        newObj['articleCommissionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideArticleCommissionResetBtn'] = ko.observable(true);

                    } else {
                        newObj['articleCommissionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideArticleCommissionResetBtn'] = ko.observable(false);
                    }
                } else {

                    if (rate['hasArticleCommissionRate'] && Number(rate['default_articleCommission']) != null && rate['default_articleCommission'] != undefined) {
                        newObj['articleCommissionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideArticleCommissionResetBtn'] = ko.observable(true);

                    } else {
                        newObj['articleCommissionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_articleCommission'] == undefined || (rate['default_articleCommission'] != undefined && Number(rate['default_articleCommission']) == null)) {
                            newObj['hideArticleCommissionResetBtn'] = ko.observable(true);
                        }
                    }

                }

                if ( rate['tldrCommission'] != null) {

                    if (Number(rate['tldrCommission']) == Number(rate['default_tldrCommission'])) {
                        newObj['tldrCommissionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideTldrCommissionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['tldrCommissionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideTldrCommissionResetBtn'] = ko.observable(false);
                    }
                } else {

                    if (rate['hasTldrCommissionRate'] && Number(rate['default_tldrCommission']) != null && rate['default_tldrCommission'] != undefined) {
                        newObj['tldrCommissionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideTldrCommissionResetBtn'] = ko.observable(true);

                    } else {
                        newObj['tldrCommissionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_tldrCommission'] == undefined || (rate['default_tldrCommission'] != undefined && Number(rate['default_tldrCommission']) == null)) {

                            newObj['hideTldrCommissionResetBtn'] = ko.observable(true);
                        }
                    }
                }

                if (rate['editorArticleCommission'] != null) {

                    if (Number(rate['editorArticleCommission']) == Number(rate['default_editorArticleCommission'])) {
                        newObj['editorArticleCommissionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideEditorArticleCommissionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['editorArticleCommissionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideEditorArticleCommissionResetBtn'] = ko.observable(false);
                    }
                } else {
                    if (rate['hasEditorArticleCommissionRate'] && Number(rate['default_editorArticleCommission']) != null && rate['default_editorArticleCommission'] != undefined) {
                        newObj['editorArticleCommissionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideEditorArticleCommissionResetBtn'] = ko.observable(true);

                    } else {
                        newObj['editorArticleCommissionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_editorArticleCommission'] == undefined || (rate['default_editorArticleCommission'] != undefined && Number(rate['default_editorArticleCommission']) == null)) {
                            newObj['hideEditorArticleCommissionResetBtn'] = ko.observable(true);
                        }
                    }
                }


                if (rate['articlePerformance'] != null) {

                    if (Number(rate['articlePerformance']) == Number(rate['default_articlePerformance'])) {
                        newObj['articlePerformanceStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideArticlePerformanceResetBtn'] = ko.observable(true);
                    } else {
                        newObj['articlePerformanceStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideArticlePerformanceResetBtn'] = ko.observable(false);
                    }
                } else {

                    if (rate['hasArticlePerformanceRate'] && Number(rate['default_articlePerformance']) != null  && rate['default_articlePerformance'] != undefined) {
                        newObj['articlePerformanceStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideArticlePerformanceResetBtn'] = ko.observable(true);

                    } else {
                        newObj['articlePerformanceStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_articlePerformance'] == undefined || (rate['default_articlePerformance'] != undefined && Number(rate['default_articlePerformance']) == null)) {
                            newObj['hideArticlePerformanceResetBtn'] = ko.observable(true);
                        }
                    }

                }

                if (rate['editorArticlePerformance'] != null) {

                    if (Number(rate['editorArticlePerformance']) == Number(rate['default_editorArticlePerformance'])) {
                        newObj['editorArticlePerformanceStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideEditorArticlePerformanceResetBtn'] = ko.observable(true);
                    } else {
                        newObj['editorArticlePerformanceStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideEditorArticlePerformanceResetBtn'] = ko.observable(false);
                    }
                } else {

                    if (rate['hasEditorArticlePerformanceRate'] && Number(rate['default_editorArticlePerformance']) != null && rate['default_editorArticlePerformance'] != undefined) {
                        newObj['editorArticlePerformanceStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideEditorArticlePerformanceResetBtn'] = ko.observable(true);

                    } else {
                        newObj['editorArticlePerformanceStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_editorArticlePerformance'] == undefined || (rate['default_editorArticlePerformance'] != undefined && Number(rate['default_editorArticlePerformance']) == null)) {
                            newObj['hideEditorArticlePerformanceResetBtn'] = ko.observable(true);
                        }
                    }
                }

                if (rate['writerArticleGroup'] != null) {

                    newObj['writerArticleGroupStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                    newObj['hideWriterArticleGroupResetBtn'] = ko.observable(false);

                } else {

                    newObj['writerArticleGroupStateStatus'] =  ko.observable(RateStateStatus.NOT_USED);
                    newObj['hideWriterArticleGroupResetBtn'] = ko.observable(true);
                }

                if (rate['editorArticleGroup'] != null) {

                    newObj['editorArticleGroupStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                    newObj['hideEditorArticleGroupResetBtn'] = ko.observable(false);

                } else {

                    newObj['editorArticleGroupStateStatus'] =  ko.observable(RateStateStatus.NOT_USED);
                    newObj['hideEditorArticleGroupResetBtn'] = ko.observable(true);
                }

                if (rate['payPerSession'] != null) {
                    if (Number(rate['payPerSession']) == Number(rate['default_payPerSession'])) {
                        newObj['payPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hidePayPerSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['payPerSessionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hidePayPerSessionResetBtn'] = ko.observable(false);
                    }
                } else {
                    if (rate['hasPayPerSessionRate'] && Number(rate['default_payPerSession']) != null && rate['default_payPerSession'] != undefined) {
                        newObj['payPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hidePayPerSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['payPerSessionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_payPerSession'] == undefined || (rate['default_payPerSession'] != undefined && Number(rate['default_payPerSession']) == null)) {
                            newObj['hidePayPerSessionResetBtn'] = ko.observable(true);
                        }
                    }
                }

                if (rate['minPayPerSession'] != null) {
                    if (Number(rate['minPayPerSession']) == Number(rate['default_minPayPerSession'])) {
                        newObj['minPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMinPayPerSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['minPayPerSessionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideMinPayPerSessionResetBtn'] = ko.observable(false);
                    }
                } else {
                    if (rate['hasPayPerSessionRate'] && Number(rate['default_minPayPerSession']) != null && rate['default_minPayPerSession'] != undefined) {
                        newObj['minPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMinPayPerSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['minPayPerSessionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_minPayPerSession'] == undefined || (rate['default_minPayPerSession'] != undefined && Number(rate['default_minPayPerSession']) == null)) {
                            newObj['hideMinPayPerSessionResetBtn'] = ko.observable(true);
                        }
                    }
                }
                if (rate['maxPayPerSession'] != null) {
                    if (Number(rate['maxPayPerSession']) == Number(rate['default_maxPayPerSession'])) {
                        newObj['maxPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMaxPayPerSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['maxPayPerSessionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideMaxPayPerSessionResetBtn'] = ko.observable(false);
                    }
                } else {
                    if (rate['hasPayPerSessionRate'] && Number(rate['default_maxPayPerSession']) != null && rate['default_maxPayPerSession'] != undefined) {
                        newObj['maxPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMaxPayPerSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['maxPayPerSessionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_maxPayPerSession'] == undefined || (rate['default_maxPayPerSession'] != undefined && Number(rate['default_maxPayPerSession']) == null)) {
                            newObj['hideMaxPayPerSessionResetBtn'] = ko.observable(true);
                        }
                    }
                }

                if (rate['payPerUSSession'] != null) {
                    if (Number(rate['payPerUSSession']) == Number(rate['default_payPerUSSession'])) {
                        newObj['payPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hidePayPerUSSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['payPerUSSessionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hidePayPerUSSessionResetBtn'] = ko.observable(false);
                    }
                } else {
                    if (rate['hasPayPerUSSessionRate'] && Number(rate['default_payPerUSSession']) != null && rate['default_payPerUSSession'] != undefined) {
                        newObj['payPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hidePayPerUSSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['payPerUSSessionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_payPerUSSession'] == undefined || (rate['default_payPerUSSession'] != undefined && Number(rate['default_payPerUSSession']) == null)) {
                            newObj['hidePayPerUSSessionResetBtn'] = ko.observable(true);
                        }
                    }
                }

                if (rate['minPayPerUSSession'] != null) {
                    if (Number(rate['minPayPerUSSession']) == Number(rate['default_minPayPerUSSession'])) {
                        newObj['minPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMinPayPerUSSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['minPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideMinPayPerUSSessionResetBtn'] = ko.observable(false);
                    }
                } else {
                    if (rate['hasPayPerUSSessionRate'] && Number(rate['default_minPayPerUSSession']) != null && rate['default_minPayPerUSSession'] != undefined) {
                        newObj['minPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMinPayPerUSSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['minPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_minPayPerUSSession'] == undefined || (rate['default_minPayPerUSSession'] != undefined && Number(rate['default_minPayPerUSSession']) == null)) {
                            newObj['hideMinPayPerUSSessionResetBtn'] = ko.observable(true);
                        }
                    }
                }

                if (rate['maxPayPerUSSession'] != null) {
                    if (Number(rate['maxPayPerUSSession']) == Number(rate['default_maxPayPerUSSession'])) {
                        newObj['maxPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMaxPayPerUSSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['maxPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideMaxPayPerUSSessionResetBtn'] = ko.observable(false);
                    }
                } else {
                    if (rate['hasPayPerUSSessionRate'] && Number(rate['default_maxPayPerUSSession']) != null && rate['default_maxPayPerUSSession'] != undefined) {
                        newObj['maxPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMaxPayPerUSSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['maxPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_maxPayPerUSSession'] == undefined || (rate['default_maxPayPerUSSession'] != undefined && Number(rate['default_maxPayPerUSSession']) == null)) {
                            newObj['hideMaxPayPerUSSessionResetBtn'] = ko.observable(true);
                        }
                    }
                }

                if (rate['editorPayPerSession'] != null) {
                    if (Number(rate['editorPayPerSession']) == Number(rate['default_editorPayPerSession'])) {
                        newObj['editorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideEditorPayPerSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['editorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideEditorPayPerSessionResetBtn'] = ko.observable(false);
                    }
                } else {
                    if (rate['hasEditorPayPerSessionRate'] && Number(rate['default_editorPayPerSession']) != null && rate['default_editorPayPerSession'] != undefined) {
                        newObj['editorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideEditorPayPerSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['editorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_editorPayPerSession'] == undefined || (rate['default_editorPayPerSession'] != undefined && Number(rate['default_editorPayPerSession']) == null)) {
                            newObj['hideEditorPayPerSessionResetBtn'] = ko.observable(true);
                        }
                    }
                }

                if (rate['minEditorPayPerSession'] != null) {
                    if (Number(rate['minEditorPayPerSession']) == Number(rate['default_minEditorPayPerSession'])) {
                        newObj['minEditorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMinEditorPayPerSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['minEditorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideMinEditorPayPerSessionResetBtn'] = ko.observable(false);
                    }
                } else {
                    if (rate['hasEditorPayPerSessionRate'] && Number(rate['default_minEditorPayPerSession']) != null && rate['default_minEditorPayPerSession'] != undefined) {
                        newObj['minEditorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMinEditorPayPerSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['minEditorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_minEditorPayPerSession'] == undefined || (rate['default_minEditorPayPerSession'] != undefined && Number(rate['default_minEditorPayPerSession']) == null)) {
                            newObj['hideMinEditorPayPerSessionResetBtn'] = ko.observable(true);
                        }
                    }
                }
                if (rate['maxEditorPayPerSession'] != null) {
                    if (Number(rate['maxEditorPayPerSession']) == Number(rate['default_maxEditorPayPerSession'])) {
                        newObj['maxEditorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMaxEditorPayPerSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['maxEditorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideMaxEditorPayPerSessionResetBtn'] = ko.observable(false);
                    }
                } else {
                    if (rate['hasEditorPayPerSessionRate'] && Number(rate['default_maxEditorPayPerSession']) != null && rate['default_maxEditorPayPerSession'] != undefined) {
                        newObj['maxEditorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMaxEditorPayPerSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['maxEditorPayPerSessionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_maxEditorPayPerSession'] == undefined || (rate['default_maxEditorPayPerSession'] != undefined && Number(rate['default_maxEditorPayPerSession']) == null)) {
                            newObj['hideMaxEditorPayPerSessionResetBtn'] = ko.observable(true);
                        }
                    }
                }

                if (rate['editorPayPerUSSession'] != null) {
                    if (Number(rate['editorPayPerUSSession']) == Number(rate['default_editorPayPerUSSession'])) {
                        newObj['editorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideEditorPayPerUSSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['editorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideEditorPayPerUSSessionResetBtn'] = ko.observable(false);
                    }
                } else {
                    if (rate['hasEditorPayPerUSSessionRate'] && Number(rate['default_editorPayPerUSSession']) != null && rate['default_editorPayPerUSSession'] != undefined) {
                        newObj['editorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideEditorPayPerUSSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['editorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_editorPayPerUSSession'] == undefined || (rate['default_editorPayPerUSSession'] != undefined && Number(rate['default_editorPayPerUSSession']) == null)) {
                            newObj['hideEditorPayPerUSSessionResetBtn'] = ko.observable(true);
                        }
                    }
                }

                if (rate['minEditorPayPerUSSession'] != null) {
                    if (Number(rate['minEditorPayPerUSSession']) == Number(rate['default_minEditorPayPerUSSession'])) {
                        newObj['minEditorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMinEditorPayPerUSSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['minEditorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideMinEditorPayPerUSSessionResetBtn'] = ko.observable(false);
                    }
                } else {
                    if (rate['hasEditorPayPerUSSessionRate'] && Number(rate['default_minEditorPayPerUSSession']) != null && rate['default_minEditorPayPerUSSession'] != undefined) {
                        newObj['minEditorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMinEditorPayPerUSSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['minEditorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_minEditorPayPerUSSession'] == undefined || (rate['default_minEditorPayPerUSSession'] != undefined && Number(rate['default_minEditorPayPerUSSession']) == null)) {
                            newObj['hideMinEditorPayPerUSSessionResetBtn'] = ko.observable(true);
                        }
                    }
                }

                if (rate['maxEditorPayPerUSSession'] != null) {
                    if (Number(rate['maxEditorPayPerUSSession']) == Number(rate['default_maxEditorPayPerUSSession'])) {
                        newObj['maxEditorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMaxEditorPayPerUSSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['maxEditorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.SAVED_CHANGE);
                        newObj['hideMaxEditorPayPerUSSessionResetBtn'] = ko.observable(false);
                    }
                } else {
                    if (rate['hasEditorPayPerUSSessionRate'] && Number(rate['default_maxEditorPayPerUSSession']) != null && rate['default_maxEditorPayPerUSSession'] != undefined) {
                        newObj['maxEditorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.UNCHANGED);
                        newObj['hideMaxEditorPayPerUSSessionResetBtn'] = ko.observable(true);
                    } else {
                        newObj['maxEditorPayPerUSSessionStateStatus'] = ko.observable(RateStateStatus.NOT_USED);
                        if(rate['default_maxEditorPayPerUSSession'] == undefined || (rate['default_maxEditorPayPerUSSession'] != undefined && Number(rate['default_maxEditorPayPerUSSession']) == null)) {
                            newObj['hideMaxEditorPayPerUSSessionResetBtn'] = ko.observable(true);
                        }
                    }
                }

                for (let key of Object.keys(rate)) {
                    newObj[key] = ko.observable(rate[key]);
                    if (key == "idCategory") {
                        rateData.selectedCategories.push(parseInt(rate[key]));
                        isSelected = true;
                    }
                    if (rate['hasArticleCommissionRate'] && key == "articleCommission" && rate[key] == null) {

                        newObj[key] = ko.observable(rate["default_articleCommission"]);
                    }
                    if (rate['hasArticlePerformanceRate'] && key == "articlePerformance" && rate[key] == null) {

                        newObj[key] = ko.observable(rate["default_articlePerformance"]);
                    }

                    if (key == "minArticlePerformance" || key == "maxArticlePerformance") {
                        newObj[key] = ko.observable((rate[key] != null) ? rate[key] : null);
                    }

                    if (key == "minArticlePerformance" ) {
                        newObj[key] = ko.observable((rate[key] != null) ? rate[key] : (rate['idRateFormatPerformance'] == 1 || (rate['articlePerformance'] == null && rate['default_idRateFormatArticlePerformance'] == 1) ? (rate['articleCommission'] ? rate['articleCommission'] : rate['default_articleCommission']) : null));
                    }

                    if (rate['hasTldrCommissionRate'] && key == "tldrCommission" && rate[key] == null) {

                        newObj[key] = ko.observable(rate["default_tldrCommission"]);
                    }

                    if (rate['hasEditorArticleCommissionRate'] && key == "editorArticleCommission" && rate[key] == null) {

                        newObj[key] = ko.observable(rate["default_editorArticleCommission"]);
                    }
                    //
                    // if(!('articleCommission' in rate) && 'default_articleCommission' in rate) {
                    //     newObj['articleCommission'] = ko.observable(rate["default_articleCommission"]);
                    // }

                    // if(!('articlePerformance' in rate) && 'default_articlePerformance' in rate) {
                    //     newObj['articlePerformance'] = ko.observable(rate["default_articlePerformance"]);
                    // }

                    // if(!('tldrCommission' in rate) && 'default_tldrCommission' in rate) {
                    //     newObj['tldrCommission'] = ko.observable(rate["default_tldrCommission"]);
                    // }
                    //
                    // if(!('editorArticleCommission' in rate) && 'default_editorArticleCommission' in rate) {
                    //     newObj['editorArticleCommission'] = ko.observable(rate["default_editorArticleCommission"]);
                    // }

                    if(rate['hasPayPerSessionRate'] && key == "payPerSession" && rate[key] == null) {
                         newObj['payPerSession'] = ko.observable(rate["default_payPerSession"]);
                    }
                    if(rate['hasPayPerSessionRate'] && key == "minPayPerSession" && rate[key] == null) {
                         newObj['minPayPerSession'] = ko.observable(rate["default_minPayPerSession"]);
                    }
                    if(rate['hasPayPerSessionRate'] && key == "maxPayPerSession" && rate[key] == null) {
                         newObj['maxPayPerSession'] = ko.observable(rate["default_maxPayPerSession"]);
                    }

                    if(rate['hasPayPerUSSessionRate'] && key == "payPerUSSession" && rate[key] == null) {
                         newObj['payPerUSSession'] = ko.observable(rate["default_payPerUSSession"]);
                    }
                    if(rate['hasPayPerUSSessionRate'] && key == "minPayPerUSSession" && rate[key] == null) {
                         newObj['minPayPerUSSession'] = ko.observable(rate["default_minPayPerUSSession"]);
                    }
                    if(rate['hasPayPerUSSessionRate'] && key == "maxPayPerUSSession" && rate[key] == null) {
                         newObj['maxPayPerUSSession'] = ko.observable(rate["default_maxPayPerUSSession"]);
                    }

                    if(rate['hasEditorPayPerSessionRate'] && key == "editorPayPerSession" && rate[key] == null) {
                         newObj['editorPayPerSession'] = ko.observable(rate["default_editorPayPerSession"]);
                    }
                    if(rate['hasEditorPayPerSessionRate'] && key == "minEditorPayPerSession" && rate[key] == null) {
                         newObj['minEditorPayPerSession'] = ko.observable(rate["default_minEditorPayPerSession"]);
                    }
                    if(rate['hasEditorPayPerSessionRate'] && key == "maxEditorPayPerSession" && rate[key] == null) {
                         newObj['maxEditorPayPerSession'] = ko.observable(rate["default_maxEditorPayPerSession"]);
                    }

                    if(rate['hasEditorPayPerUSSessionRate'] && key == "editorPayPerUSSession" && rate[key] == null) {
                         newObj['editorPayPerUSSession'] = ko.observable(rate["default_editorPayPerUSSession"]);
                    }
                    if(rate['hasEditorPayPerUSSessionRate'] && key == "minEditorPayPerUSSession" && rate[key] == null) {
                         newObj['minEditorPayPerUSSession'] = ko.observable(rate["default_minEditorPayPerUSSession"]);
                    }
                    if(rate['hasEditorPayPerUSSessionRate'] && key == "maxEditorPayPerUSSession" && rate[key] == null) {
                         newObj['maxEditorPayPerUSSession'] = ko.observable(rate["default_maxEditorPayPerUSSession"]);
                    }

                    if (rate['hasEditorArticlePerformanceRate'] && key == "editorArticlePerformance" && rate[key] == null) {

                        newObj[key] = ko.observable(rate["default_editorArticlePerformance"]);
                    }

                    if (key == "minEditorArticlePerformance" || key ==  "maxEditorArticlePerformance") {
                        newObj[key] = ko.observable((rate[key] != null) ? rate[key] : null);
                    }

                    if (key == "minEditorArticlePerformance" ) {
                        newObj[key] = ko.observable((rate[key] != null) ? rate[key] : (rate['default_idRateFormatEditorArticlePerformance'] ? (rate['editorArticleCommission'] ? rate['editorArticleCommission'] : rate['default_editorArticleCommission']) : null));
                    }
                }

                newObj["showRow"] = ko.observable(isSelected);
                rateData.rates.push(newObj);
            }
            newList.push(rateData);
        }

        this.getTemplateViewModel().userRates(newList);
        this.getTemplateViewModel().allUserRates(newList);
    }

    public clearPerformanceTooltips(): void {

        let userRates = this.getTemplateViewModel().userRates();

        for (let ur of userRates) {
            delete ur['writerCommissionHeaderTooltipBtn'];
            delete ur['editorSessionCommissionHeaderTooltipBtn'];
            delete ur['writerSessionCommissionHeaderTooltipBtn'];
            delete ur['writerPerformanceHeaderTooltipBtn'];
            delete ur['writerArticlegroupHeaderTooltipBtn'];
            delete ur['editorCommissionHeaderTooltipBtn'];
            delete ur['editorPerformanceHeaderTooltipBtn'];
            delete ur['editorArticlegroupHeaderTooltipBtn'];
            delete ur['writerOutputMinimumTargetHeaderTooltipBtn'];
            delete ur['editorOutputMinimumTargetHeaderTooltipBtn'];
            delete ur['writerTier1TargetSAHeaderTooltipBtn'];
            delete ur['editorTier1TargetSAHeaderTooltipBtn'];
            delete ur['writerTier2TargetSAHeaderTooltipBtn'];
            delete ur['editorTier2TargetSAHeaderTooltipBtn'];
            delete ur['writerTier1BonusPercentageHeaderTooltipBtn'];
            delete ur['editorTier1BonusPercentageHeaderTooltipBtn'];
            delete ur['writerTier2BonusPercentageHeaderTooltipBtn'];
            delete ur['editorTier2BonusPercentageHeaderTooltipBtn'];
            delete ur['writerEffectiveDateHeaderTooltipBtn'];
            delete ur['editorEffectiveDateHeaderTooltipBtn'];

            for (let r of ur.rates()) {
                delete r['minPerformanceTooltip'];
                delete r['maxPerformanceTooltip'];
                delete r['editorMinPerformanceTooltip'];
                delete r['editorMaxPerformanceTooltip'];
                delete r['minWriterArticleGroupTooltip'];
                delete r['maxWriterArticleGroupTooltip'];
                delete r['editorMinArticleGroupTooltip'];
                delete r['editorMaxArticleGroupTooltip'];
            }
        }
    }

    protected generateDropzone(user){

        let myDropzone = new Dropzone("div#my-drop-zone", { url: "/api/user/uploadImage/", maxFiles: 1, acceptedFiles: "image/jpeg,image/png,image/gif"});

        let _this = this;

        myDropzone.on("success", function(file, serverFileName) {
            let responseParsed = serverFileName;
            _this.getTemplateViewModel().pictureUrl(responseParsed.data);
        });
        myDropzone.on("addedfile", function(file) {
            if (this.files.length > 1) {
                this.removeFile(this.files[0]);
            }
        });

        if(user && user.valnet_user.pictureUrl){

            let mockFile = { name: user.valnet_user.pictureUrl, size: parseInt(user.valnet_user.pictureSize)};

            myDropzone.emit("addedfile", mockFile);
            myDropzone.createThumbnailFromUrl(mockFile, mockFile.name);
            myDropzone.emit("complete", mockFile);
            myDropzone.files.push(mockFile);
            _this.getTemplateViewModel().pictureUrl(user.valnet_user.pictureUrl);
        }
    }

    public onClickEditArticleCommission(data) {

        data.initialArticleCommissionValue = null;
        data.initialDefaultArticleCommissionValue = null;

        if(data.articleCommission) {
            data.initialArticleCommissionValue = data.articleCommission();
        }
        if(data.default_articleCommission) {
            data.initialDefaultArticleCommissionValue = data.default_articleCommission();
        }

        data.editArticleCommission(true);
    }

    public onChangeRateField(rateType, data, event) {

        switch (rateType) {
            case 'writerArticleCommission':
                if (data.hasOwnProperty('default_articleCommission')) {

                    if(Number(data.default_articleCommission()) !=  Number(data.articleCommission())) {

                        data.articleCommissionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hideArticleCommissionResetBtn(false);
                    } else {

                        data.articleCommissionStateStatus(RateStateStatus.UNCHANGED);
                        data.hideArticleCommissionResetBtn(true);
                    }
                } else {

                    data.articleCommissionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hideArticleCommissionResetBtn(false);
                }

                if (data.minRateFilledType() == MinPerformanceFilledType.AUTO) {
                    data.minArticlePerformance(data.articleCommission());
                }

                break;
            case 'editorArticleCommission':
                if (data.hasOwnProperty('default_editorArticleCommission')) {

                    if(Number(data.default_editorArticleCommission()) !=  Number(data.editorArticleCommission())) {

                        data.editorArticleCommissionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hideEditorArticleCommissionResetBtn(false);
                    } else {

                        data.editorArticleCommissionStateStatus(RateStateStatus.UNCHANGED);
                        data.hideEditorArticleCommissionResetBtn(true);
                    }
                } else {

                    data.editorArticleCommissionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hideEditorArticleCommissionResetBtn(false);
                }

                if (data.editorMinRateFilledType() == MinPerformanceFilledType.AUTO) {
                    data.minEditorArticlePerformance(data.editorArticleCommission());
                }

                break;
            case 'writerTldrCommission':
                if (data.hasOwnProperty('default_tldrCommission')) {

                    if(Number(data.default_tldrCommission()) !=  Number(data.tldrCommission())) {

                        data.tldrCommissionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hideTldrCommissionResetBtn(false);
                    } else {

                        data.tldrCommissionStateStatus(RateStateStatus.UNCHANGED);
                        data.hideTldrCommissionResetBtn(true);
                    }
                } else {

                    data.tldrCommissionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hideTldrCommissionResetBtn(false);
                }
                break;
            case 'writerArticlePerformance':
                if (data.hasOwnProperty('default_articlePerformance')) {

                    if(Number(data.default_articlePerformance()) !=  Number(data.articlePerformance())) {

                        data.articlePerformanceStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.minArticlePerformance(null);
                        data.maxArticlePerformance(null);

                        data.hideArticlePerformanceResetBtn(false);
                    } else {

                        data.articlePerformanceStateStatus(RateStateStatus.UNCHANGED);
                        data.minArticlePerformance((data.default_idRateFormatArticlePerformance() ? data.articleCommission() : null));
                        data.hideArticlePerformanceResetBtn(true);
                    }
                } else {

                    data.articlePerformanceStateStatus(RateStateStatus.UNSAVED_CHANGE);

                    data.hideArticlePerformanceResetBtn(false);
                }
                break;
            case 'editorArticlePerformance':
                if (data.hasOwnProperty('default_editorArticlePerformance')) {

                    if(Number(data.default_editorArticlePerformance) !=  Number(data.editorArticlePerformance())) {

                        data.editorArticlePerformanceStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.minEditorArticlePerformance(null);
                        data.maxEditorArticlePerformance(null);
                        data.hideEditorArticlePerformanceResetBtn(false);
                    } else {

                        data.editorArticlePerformanceStateStatus(RateStateStatus.UNCHANGED);
                        data.minEditorArticlePerformance((data.default_idRateFormatEditorArticlePerformance() ? data.editorArticleCommission() : null));
                        data.hideEditorArticlePerformanceResetBtn(true);
                    }

                } else {

                    data.editorArticlePerformanceStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hideEditorArticlePerformanceResetBtn(false);
                }
            case 'payPerSession':
                if (data.hasOwnProperty('default_payPerSession')) {
                    if(Number(data.default_payPerSession()) !=  Number(data.payPerSession())) {
                        data.payPerSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hidePayPerSessionResetBtn(false);
                    } else {
                        data.payPerSessionStateStatus(RateStateStatus.UNCHANGED);
                        data.hidePayPerSessionResetBtn(true);
                    }
                } else {
                    data.payPerSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hidePayPerSessionResetBtn(false);
                }
                break;

            case 'minPayPerSession':
                if (data.hasOwnProperty('default_minPayPerSession')) {
                    if(Number(data.default_minPayPerSession()) !=  Number(data.minPayPerSession())) {
                        data.minPayPerSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hideMinPayPerSessionResetBtn(false);
                    } else {
                        data.minPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
                        data.hideMinPayPerSessionResetBtn(true);
                    }
                } else {
                    data.minPayPerSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hideMinPayPerSessionResetBtn(false);
                }
                break;

            case 'maxPayPerSession':
                if (data.hasOwnProperty('default_maxPayPerSession')) {
                    if(Number(data.default_maxPayPerSession()) !=  Number(data.maxPayPerSession())) {
                        data.maxPayPerSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hideMaxPayPerSessionResetBtn(false);
                    } else {
                        data.maxPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
                        data.hideMaxPayPerSessionResetBtn(true);
                    }
                } else {
                    data.maxPayPerSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hideMaxPayPerSessionResetBtn(false);
                }
                break;

            case 'payPerUSSession':
                if (data.hasOwnProperty('default_payPerUSSession')) {
                    if(Number(data.default_payPerUSSession()) !=  Number(data.payPerUSSession())) {
                        data.payPerUSSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hidePayPerUSSessionResetBtn(false);
                    } else {
                        data.payPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
                        data.hidePayPerUSSessionResetBtn(true);
                    }
                } else {
                    data.payPerUSSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hidePayPerUSSessionResetBtn(false);
                }
                break;

            case 'minPayPerUSSession':
                if (data.hasOwnProperty('default_minPayPerUSSession')) {
                    if(Number(data.default_minPayPerUSSession()) !=  Number(data.minPayPerUSSession())) {
                        data.minPayPerUSSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hideMinPayPerUSSessionResetBtn(false);
                    } else {
                        data.minPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
                        data.hideMinPayPerUSSessionResetBtn(true);
                    }
                } else {
                    data.minPayPerUSSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hideMinPayPerUSSessionResetBtn(false);
                }
                break;

            case 'maxPayPerUSSession':
                if (data.hasOwnProperty('default_maxPayPerUSSession')) {
                    if(Number(data.default_maxPayPerUSSession()) !=  Number(data.maxPayPerUSSession())) {
                        data.maxPayPerUSSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hideMaxPayPerUSSessionResetBtn(false);
                    } else {
                        data.maxPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
                        data.hideMaxPayPerUSSessionResetBtn(true);
                    }
                } else {
                    data.maxPayPerUSSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hideMaxPayPerUSSessionResetBtn(false);
                }
                break;

            case 'editorPayPerSession':
                if (data.hasOwnProperty('default_editorPayPerSession')) {
                    if(Number(data.default_editorPayPerSession()) !=  Number(data.editorPayPerSession())) {
                        data.editorPayPerSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hideEditorPayPerSessionResetBtn(false);
                    } else {
                        data.editorPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
                        data.hideEditorPayPerSessionResetBtn(true);
                    }
                } else {
                    data.editorPayPerSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hideEditorPayPerSessionResetBtn(false);
                }
                break;

            case 'minEditorPayPerSession':
                if (data.hasOwnProperty('default_minEditorPayPerSession')) {
                    if(Number(data.default_minEditorPayPerSession()) !=  Number(data.minEditorPayPerSession())) {
                        data.minEditorPayPerSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hideMinEditorPayPerSessionResetBtn(false);
                    } else {
                        data.minEditorPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
                        data.hideMinEditorPayPerSessionResetBtn(true);
                    }
                } else {
                    data.minEditorPayPerSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hideMinEditorPayPerSessionResetBtn(false);
                }
                break;

            case 'maxEditorPayPerSession':
                if (data.hasOwnProperty('default_maxEditorPayPerSession')) {
                    if(Number(data.default_maxEditorPayPerSession()) !=  Number(data.maxEditorPayPerSession())) {
                        data.maxEditorPayPerSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hideMaxEditorPayPerSessionResetBtn(false);
                    } else {
                        data.maxEditorPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
                        data.hideMaxEditorPayPerSessionResetBtn(true);
                    }
                } else {
                    data.maxEditorPayPerSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hideMaxEditorPayPerSessionResetBtn(false);
                }
                break;

            case 'editorPayPerUSSession':
                if (data.hasOwnProperty('default_editorPayPerUSSession')) {
                    if(Number(data.default_editorPayPerUSSession()) !=  Number(data.editorPayPerUSSession())) {
                        data.editorPayPerUSSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hideEditorPayPerUSSessionResetBtn(false);
                    } else {
                        data.editorPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
                        data.hideEditorPayPerUSSessionResetBtn(true);
                    }
                } else {
                    data.editorPayPerUSSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hideEditorPayPerUSSessionResetBtn(false);
                }
                break;

            case 'minEditorPayPerUSSession':
                if (data.hasOwnProperty('default_minEditorPayPerUSSession')) {
                    if(Number(data.default_minEditorPayPerUSSession()) !=  Number(data.minEditorPayPerUSSession())) {
                        data.minEditorPayPerUSSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hideMinEditorPayPerUSSessionResetBtn(false);
                    } else {
                        data.minEditorPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
                        data.hideMinEditorPayPerUSSessionResetBtn(true);
                    }
                } else {
                    data.minEditorPayPerUSSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hideMinEditorPayPerUSSessionResetBtn(false);
                }
                break;

            case 'maxEditorPayPerUSSession':
                if (data.hasOwnProperty('default_maxEditorPayPerUSSession')) {
                    if(Number(data.default_maxEditorPayPerUSSession()) !=  Number(data.maxEditorPayPerUSSession())) {
                        data.maxEditorPayPerUSSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                        data.hideMaxEditorPayPerUSSessionResetBtn(false);
                    } else {
                        data.maxEditorPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
                        data.hideMaxEditorPayPerUSSessionResetBtn(true);
                    }
                } else {
                    data.maxEditorPayPerUSSessionStateStatus(RateStateStatus.UNSAVED_CHANGE);
                    data.hideMaxEditorPayPerUSSessionResetBtn(false);
                }
                break;

            default:
                break;
        }
    }

    public onToggleRatePanel(section, data, event): void {

        switch (section) {
            case 'writerArticlePerformance':

                if (data.performancePanelOpen()) {
                    data.performancePanelOpen(false);
                    data.optionsWriterPerformanceToggleText('Add Options');
                    data.minArticlePerformance(null);
                    data.maxArticlePerformance(null);
                    data.minRateFilledType(MinPerformanceFilledType.CUSTOM);
                } else {

                    data.performancePanelOpen(true);
                    data.optionsWriterPerformanceToggleText('Remove Options');
                    if (data.minArticlePerformance() == null || data.minArticlePerformance() == undefined) {
                        if (Number(data.minArticlePerformance()) == Number(data.articleCommission())) {

                            data.minRateFilledType(MinPerformanceFilledType.AUTO);
                        } else {

                            data.minRateFilledType(MinPerformanceFilledType.CUSTOM);
                        }
                    }
                }
                break;
            case 'editorArticlePerformance':

                if (data.editorPerformancePanelOpen()) {
                    data.editorPerformancePanelOpen(false);
                    data.optionsEditorPerformanceToggleText('Add Options');
                    data.minEditorArticlePerformance(null);
                    data.maxEditorArticlePerformance(null);
                    data.editorMinRateFilledType(MinPerformanceFilledType.CUSTOM);
                } else {

                    data.editorPerformancePanelOpen(true);
                    data.optionsEditorPerformanceToggleText('Remove Options');
                    if (data.minEditorArticlePerformance() == null || data.minEditorArticlePerformance() == undefined) {
                        if (Number(data.minEditorArticlePerformance()) == Number(data.editorArticleCommission())) {

                            data.editorMinRateFilledType(MinPerformanceFilledType.AUTO);
                        } else {

                            data.editorMinRateFilledType(MinPerformanceFilledType.CUSTOM);
                        }
                    }
                }
                break;
            case 'writerArticleGroup':

                if (data.writerArticleGroupPanelOpen()) {
                    data.writerArticleGroupPanelOpen(false);
                    data.optionsWriterArticleGroupToggleText('Add Options');
                    data.minWriterArticleGroup(null);
                    data.maxWriterArticleGroup(null);
                    data.writerMinArticleGroupRateFilledType(MinPerformanceFilledType.CUSTOM);
                } else {

                    data.writerArticleGroupPanelOpen(true);
                    data.optionsWriterArticleGroupToggleText('Remove Options');
                    if (data.minWriterArticleGroup() == null || data.minWriterArticleGroup() == undefined) {
                        if (Number(data.minWriterArticleGroup()) == Number(data.articleCommission())) {

                            data.writerMinArticleGroupRateFilledType(MinPerformanceFilledType.AUTO);
                        } else {

                            data.writerMinArticleGroupRateFilledType(MinPerformanceFilledType.CUSTOM);
                        }
                    }
                }
                break;
            case 'editorArticleGroup':

                if (data.editorArticleGroupPanelOpen()) {
                    data.editorArticleGroupPanelOpen(false);
                    data.optionsEditorArticleGroupToggleText('Add Options');
                    data.minEditorArticleGroup(null);
                    data.maxEditorArticleGroup(null);
                    data.editorMinRateFilledType(MinPerformanceFilledType.CUSTOM);
                } else {

                    data.editorArticleGroupPanelOpen(true);
                    data.optionsEditorArticleGroupToggleText('Remove Options');
                    if (data.minEditorArticleGroup() == null || data.minEditorArticleGroup() == undefined) {
                        if (Number(data.minEditorArticleGroup()) == Number(data.editorArticleCommission())) {

                            data.editorMinRateFilledType(MinPerformanceFilledType.AUTO);
                        } else {

                            data.editorMinRateFilledType(MinPerformanceFilledType.CUSTOM);
                        }
                    }
                }
                break;
        }
    }


    public onClickRevertArticleCommission(data) {

        if (data.hasOwnProperty('default_articleCommission')) {

            data.articleCommission(data.default_articleCommission());
            data.articleCommissionStateStatus(RateStateStatus.UNCHANGED);

        } else {

            data.articleCommission(null);
            data.articleCommissionStateStatus(RateStateStatus.UNCHANGED);

        }
        data.hideArticleCommissionResetBtn(true);


        if (Number(data.articleCommission()) != Number(data.minArticlePerformance())) {
            data.minRateFilledType(MinPerformanceFilledType.CUSTOM);
        } else {

            data.minRateFilledType(MinPerformanceFilledType.AUTO);
        }
    }

    public onClickRevertPayPerSession(data) {
        if (data.hasOwnProperty('default_payPerSession')) {
            data.payPerSession(data.default_payPerSession());
            data.payPerSessionStateStatus(RateStateStatus.UNCHANGED);
        } else {
            data.payPerSession(null);
            data.payPerSessionStateStatus(RateStateStatus.UNCHANGED);
        }
        data.hidePayPerSessionResetBtn(true);
    }

    public onClickRevertMinPayPerSession(data) {
        if (data.hasOwnProperty('default_minPayPerSession')) {
            data.minPayPerSession(data.default_minPayPerSession());
            data.minPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
        } else {
            data.minPayPerSession(null);
            data.minPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
        }
        data.hideMinPayPerSessionResetBtn(true);
    }

    public onClickRevertMaxPayPerSession(data) {
        if (data.hasOwnProperty('default_maxPayPerSession')) {
            data.maxPayPerSession(data.default_maxPayPerSession());
            data.maxPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
        } else {
            data.maxPayPerSession(null);
            data.maxPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
        }
        data.hideMaxPayPerSessionResetBtn(true);
    }
    public onClickRevertPayPerUSSession(data) {
        if (data.hasOwnProperty('default_payPerUSSession')) {
            data.payPerUSSession(data.default_payPerUSSession());
            data.payPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
        } else {
            data.payPerUSSession(null);
            data.payPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
        }
        data.hidePayPerUSSessionResetBtn(true);
    }

    public onClickRevertMinPayPerUSSession(data) {
        if (data.hasOwnProperty('default_minPayPerUSSession')) {
            data.minPayPerUSSession(data.default_minPayPerUSSession());
            data.minPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
        } else {
            data.minPayPerUSSession(null);
            data.minPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
        }
        data.hideMinPayPerUSSessionResetBtn(true);
    }

    public onClickRevertMaxPayPerUSSession(data) {
        if (data.hasOwnProperty('default_maxPayPerUSSession')) {
            data.maxPayPerUSSession(data.default_maxPayPerUSSession());
            data.maxPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
        } else {
            data.maxPayPerUSSession(null);
            data.maxPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
        }
        data.hideMaxPayPerUSSessionResetBtn(true);
    }


    public onClickRevertEditorPayPerSession(data) {
        if (data.hasOwnProperty('default_editorPayPerSession')) {
            data.editorPayPerSession(data.default_editorPayPerSession());
            data.editorPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
        } else {
            data.editorPayPerSession(null);
            data.editorPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
        }
        data.hideEditorPayPerSessionResetBtn(true);
    }

    public onClickRevertMinEditorPayPerSession(data) {
        if (data.hasOwnProperty('default_minEditorPayPerSession')) {
            data.minEditorPayPerSession(data.default_minEditorPayPerSession());
            data.minEditorPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
        } else {
            data.minEditorPayPerSession(null);
            data.minEditorPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
        }
        data.hideMinEditorPayPerSessionResetBtn(true);
    }

    public onClickRevertMaxEditorPayPerSession(data) {
        if (data.hasOwnProperty('default_maxEditorPayPerSession')) {
            data.maxEditorPayPerSession(data.default_maxEditorPayPerSession());
            data.maxEditorPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
        } else {
            data.maxEditorPayPerSession(null);
            data.maxEditorPayPerSessionStateStatus(RateStateStatus.UNCHANGED);
        }
        data.hideMaxEditorPayPerSessionResetBtn(true);
    }
    public onClickRevertEditorPayPerUSSession(data) {
        if (data.hasOwnProperty('default_editorPayPerUSSession')) {
            data.editorPayPerUSSession(data.default_editorPayPerUSSession());
            data.editorPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
        } else {
            data.editorPayPerUSSession(null);
            data.editorPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
        }
        data.hideEditorPayPerUSSessionResetBtn(true);
    }

    public onClickRevertMinEditorPayPerUSSession(data) {
        if (data.hasOwnProperty('default_minEditorPayPerUSSession')) {
            data.minEditorPayPerUSSession(data.default_minEditorPayPerUSSession());
            data.minEditorPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
        } else {
            data.minEditorPayPerUSSession(null);
            data.minEditorPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
        }
        data.hideMinEditorPayPerUSSessionResetBtn(true);
    }

    public onClickRevertMaxEditorPayPerUSSession(data) {
        if (data.hasOwnProperty('default_maxEditorPayPerUSSession')) {
            data.maxEditorPayPerUSSession(data.default_maxEditorPayPerUSSession());
            data.maxEditorPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
        } else {
            data.maxEditorPayPerUSSession(null);
            data.maxEditorPayPerUSSessionStateStatus(RateStateStatus.UNCHANGED);
        }
        data.hideMaxEditorPayPerUSSessionResetBtn(true);
    }


    public onClickRevertArticlePerformance(data) {

        if (data.hasOwnProperty('default_articlePerformance')) {

            data.articlePerformance(data.default_articlePerformance());
        } else {

            data.articlePerformance(null);
        }

        if(data.default_idRateFormatArticlePerformance()){
            data.performancePanelOpen(true);
            data.optionsWriterPerformanceToggleText('Remove Options');
            data.minRateFilledType(MinPerformanceFilledType.AUTO);

        }
        data.minArticlePerformance(data.default_minArticlePerformance() ? data.default_minArticlePerformance() : (data.default_idRateFormatArticlePerformance() ? data.articleCommission() : null));
        data.articlePerformanceStateStatus(RateStateStatus.UNCHANGED);
        data.hideArticlePerformanceResetBtn(true);
    }


    public onClickRevertEditorArticlePerformance(data) {

        if (data.hasOwnProperty('default_editorArticlePerformance')) {

            data.editorArticlePerformance(data.default_editorArticlePerformance());
        } else {
            data.editorArticlePerformance(null);

        }
        data.minEditorArticlePerformance(data.default_minEditorArticlePerformance() ? data.default_minEditorArticlePerformance() : (data.default_idRateFormatEditorArticlePerformance() ? data.editorArticleCommission() : null));

        data.editorArticlePerformanceStateStatus(RateStateStatus.UNCHANGED);
        data.hideEditorArticlePerformanceResetBtn(true);
    }


    public onClickRevertEditorArticleCommission(data) {

        if (data.hasOwnProperty('default_editorArticleCommission')) {

            data.editorArticleCommission(data.default_editorArticleCommission());
        } else {
            data.editorArticleCommission(null);

        }
        data.editorArticleCommissionStateStatus(RateStateStatus.UNCHANGED);
        data.hideEditorArticleCommissionResetBtn(true);


        if (Number(data.editorArticleCommission()) != Number(data.minEditorArticlePerformance())) {
            data.editorMinRateFilledType(MinPerformanceFilledType.CUSTOM);
        } else {

            data.editorMinRateFilledType(MinPerformanceFilledType.AUTO);
        }
    }


    public onClickRevertTldrCommission(data) {

        if (data.hasOwnProperty('default_tldrCommission')) {

            data.tldrCommission(data.default_tldrCommission());
        } else {

            data.tldrCommission(null);
        }
        data.tldrCommissionStateStatus(RateStateStatus.UNCHANGED);
        data.hideTldrCommissionResetBtn(true);
    }


    public onChangeArticlePerformanceMinSource(section, data, event): void {

        switch (section) {
            case 'writerArticlePerformance':

                if (data.minRateFilledType() == MinPerformanceFilledType.AUTO) {
                    data.minRateFilledType(MinPerformanceFilledType.CUSTOM);
                    data.minArticlePerformance(data.default_minArticlePerformance());
                } else {
                    data.minRateFilledType(MinPerformanceFilledType.AUTO);
                    data.minArticlePerformance(data.articleCommission());
                }
                break;
            case 'editorArticlePerformance':

                if (data.editorMinRateFilledType() == MinPerformanceFilledType.AUTO) {
                    data.editorMinRateFilledType(MinPerformanceFilledType.CUSTOM);
                    data.minEditorArticlePerformance(data.default_minEditorArticlePerformance());

                } else {

                    data.editorMinRateFilledType(MinPerformanceFilledType.AUTO);
                    data.minEditorArticlePerformance(data.editorArticleCommission());
                }

                break;
            case 'writerArticleGroup':

                if (data.writerMinArticleGroupRateFilledType() == MinPerformanceFilledType.AUTO) {

                    data.writerMinArticleGroupRateFilledType(MinPerformanceFilledType.CUSTOM);
                    data.minWriterArticleGroup(null);
                } else {
                    data.writerMinArticleGroupRateFilledType(MinPerformanceFilledType.AUTO);
                    data.minWriterArticleGroup(data.articleCommission());
                }
                break;
            case 'editorArticleGroup':

                if (data.editorMinArticleGroupRateFilledType() == MinPerformanceFilledType.AUTO) {
                    data.editorMinArticleGroupRateFilledType(MinPerformanceFilledType.CUSTOM);
                    data.minEditorArticleGroup(null);

                } else {

                    data.editorMinArticleGroupRateFilledType(MinPerformanceFilledType.AUTO);
                    data.minEditorArticleGroup(data.editorArticleCommission());
                }

                break;
        }
    }


    public onClickConfirmEditTldrCommission(data, event) {

        let tldrCommission = null;
        let default_tldrCommission = null;

        if(data.tldrCommission) {
            tldrCommission = data.tldrCommission();
        }
        if(data.default_tldrCommission) {
            default_tldrCommission = data.default_tldrCommission();
        }

        if(!tldrCommission || parseFloat(tldrCommission) < 0){
            this.toggleDialogVisibility('negative-rate-dialog');
            data.tldrCommission(default_tldrCommission);
            data.default_tldrCommission(data.initialDefaultTldrCommissionValue);
        }

        data.editTldrCommission(false);
    }


    public areRatesValid(): boolean {


        let userRates = this.getTemplateViewModel().userRates();
        let paymentRateError = {};

        let numberRegex = /^\s*[+-]?(\d+|\.\d+|\d+\.\d+|\d+\.)(e[+-]?\d+)?\s*$/

        for (let ur of userRates) {

            let paymentRateErrorMessages = [];

            for (let r of ur.rates()) {

                if (r.showRow() == true) {

                    let commissionIsNumber = numberRegex.test(r.articleCommission());
                    let apIsNumber = numberRegex.test(r.articlePerformance());
                    let minIsNumber = numberRegex.test(r.minArticlePerformance());
                    let maxIsNumber = numberRegex.test(r.maxArticlePerformance());
                    let tldrIsNumber = numberRegex.test(r.tldrCommission());
                    let payPerSessionIsNumber = numberRegex.test(r.payPerSession());
                    let minPayPerSessionIsNumber = numberRegex.test(r.minPayPerSession());
                    let maxPayPerSessionIsNumber = numberRegex.test(r.maxPayPerSession());
                    let payPerUSSessionIsNumber = numberRegex.test(r.payPerUSSession());
                    let minPayPerUSSessionIsNumber = numberRegex.test(r.minPayPerUSSession());
                    let maxPayPerUSSessionIsNumber = numberRegex.test(r.maxPayPerUSSession());

                    let editorPayPerSessionIsNumber = numberRegex.test(r.editorPayPerSession());
                    let minEditorPayPerSessionIsNumber = numberRegex.test(r.minEditorPayPerSession());
                    let maxEditorPayPerSessionIsNumber = numberRegex.test(r.maxEditorPayPerSession());
                    let editorPayPerUSSessionIsNumber = numberRegex.test(r.editorPayPerUSSession());
                    let minEditorPayPerUSSessionIsNumber = numberRegex.test(r.minEditorPayPerUSSession());
                    let maxEditorPayPerUSSessionIsNumber = numberRegex.test(r.maxEditorPayPerUSSession());


                    if(r.articleCommission()) {
                        if (commissionIsNumber) {
                            if (Number(r.articleCommission()) < 0) {
                                paymentRateErrorMessages.push(r.category() + ': Author Article commission has to be a positive number.');
                            }
                        }  else {

                            paymentRateErrorMessages.push(r.category() + ': Author Article commission has to be a number.');
                        }
                    }

                    if(r.articlePerformance()) {
                        if (apIsNumber) {
                            if (Number(r.articlePerformance()) < 0) {
                                paymentRateErrorMessages.push(r.category() + ': Author Article performance has to be a positive number.');
                            }
                        }  else {

                            paymentRateErrorMessages.push(r.category() + ': Author Article performance has to be a number.');
                        }
                    }

                    if(r.minArticlePerformance()) {
                        if (minIsNumber) {
                            if (Number(r.minArticlePerformance()) <= 0) {

                                paymentRateErrorMessages.push(r.category() + ': Author Article performance threshold has to be a positive number.');
                            }
                        } else {

                            paymentRateErrorMessages.push(r.category() + ': Author Article performance threshold has to be a number.');
                        }
                    }

                    if(r.maxArticlePerformance()) {
                        if (maxIsNumber) {
                            if (Number(r.maxArticlePerformance()) <= 0) {
                                paymentRateErrorMessages.push(r.category() + ': Author Maximum Article performance has to be a positive number.');

                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Author Maximum Article performance has to be a number.');
                        }
                    }

                    if (minIsNumber && maxIsNumber) {
                        if (Number(r.minArticlePerformance()) > Number(r.maxArticlePerformance())) {
                            paymentRateErrorMessages.push(r.category() + ': Author Threshold have to be less than maximum.');
                        }
                    }


                    if(r.tldrCommission()) {
                        if (tldrIsNumber) {
                            if (Number(r.tldrCommission()) < 0) {
                                paymentRateErrorMessages.push(r.category() + ': Author Article Tldr has to be a positive number.');
                            }
                        }  else {

                            paymentRateErrorMessages.push(r.category() + ': Author Article Tldr has to be a number.');
                        }
                    }

                    let agIsNumber = numberRegex.test(r.writerArticleGroup());
                    let agMinIsNumber = numberRegex.test(r.minWriterArticleGroup());
                    let agMaxIsNumber = numberRegex.test(r.maxWriterArticleGroup());

                    if(r.writerArticleGroup()) {
                        if (agIsNumber) {
                            if (Number(r.writerArticleGroup()) < 0) {
                                paymentRateErrorMessages.push(r.category() + ': Author Article group has to be a positive number.');
                            }
                        }  else {

                            paymentRateErrorMessages.push(r.category() + ': Author Article performance has to be a number.');
                        }
                    }

                    if(r.minWriterArticleGroup()) {
                        if (agMinIsNumber) {
                            if (Number(r.minWriterArticleGroup()) <= 0) {

                                paymentRateErrorMessages.push(r.category() + ': Author Article group threshold has to be a positive number.');
                            }
                        } else {

                            paymentRateErrorMessages.push(r.category() + ': Author Article group threshold has to be a number.');
                        }
                    }

                    if(r.maxWriterArticleGroup()) {
                        if (agMaxIsNumber) {
                            if (Number(r.maxWriterArticleGroup()) <= 0) {
                                paymentRateErrorMessages.push(r.category() + ': Author Maximum Article group has to be a positive number.');

                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Author Maximum Article group has to be a number.');
                        }
                    }

                    if (agMinIsNumber && agMaxIsNumber) {
                        if (Number(r.minWriterArticleGroup()) > Number(r.maxWriterArticleGroup())) {
                            paymentRateErrorMessages.push(r.category() + ': Author Threshold have to be less than maximum.');
                        }
                    }


                    // Editor Validation
                    let editorCommissionIsNumber = numberRegex.test(r.editorArticleCommission());
                    let editorApIsNumber = numberRegex.test(r.editorArticlePerformance());
                    let editorMinIsNumber = numberRegex.test(r.minEditorArticlePerformance());
                    let editorMaxIsNumber = numberRegex.test(r.maxEditorArticlePerformance());

                    if(r.editorArticleCommission()) {
                        if (editorCommissionIsNumber) {
                            if (Number(r.editorArticleCommission()) < 0) {
                                paymentRateErrorMessages.push(r.category() + ': Editor Article commission has to be a positive number.');
                            }
                        }  else {

                            paymentRateErrorMessages.push(r.category() + ': Editor Article commission has to be a number.');
                        }
                    }
                    if(r.editorArticlePerformance()) {
                        if (editorApIsNumber) {
                            if (Number(r.editorArticlePerformance() < 0)) {

                                paymentRateErrorMessages.push(r.category() + ': Editor Article performance has to be a positive number.');
                            }
                        } else {

                            paymentRateErrorMessages.push(r.category() + ': Editor Article performance has to be a number.');
                        }
                    }

                    if(r.minEditorArticlePerformance()) {
                        if (editorMinIsNumber) {
                            if (Number(r.minEditorArticlePerformance()) <= 0) {

                                paymentRateErrorMessages.push(r.category() + ': Editor Article performance threshold has to be a positive number.');
                            }

                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Editor Article performance threshold has to be a number.');
                        }
                    }

                    if(r.maxEditorArticlePerformance()) {
                        if (editorMaxIsNumber) {
                            if ( Number(r.maxEditorArticlePerformance()) <= 0) {

                                paymentRateErrorMessages.push(r.category() + ': Maximum Editor Article performance has to be a positive number.');
                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Maximum Editor Article performance has to be a number.');
                        }
                    }

                    if (editorMinIsNumber && editorMaxIsNumber) {
                        if (Number(r.minEditorArticlePerformance()) > Number(r.maxEditorArticlePerformance())) {

                            paymentRateErrorMessages.push(r.category() + ': Editor Threshold have to be less than maximum.');
                        }
                    }


                    let agEditorIsNumber = numberRegex.test(r.editorArticleGroup());
                    let agEditorMinIsNumber = numberRegex.test(r.minEditorArticleGroup());
                    let agEditorMaxIsNumber = numberRegex.test(r.maxEditorArticleGroup());

                    if(r.editorArticleGroup()) {
                        if (agEditorIsNumber) {
                            if (Number(r.editorArticleGroup()) < 0) {
                                paymentRateErrorMessages.push(r.category() + ': Editor Article group has to be a positive number.');
                            }
                        }  else {

                            paymentRateErrorMessages.push(r.category() + ': Editor Article performance has to be a number.');
                        }
                    }

                    if(r.minEditorArticleGroup()) {
                        if (agEditorMinIsNumber) {
                            if (Number(r.minEditorArticleGroup()) <= 0) {

                                paymentRateErrorMessages.push(r.category() + ': Editor Article group threshold has to be a positive number.');
                            }
                        } else {

                            paymentRateErrorMessages.push(r.category() + ': Editor Article group threshold has to be a number.');
                        }
                    }

                    if(r.maxEditorArticleGroup()) {
                        if (agEditorMaxIsNumber) {
                            if (Number(r.maxEditorArticleGroup()) <= 0) {
                                paymentRateErrorMessages.push(r.category() + ': Editor Maximum Article group has to be a positive number.');

                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Editor Maximum Article group has to be a number.');
                        }
                    }

                    if (agEditorMinIsNumber && agEditorMaxIsNumber) {
                        if (Number(r.minEditorArticleGroup()) > Number(r.maxEditorArticleGroup())) {
                            paymentRateErrorMessages.push(r.category() + ': Editor Threshold have to be less than maximum.');
                        }
                    }
                    if(r.payPerSession()) {
                        if (payPerSessionIsNumber) {
                            if (Number(r.payPerSession()) < 0) {
                                paymentRateErrorMessages.push(r.category() + ': Pay Per Session has to be a positive number.');
                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Pay Per Session has to be a number.');
                        }
                    }

                    if(r.minPayPerSession()) {
                        if (minPayPerSessionIsNumber) {
                            if (Number(r.minPayPerSession()) <= 0) {
                                paymentRateErrorMessages.push(r.category() + ': Min Pay Per Session has to be a positive number.');
                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Min Pay Per Session has to be a number.');
                        }
                    }

                    if(r.maxPayPerSession()) {
                        if (maxPayPerSessionIsNumber) {
                            if (Number(r.maxPayPerSession()) <= 0) {
                                paymentRateErrorMessages.push(r.category() + ': Max Pay Per Session has to be a positive number.');
                            }
                            if (Number(r.maxPayPerSession()) > 2500) {
                                paymentRateErrorMessages.push(r.category() + ': Max Pay Per Session has to be a less than 2500.');
                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Max Pay Per Session has to be a number.');
                        }
                    }

                    if (minPayPerSessionIsNumber && maxPayPerSessionIsNumber) {
                        if (Number(r.minPayPerSession()) > Number(r.maxPayPerSession())) {
                            paymentRateErrorMessages.push(r.category() + ': Min Pay Per Session must be less than Max Pay Per Session.');
                        }
                    }
                    if(r.payPerUSSession()) {
                        if (payPerUSSessionIsNumber) {
                            if (Number(r.payPerUSSession()) < 0) {
                                paymentRateErrorMessages.push(r.category() + ': Pay Per US Session has to be a positive number.');
                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Pay Per US Session has to be a number.');
                        }
                    }

                    if(r.minPayPerUSSession()) {
                        if (minPayPerUSSessionIsNumber) {
                            if (Number(r.minPayPerUSSession()) <= 0) {
                                paymentRateErrorMessages.push(r.category() + ': Min Pay Per US Session has to be a positive number.');
                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Min Pay Per US Session has to be a number.');
                        }
                    }

                    if(r.maxPayPerUSSession()) {
                        if (maxPayPerUSSessionIsNumber) {
                            if (Number(r.maxPayPerUSSession()) <= 0) {
                                paymentRateErrorMessages.push(r.category() + ': Max Pay Per US Session has to be a positive number.');
                            }
                            if (Number(r.maxPayPerUSSession()) > 2500) {
                                paymentRateErrorMessages.push(r.category() + ': Max Pay Per US Session has to be a less than 2500.');
                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Max Pay Per US Session has to be a number.');
                        }
                    }

                    if (minPayPerUSSessionIsNumber && maxPayPerUSSessionIsNumber) {
                        if (Number(r.minPayPerUSSession()) > Number(r.maxPayPerUSSession())) {
                            paymentRateErrorMessages.push(r.category() + ': Min Pay Per US Session must be less than Max Pay Per US Session.');
                        }
                    }

                    if(r.editorPayPerSession()) {
                        if (editorPayPerSessionIsNumber) {
                            if (Number(r.editorPayPerSession()) < 0) {
                                paymentRateErrorMessages.push(r.category() + ': Pay Per Session has to be a positive number.');
                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Pay Per Session has to be a number.');
                        }
                    }

                    if(r.minEditorPayPerSession()) {
                        if (minEditorPayPerSessionIsNumber) {
                            if (Number(r.minEditorPayPerSession()) <= 0) {
                                paymentRateErrorMessages.push(r.category() + ': Min Pay Per Session has to be a positive number.');
                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Min Pay Per Session has to be a number.');
                        }
                    }

                    if(r.maxEditorPayPerSession()) {
                        if (maxEditorPayPerSessionIsNumber) {
                            if (Number(r.maxEditorPayPerSession()) <= 0) {
                                paymentRateErrorMessages.push(r.category() + ': Max Pay Per Session has to be a positive number.');
                            }
                            if (Number(r.maxEditorPayPerSession()) > 2500) {
                                paymentRateErrorMessages.push(r.category() + ': Max Pay Per Session has to be a less than 2500.');
                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Max Pay Per Session has to be a number.');
                        }
                    }

                    if (minEditorPayPerSessionIsNumber && maxEditorPayPerSessionIsNumber) {
                        if (Number(r.minEditorPayPerSession()) > Number(r.maxEditorPayPerSession())) {
                            paymentRateErrorMessages.push(r.category() + ': Min Pay Per Session must be less than Max Pay Per Session.');
                        }
                    }
                    if(r.editorPayPerUSSession()) {
                        if (editorPayPerUSSessionIsNumber) {
                            if (Number(r.editorPayPerUSSession()) < 0) {
                                paymentRateErrorMessages.push(r.category() + ': Pay Per US Session has to be a positive number.');
                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Pay Per US Session has to be a number.');
                        }
                    }

                    if(r.minEditorPayPerUSSession()) {
                        if (minEditorPayPerUSSessionIsNumber) {
                            if (Number(r.minEditorPayPerUSSession()) <= 0) {
                                paymentRateErrorMessages.push(r.category() + ': Min Pay Per US Session has to be a positive number.');
                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Min Pay Per US Session has to be a number.');
                        }
                    }

                    if(r.maxEditorPayPerUSSession()) {
                        if (maxEditorPayPerUSSessionIsNumber) {
                            if (Number(r.maxEditorPayPerUSSession()) <= 0) {
                                paymentRateErrorMessages.push(r.category() + ': Max Pay Per US Session has to be a positive number.');
                            }
                            if (Number(r.maxEditorPayPerUSSession()) > 2500) {
                                paymentRateErrorMessages.push(r.category() + ': Max Pay Per US Session has to be a less than 2500.');
                            }
                        } else {
                            paymentRateErrorMessages.push(r.category() + ': Max Pay Per US Session has to be a number.');
                        }
                    }

                    if (minEditorPayPerUSSessionIsNumber && maxEditorPayPerUSSessionIsNumber) {
                        if (Number(r.minEditorPayPerUSSession()) > Number(r.maxEditorPayPerUSSession())) {
                            paymentRateErrorMessages.push(r.category() + ': Min Pay Per US Session must be less than Max Pay Per US Session.');
                        }
                    }
                }
            }

            if (paymentRateErrorMessages.length > 0 ) {

                paymentRateError = {
                    brand: ur.brand,
                    messages: paymentRateErrorMessages
                };

                this.getTemplateViewModel().paymentRateError(paymentRateError);
                this.toggleDialogVisibility('negative-rate-dialog');
                return false;
            }
        }

        return true;
    }

    public onShowBrandRateCategoryPanel(data, event): void {

        let selectedCategories = [];
        data.selectedCategories().forEach((sc) => selectedCategories.push(sc));
        data.originalSelectedCategories(selectedCategories);
        data.isVisible(true);
    }

    public onClickCancelRateCategoriesPanel(data, event): void {

        let originalSelectedCategories = [];
        data.originalSelectedCategories().forEach((osc) => originalSelectedCategories.push(osc));
        data.selectedCategories(originalSelectedCategories);
        data.originalSelectedCategories([]);
        data.isVisible(false);
    }

    public onClickAcceptRateCategoriesPanel(data, event): void {

        let chosenCategories = data.selectedCategories();
        for(let rate of data.rates()){

            let  idCategory = parseInt(rate.idCategory());
            if (chosenCategories.includes(idCategory)) {

                rate.showRow(true);
            } else {

                rate.showRow(false);
            }
        }

        data.isVisible(false);
    }

    public setPaymentRateErrorMessages(messages: Array<string>): void {

        this.getTemplateViewModel().paymentRateErrorMsgs(messages);
    }

    public isBrandSelected(data) {

        let isSelected = false;
        let selectedBrands = this.getTemplateViewModel().selectedBrands();
        if(selectedBrands.includes(data.idBrand)) {
            isSelected = true;
        }

        return isSelected;
    }

    public onFilterCategories(data, parentData) {

        let isRateFound = false;
        for(let rate of parentData.rates()){
            let  idCategory = parseInt(rate.idCategory());

            if(data.id == idCategory) {
                isRateFound = true;
            }
        }

        if(!isRateFound){
            let newRate = {};
            newRate['idCategory'] = ko.observable(data.id);
            newRate['category'] = ko.observable(data.name);
            newRate['showRow'] = ko.observable(false);
            // writer article commission.
            newRate['default_articleCommission'] = ko.observable(data.default_articleCommission);
            newRate['articleCommission'] = ko.observable(data.default_articleCommission);
            newRate['articleCommissionStateStatus'] = ko.observable(data.default_articleCommission ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['hideArticleCommissionResetBtn'] = ko.observable(false);

            // writer tldr commission
            newRate['default_tldrCommission'] = ko.observable(data.default_tldrCommission);
            newRate['tldrCommission'] = ko.observable(data.default_tldrCommission);
            newRate['tldrCommissionStateStatus'] = ko.observable(data.default_tldrCommission ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['hideTldrCommissionResetBtn'] = ko.observable(false);

            // writer article performance.
            newRate['default_articlePerformance'] = ko.observable(data.default_articlePerformance);
            newRate['default_minArticlePerformance'] = ko.observable(data.default_minArticlePerformance);
            newRate['default_maxArticlePerformance'] = ko.observable(data.default_maxArticlePerformance);
            newRate['articlePerformance'] = ko.observable(data.default_articlePerformance);
            newRate['articlePerformanceStateStatus'] = ko.observable(data.default_articlePerformance ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['minRateFilledType'] = ko.observable(data.idRateFormatPerformance ? MinPerformanceFilledType.AUTO : ( data.default_idRateFormatArticlePerformance ? MinPerformanceFilledType.AUTO : MinPerformanceFilledType.CUSTOM));
            newRate['default_idRateFormatArticlePerformance'] = ko.observable(data.default_idRateFormatArticlePerformance);
            if(data.default_idRateFormatArticlePerformance){
                newRate['optionsWriterPerformanceToggleText'] = ko.observable("Remove Options");
            } else {
                newRate['optionsWriterPerformanceToggleText'] = ko.observable("Add Options");
            }

            newRate['hideArticlePerformanceResetBtn'] = ko.observable(true);
            newRate['minArticlePerformance'] = ko.observable(data.default_minArticlePerformance ? data.default_minArticlePerformance : (data.default_idRateFormatArticlePerformance ? newRate['articleCommission']() : null));
            newRate['maxArticlePerformance'] = ko.observable(data.default_maxArticlePerformance);
            newRate['performancePanelOpen'] = ko.observable(((data.default_minArticlePerformance || data.default_maxArticlePerformance || newRate['minArticlePerformance']()) ? true: false));

            // editor commission
            newRate['default_editorArticleCommission'] = ko.observable(data.default_editorArticleCommission);
            newRate['editorArticleCommission'] = ko.observable(data.default_editorArticleCommission);
            newRate['editorArticleCommissionStateStatus'] = ko.observable(data.default_editorArticleCommission ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['hideEditorArticleCommissionResetBtn'] = ko.observable(false);

            // editor article performance.
            newRate['default_editorArticlePerformance'] = ko.observable(data.default_editorArticlePerformance);
            newRate['editorArticlePerformance'] = ko.observable(data.default_editorArticlePerformance);
            newRate['editorArticlePerformanceStateStatus'] = ko.observable(data.default_editorArticlePerformance ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['editorMinRateFilledType'] = ko.observable(data.default_idRateFormatEditorArticlePerformance ? MinPerformanceFilledType.CUSTOM : MinPerformanceFilledType.CUSTOM);
            newRate['default_idRateFormatEditorArticlePerformance'] = ko.observable(data.default_idRateFormatEditorArticlePerformance);
            newRate['minEditorArticlePerformance'] = ko.observable(data.default_minEditorArticlePerformance ? data.default_minArticlePerformance : (data.default_idRateFormatEditorArticlePerformance ? newRate['editorArticleCommission']() : null));
            newRate['maxEditorArticlePerformance'] = ko.observable(data.default_maxEditorArticlePerformance);
            newRate['optionsEditorPerformanceToggleText'] = ko.observable("Add Options");
            newRate['hideEditorArticlePerformanceResetBtn'] = ko.observable(true);
            newRate['editorPerformancePanelOpen'] = ko.observable(((data.default_minEditorArticlePerformance || data.default_maxEditorArticlePerformance || newRate['minEditorArticlePerformance']()) ? true: false));

            // writer article group settings
            newRate['writerArticleGroupPanelOpen'] = ko.observable(false);
            newRate['writerArticleGroup'] = ko.observable(data.default_articleGroup);
            newRate['writerArticleGroupStateStatus'] = ko.observable(false);
            newRate['optionsWriterArticleGroupToggleText'] = ko.observable("Add Options");
            newRate['hideWriterArticleGroupResetBtn'] = ko.observable(false);
            newRate['minWriterArticleGroup'] = ko.observable(data.minArticleGroup);
            newRate['writerMinArticleGroupRateFilledType'] = ko.observable(MinPerformanceFilledType.CUSTOM);
            newRate['maxWriterArticleGroup'] = ko.observable(data.maxArticleGroup);
            newRate['writerArticleGroupDisabled'] = ko.observable((data.id != 0));

            // per session article group settings
            newRate['default_payPerSession'] = ko.observable(data.default_payPerSession);
            newRate['default_minPayPerSession'] = ko.observable(data.default_minPayPerSession);
            newRate['default_maxPayPerSession'] = ko.observable(data.default_maxPayPerSession);
            newRate['payPerSession'] = ko.observable(data.default_payPerSession);
            newRate['minPayPerSession'] = ko.observable(data.default_minPayPerSession);
            newRate['maxPayPerSession'] = ko.observable(data.default_maxPayPerSession);
            newRate['payPerSessionStateStatus'] = ko.observable(data.default_payPerSession ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['minPayPerSessionStateStatus'] = ko.observable(data.default_minPayPerSession ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['maxPayPerSessionStateStatus'] = ko.observable(data.default_maxPayPerSession ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['hidePayPerSessionResetBtn'] = ko.observable(true);
            newRate['hideMinPayPerSessionResetBtn'] = ko.observable(true);
            newRate['hideMaxPayPerSessionResetBtn'] = ko.observable(true);


            // per US session article group settings
            newRate['default_payPerUSSession'] = ko.observable(data.default_payPerUSSession);
            newRate['default_minPayPerUSSession'] = ko.observable(data.default_minPayPerUSSession);
            newRate['default_maxPayPerUSSession'] = ko.observable(data.default_maxPayPerUSSession);
            newRate['payPerUSSession'] = ko.observable(data.default_payPerUSSession);
            newRate['minPayPerUSSession'] = ko.observable(data.default_minPayPerUSSession);
            newRate['maxPayPerUSSession'] = ko.observable(data.default_maxPayPerUSSession);
            newRate['payPerUSSessionStateStatus'] = ko.observable(data.default_payPerUSSession ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['minPayPerUSSessionStateStatus'] = ko.observable(data.default_minPayPerUSSession ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['maxPayPerUSSessionStateStatus'] = ko.observable(data.default_maxPayPerUSSession ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['hidePayPerUSSessionResetBtn'] = ko.observable(true);
            newRate['hideMinPayPerUSSessionResetBtn'] = ko.observable(true);
            newRate['hideMaxPayPerUSSessionResetBtn'] = ko.observable(true);

            // editor per session article group settings
            newRate['default_editorPayPerSession'] = ko.observable(data.default_editorPayPerSession);
            newRate['default_minEditorPayPerSession'] = ko.observable(data.default_minEditorPayPerSession);
            newRate['default_maxEditorPayPerSession'] = ko.observable(data.default_maxEditorPayPerSession);
            newRate['editorPayPerSession'] = ko.observable(data.default_editorPayPerSession);
            newRate['minEditorPayPerSession'] = ko.observable(data.default_minEditorPayPerSession);
            newRate['maxEditorPayPerSession'] = ko.observable(data.default_maxEditorPayPerSession);
            newRate['editorPayPerSessionStateStatus'] = ko.observable(data.default_editorPayPerSession ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['minEditorPayPerSessionStateStatus'] = ko.observable(data.default_minEditorPayPerSession ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['maxEditorPayPerSessionStateStatus'] = ko.observable(data.default_maxEditorPayPerSession ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['hideEditorPayPerSessionResetBtn'] = ko.observable(true);
            newRate['hideMinEditorPayPerSessionResetBtn'] = ko.observable(true);
            newRate['hideMaxEditorPayPerSessionResetBtn'] = ko.observable(true);


            // editor per US session article group settings
            newRate['default_editorPayPerUSSession'] = ko.observable(data.default_editorPayPerUSSession);
            newRate['default_minEditorPayPerUSSession'] = ko.observable(data.default_minEditorPayPerUSSession);
            newRate['default_maxEditorPayPerUSSession'] = ko.observable(data.default_maxEditorPayPerUSSession);
            newRate['editorPayPerUSSession'] = ko.observable(data.default_editorPayPerUSSession);
            newRate['minEditorPayPerUSSession'] = ko.observable(data.default_minEditorPayPerUSSession);
            newRate['maxEditorPayPerUSSession'] = ko.observable(data.default_maxEditorPayPerUSSession);
            newRate['editorPayPerUSSessionStateStatus'] = ko.observable(data.default_editorPayPerUSSession ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['minEditorPayPerUSSessionStateStatus'] = ko.observable(data.default_minEditorPayPerUSSession ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['maxEditorPayPerUSSessionStateStatus'] = ko.observable(data.default_maxEditorPayPerUSSession ? RateStateStatus.UNCHANGED: RateStateStatus.NOT_USED);
            newRate['hideEditorPayPerUSSessionResetBtn'] = ko.observable(true);
            newRate['hideMinEditorPayPerUSSessionResetBtn'] = ko.observable(true);
            newRate['hideMaxEditorPayPerUSSessionResetBtn'] = ko.observable(true);

            // editor article group settings
            newRate['editorArticleGroupPanelOpen'] = ko.observable(false);
            newRate['editorArticleGroup'] = ko.observable(data.default_editorArticleGroup);
            newRate['editorArticleGroupStateStatus'] = ko.observable(false);
            newRate['optionsEditorArticleGroupToggleText'] = ko.observable("Add Options");
            newRate['hideEditorArticleGroupResetBtn'] = ko.observable(false);
            newRate['minEditorArticleGroup'] = ko.observable(data.minEditorArticleGroup);
            newRate['editorMinArticleGroupRateFilledType'] = ko.observable(MinPerformanceFilledType.CUSTOM);
            newRate['maxEditorArticleGroup'] = ko.observable(data.maxEditorArticleGroup);
            newRate['editorArticleGroupDisabled'] =  ko.observable((data.id != 0));
            newRate['writerHasUSSession'] =  ko.observable(false);
            newRate['editorHasUSSession'] =  ko.observable(false);

            newRate['payPerSessionGroupDisabled'] =  ko.observable((data.idSystem == 2));
            newRate['editorPayPerSessionGroupDisabled'] =  ko.observable((data.idSystem == 2));


            let minPerformanceTooltipBtn = new infoButton_template('minPerformanceTooltipBtn_' + parentData.brand  + '_' + data.name, this.getTemplateViewModel(), this.caller);
            minPerformanceTooltipBtn.setTitle('Writer Performance Minimum');
            minPerformanceTooltipBtn.setContent(this.maxTooltipButtonContent);

            let maxPerformanceTooltipBtn = new infoButton_template('maxPerformanceTooltipBtn_' + parentData.brand  + '_' + data.name, this.getTemplateViewModel(), this.caller);
            maxPerformanceTooltipBtn.setTitle('Writer Performance Maximum');
            maxPerformanceTooltipBtn.setContent(this.minTooltipButtonContent);

            let editorMinPerformanceTooltipBtn = new infoButton_template('editorMinPerformanceTooltipBtn_' + parentData.brand  + '_' + data.name, this.getTemplateViewModel(), this.caller);
            editorMinPerformanceTooltipBtn.setTitle('Editor Performance Minimum');
            editorMinPerformanceTooltipBtn.setContent(this.maxTooltipButtonContent);

            let editorMaxPerformanceTooltipBtn = new infoButton_template('editorMaxPerformanceTooltipBtn_' + parentData.brand  + '_' + data.name, this.getTemplateViewModel(), this.caller);
            editorMaxPerformanceTooltipBtn.setTitle('Editor Performance Maximum');
            editorMaxPerformanceTooltipBtn.setContent(this.maxTooltipButtonContent);

            newRate['minPerformanceTooltip'] = minPerformanceTooltipBtn;
            newRate['maxPerformanceTooltip'] = maxPerformanceTooltipBtn;
            newRate['editorMinPerformanceTooltip'] = editorMinPerformanceTooltipBtn;
            newRate['editorMaxPerformanceTooltip'] = editorMaxPerformanceTooltipBtn;

            let writerMinArticleGroupTooltipBtn = new infoButton_template('writerMinArticleGroupTooltipBtn_' + parentData.brand  + '_' + data.category, this.getTemplateViewModel(), this.caller);
            writerMinArticleGroupTooltipBtn.setTitle('Writer Article Group Minimum');
            writerMinArticleGroupTooltipBtn.setContent(this.minTooltipButtonContent);

            let writerMaxArticleGroupTooltipBtn = new infoButton_template('writerMaxArticleGroupTooltipBtn_' + parentData.brand  + '_' + data.category, this.getTemplateViewModel(), this.caller);
            writerMaxArticleGroupTooltipBtn.setTitle('Writer Article Group Maximum');
            writerMaxArticleGroupTooltipBtn.setContent(this.maxTooltipButtonContent);


            let editorMinArticleGroupTooltipBtn = new infoButton_template('editorMinArticleGroupTooltipBtn_' + parentData.brand  + '_' + data.category, this.getTemplateViewModel(), this.caller);
            editorMinArticleGroupTooltipBtn.setTitle('Editor Article Group Minimum');
            editorMinArticleGroupTooltipBtn.setContent(this.minTooltipButtonContent);

            let editorMaxArticleGroupTooltipBtn = new infoButton_template('editorMaxArticleGroupTooltipBtn_' + parentData.brand  + '_' + data.category, this.getTemplateViewModel(), this.caller);
            editorMaxArticleGroupTooltipBtn.setTitle('Editor Article Group Maximum');
            editorMaxArticleGroupTooltipBtn.setContent(this.maxTooltipButtonContent);

            newRate['minWriterArticleGroupTooltip'] = writerMinArticleGroupTooltipBtn;
            newRate['maxWriterArticleGroupTooltip'] = writerMaxArticleGroupTooltipBtn;
            newRate['editorMinArticleGroupTooltip'] = editorMinArticleGroupTooltipBtn;
            newRate['editorMaxArticleGroupTooltip'] = editorMaxArticleGroupTooltipBtn;

            if (data.id == 0) {

                parentData.rates.unshift(newRate);
            } else {

                parentData.rates.push(newRate);
            }
        }
    }

    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions);
    }


    public setBrandInfo(brandInfo){

        brandInfo = this.addStartDatePicker(brandInfo, brandInfo.brand.id);
        brandInfo = this.createUserSlugToolTip(brandInfo, brandInfo.brand.id);
        brandInfo = this.createAuthorToneToolTip(brandInfo, brandInfo.brand.id);
        brandInfo = this.createAuthorTopicExpertise(brandInfo, brandInfo.brand.id);
        brandInfo = this.createUserTopicExpertiseToolTip(brandInfo, brandInfo.brand.id);
        this.getTemplateViewModel().brandInfo(brandInfo);
    }

    public addStartDatePicker(bi, id){

        if(!bi.startDatePicker){
            bi.startDatePicker = new filterSingleDate_template(`startDatePicker_${id}`, this.getTemplateViewModel(), this.caller);
        }
        return bi;
    }

    protected generateBrandDropzone(brandInfo){

        brandInfo.forEach((value, index) => {

            let myDropzone = new Dropzone("div#drop-zone"+value.brand.id, { url: "/api/user/uploadImage/", maxFiles: 1, acceptedFiles: "image/jpeg,image/png,image/gif"});
            let myDropzoneBanner = new Dropzone("div#drop-zone-banner"+value.brand.id, { url: "/api/user/uploadImage/", maxFiles: 1, addRemoveLinks: true, acceptedFiles: "image/jpeg,image/png,image/gif"});

            let _this = this;

            /*myDropzone.on("complete", function(file) {
            });*/

            myDropzone.on("success", function(file, serverFileName) {

                let responseParsed = serverFileName;
                let brandInfo = _this.getTemplateViewModel().brandInfo();
                for(let b of brandInfo){

                    if(b.brand.id == responseParsed.idBrand){
                        b.pictureUrl = responseParsed.data;
                    }
                }
                _this.getTemplateViewModel().brandInfo(brandInfo);
            });
            myDropzone.on("addedfile", function(file) {
                if (this.files.length > 1) {
                    this.removeFile(this.files[0]);
                }
            });

            myDropzone.on('sending', function(file, xhr, formData){
                formData.append('idBrand', this.element.id.replace("drop-zone",""));
            });

            if(value.pictureUrl){
                let filename = this.basename(value.pictureUrl, "/");
                let path = '/authorimages/' + value.brand.name.toLowerCase() + "/" + filename;
                let mockFile = { name: path, size: parseInt("264560")};

                myDropzone.emit("addedfile", mockFile);
                myDropzone.createThumbnailFromUrl(mockFile, mockFile.name);
                myDropzone.emit("complete", mockFile);
                myDropzone.files.push(mockFile);
            }

            //Repeat for banner
            myDropzoneBanner.on("success", function(file, serverFileName) {

                let responseParsed = serverFileName;
                let brandInfo = _this.getTemplateViewModel().brandInfo();
                for(let b of brandInfo){

                    if(b.brand.id == responseParsed.idBrand){
                        b.bannerPictureUrl = responseParsed.data;
                    }
                }
                _this.getTemplateViewModel().brandInfo(brandInfo);
            });
            myDropzoneBanner.on("addedfile", function(file) {
                if (this.files.length > 1) {
                    this.removeFile(this.files[0]);
                }
            });
            myDropzoneBanner.on("removedfile", function(file) {

                let idElement = this.element.id;
                idElement = idElement.replace("drop-zone-banner", "");

                if(idElement){

                    let brandInfo = _this.getTemplateViewModel().brandInfo();
                    for(let b of brandInfo){

                        if(b.brand.id == idElement){
                            b.bannerPictureUrl = null;
                        }
                    }
                    _this.getTemplateViewModel().brandInfo(brandInfo);
                }
            });

            myDropzoneBanner.on('sending', function(file, xhr, formData){
                formData.append('idBrand', this.element.id.replace("drop-zone-banner",""));
            });

            if(value.bannerPictureUrl){
                let filename = this.basename(value.bannerPictureUrl, "/");
                let path = '/authorimages/' + value.brand.name.toLowerCase() + "/" + filename;
                let mockFile = { name: path, size: parseInt("264560")};

                myDropzoneBanner.emit("addedfile", mockFile);
                myDropzoneBanner.createThumbnailFromUrl(mockFile, mockFile.name);
                myDropzoneBanner.emit("complete", mockFile);
                myDropzoneBanner.files.push(mockFile);
            }
        });

    }

    protected setAuthorDetails(authorDetails, userBrands, brandJobTitles){

        let allUserBrands = userBrands;

        authorDetails.forEach((item, key) =>{

            authorDetails[key].isAuthorDetailActive = ko.observable(true);
            if(!allUserBrands.some(obj => obj.id === item.brand.id)){
                allUserBrands.push(item.brand);
            }
        });

        allUserBrands.forEach(value => {

            // brand specific job titles
            let brandJobTitleList = [];
            if(brandJobTitles.hasOwnProperty(value.id)){
                brandJobTitleList = brandJobTitles[value.id];
            }

            let index = authorDetails.map(item => item.brand.id).indexOf(value.id);

            if(index == -1){

                let authorDetail = {
                    id: null,
                    brand: value,
                    brandJobTitleList: brandJobTitleList,
                    bio: null,
                    pictureUrl: null,
                    bannerPictureUrl: null,
                    isIndex: true,
                    isAuthorDetailActive: ko.observable(false),
                    niceName: slugify(this.getTemplateViewModel().fullName()),
                    displayName: this.getTemplateViewModel().fullName(),
                    jobTitle: null,
                    authorQuestion1: null,
                    authorInfo1: null,
                    authorQuestion2: null,
                    authorInfo2: null,
                    authorQuestion3: null,
                    authorInfo3: null,
                    pinnedArticles: ko.observableArray([]),
                    embeds: ko.observableArray([]),
                    seoBio : null,
                    authorTone: null,
                    topicExpertiseList: ko.observableArray([]),
                    topicExpertiseMaxItemReached: null

                };

                authorDetail.topicExpertiseMaxItemReached = ko.computed(function () {
                    return authorDetail.topicExpertiseList().length >= 3
                }, authorDetail)

                authorDetail = this.addStartDatePicker(authorDetail, authorDetail.brand.id);
                authorDetail = this.createUserSlugToolTip(authorDetail, authorDetail.brand.id);
                authorDetail = this.createAuthorToneToolTip(authorDetail, authorDetail.brand.id);
                authorDetail = this.createUserTopicExpertiseToolTip(authorDetail, authorDetail.brand.id);
                authorDetail = this.createAuthorTopicExpertise(authorDetail, authorDetail.brand.id);
                authorDetails.push({...authorDetail });
            }else{

                let authorDetail = authorDetails[index];
                authorDetail.authorInfo1 = null;
                authorDetail.authorInfo2 = null;
                authorDetail.authorInfo3 = null;

                authorDetail.authorQuestion1 = null;
                authorDetail.authorQuestion2 = null;
                authorDetail.authorQuestion3 = null;

                if(authorDetail.additionalAuthorInfo){

                    let decodedAuthorInfo = JSON.parse(authorDetail.additionalAuthorInfo);
                    if (decodedAuthorInfo){

                        if(decodedAuthorInfo[0]){

                            authorDetail.authorQuestion1 = decodedAuthorInfo[0]["Q"];
                            authorDetail.authorInfo1 = decodedAuthorInfo[0]["A"];
                        }
                        if(decodedAuthorInfo[1]){

                            authorDetail.authorQuestion2 = decodedAuthorInfo[1]["Q"];
                            authorDetail.authorInfo2 = decodedAuthorInfo[1]["A"];
                        }
                        if(decodedAuthorInfo[2]){

                            authorDetail.authorQuestion3 = decodedAuthorInfo[2]["Q"];
                            authorDetail.authorInfo3 = decodedAuthorInfo[2]["A"];
                        }
                    }
                }

                authorDetail.pinnedArticles = ko.observableArray(authorDetail.pinnedArticles || []);
                authorDetail.embeds = ko.observableArray(authorDetail.embeds || []);


                authorDetail = this.addStartDatePicker(authorDetail, authorDetail.brand.id);
                authorDetail = this.createUserSlugToolTip(authorDetail, authorDetail.brand.id);
                authorDetail = this.createAuthorToneToolTip(authorDetail, authorDetail.brand.id);
                authorDetail = this.createUserTopicExpertiseToolTip(authorDetail, authorDetail.brand.id);
                authorDetail = this.createAuthorTopicExpertise(authorDetail, authorDetail.brand.id);

                authorDetail.topicExpertiseList = ko.observableArray(authorDetail.topicExpertiseList || [])

                authorDetail.topicExpertiseMaxItemReached = ko.computed(function () {
                    return authorDetail.topicExpertiseList().length >= 3
                }, authorDetail)

                if(authorDetail.topicExpertise){
                    authorDetail.topicExpertise.setIsGlobalLockEnabled(authorDetail.topicExpertiseMaxItemReached())
                }

                if(!brandJobTitleList.some(item => item === authorDetail.jobTitle)){
                    brandJobTitleList.push(authorDetail.jobTitle);
                }
                authorDetail.brandJobTitleList = brandJobTitleList;

                authorDetails[index] = {...authorDetail };
            }
        });

        this.getTemplateViewModel().brandInfo(authorDetails);
        this.generateBrandDropzone(authorDetails);
    }

    protected basename(str, sep) {
        return str.substr(str.lastIndexOf(sep) + 1);
    }

    //Not sure why this isn't firing but this needs to be resolved
    protected onClickInitBrandCKE(data){

        let idBrand = data.brand.id;
        let isAuthorDetailActive = data.isAuthorDetailActive()

        //Used for on load to not try to init an element that doesn't exist yet
        let currentElement = document.getElementById("bio-" + idBrand);

        //Used for when the CKE already init, not to try doing it again
        let ckeElement = document.getElementById("cke_bio-" + idBrand);

        if(isAuthorDetailActive && currentElement && !ckeElement){

            this.caller.initCkEditor('bio-' + idBrand);

            this.initAuthorInfoCKE(idBrand, 1);
        }
        return true;
    }

    protected addSite(){

        this.getTemplateViewModel().isRemoveSiteVisible(true);

        if(!this.getTemplateViewModel().isWebsite2Visible()){

            this.getTemplateViewModel().isWebsite2Visible(true);
            return true;
        }

        if(!this.getTemplateViewModel().isWebsite3Visible()){

            this.getTemplateViewModel().isWebsite3Visible(true);
            this.getTemplateViewModel().isAddSiteVisible(false);
            return true;
        }
    }

    protected removeSite(){

        this.getTemplateViewModel().isAddSiteVisible(true);

        if(this.getTemplateViewModel().isWebsite3Visible()){

            this.getTemplateViewModel().website3("");
            this.getTemplateViewModel().isWebsite3Visible(false);
            return true;
        }
        if(this.getTemplateViewModel().isWebsite2Visible()){

            this.getTemplateViewModel().website2("");
            this.getTemplateViewModel().isWebsite2Visible(false);
            this.getTemplateViewModel().isRemoveSiteVisible(false);
            return true;
        }
    }

    protected setAdditionalAuthorInfo(userConfigs){

        this.getTemplateViewModel().additionalAuthorInfo(userConfigs)
    }

    public setSocialMediaFilterItems(){

        let socialMediaList = [
            {"id": "facebook", "name":"Facebook"},
            {"id": "instagram", "name":"Instagram"},
            {"id": "twitter", "name":"Twitter"},
            {"id": "linkedIn", "name":"LinkedIn"},
            {"id": "tiktok", "name":"Tiktok"},
            {"id": "muckrack", "name":"Muck Rack"},
            {"id": "openCritic", "name":"OpenCritic"},
            {"id": "mastodon", "name":"Mastodon"},
            {"id": "threads", "name":"Threads"},
            {"id": "weChat", "name":"WeChat"},
            {"id": "youtube", "name":"YouTube"},
            {"id": "twitch", "name":"Twitch"},
            {"id": "discord", "name":"Discord"},
            {"id": "pinterest", "name":"Pinterest"},
            {"id": "whatsApp", "name":"WhatsApp"},
            {"id": "reddit", "name":"Reddit"},
            {"id": "snapchat", "name":"Snapchat"},
            {"id": "substack", "name":"Substack"},
            {"id": "medium", "name":"Medium"},
            {"id": "tumblr", "name":"Tumblr"},
            {"id": "telegram", "name":"Telegram"},
            {"id": "signalSocial", "name":"Signal"},
            {"id": "sm_email", "name":"Email"},
            {"id": "websites", "name":"Websites"}
        ];

        this.socialMediaFilter.setItems(socialMediaList);
    }

    protected setSocialMediaSelectedItems(user){

        let selectedItems = [];

        selectedItems.push({"id":"twitter"});
        selectedItems.push({"id":"instagram"});
        selectedItems.push({"id":"facebook"});
        selectedItems.push({"id":"linkedIn"});
        if(user.tiktok){ selectedItems.push({"id":"tiktok"}); }
        if(user.muckrack){selectedItems.push({"id":"muckrack"});}
        if(user.openCritic){selectedItems.push({"id":"openCritic"});}
        if(user.mastodon){selectedItems.push({"id":"mastodon"});}
        if(user.threads){ selectedItems.push({"id":"threads"}); }
        if(user.wechat){ selectedItems.push({"id":"weChat"}); }
        if(user.youtube){ selectedItems.push({"id":"youtube"}); }
        if(user.twitch){ selectedItems.push({"id":"twitch"}); }
        if(user.discord){ selectedItems.push({"id":"discord"}); }
        if(user.pinterest){ selectedItems.push({"id":"pinterest"}); }
        if(user.whatsapp){ selectedItems.push({"id":"whatsApp"}); }
        if(user.reddit){ selectedItems.push({"id":"reddit"}); }
        if(user.snapchat){ selectedItems.push({"id":"snapchat"}); }
        if(user.substack){ selectedItems.push({"id":"substack"}); }
        if(user.medium){ selectedItems.push({"id":"medium"}); }
        if(user.tumblr){ selectedItems.push({"id":"tumblr"}); }
        if(user.signalSocial){ selectedItems.push({"id":"signalSocial"}); }
        if(user.telegram){ selectedItems.push({"id":"telegram"}); }
        if(user.email){ selectedItems.push({"id":"sm_email"}); }
        if(user.websites){ selectedItems.push({"id":"websites"}); }

        this.socialMediaFilter.setSelectedItems(selectedItems);

        let idSelectedItems = [];
        selectedItems.forEach(function(item){

            idSelectedItems.push(item.id);
        });
        this.getTemplateViewModel().socialMedia(idSelectedItems);
    }

    protected initAuthorInfoCKE(idBrand, index){

        let currentAuthorInfo = document.getElementById("authorInfo-" + index + "-" + idBrand);
        let ckeAuthorInfo = document.getElementById("cke_authorInfo-" + index + "-" + idBrand);

        if(currentAuthorInfo && !ckeAuthorInfo && index < 4){

            this.caller.initCkEditor("authorInfo-" + index + "-" + idBrand);
            this.initAuthorInfoCKE(idBrand, ++index);
        }
    }

    private getFormattedEasternTimeZoneDateTime(date?: Date): any {

        if (!date) {

            date = this.createEasternTimeZoneDateTime();
        }
        if(typeof date == "string"){

            date = new Date(date);
        }
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        return year + '/' + this.padInteger(month,2) + '/' + this.padInteger(day,2);
    }

    private createEasternTimeZoneDateTime(date?: Date): Date {

        if (!date) {

            date = new Date();
        }
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        //checks if DST is currently being observed, adjusts offset accordingly
        let easternTimeOffset = this.isDstObserved(date) ? -240 : -300;
        date.setMinutes(date.getMinutes() + easternTimeOffset);
        return date;
    }

    private padInteger(number: number, size: number){

        let s = number+"";
        while (s.length < size) s = "0" + s;
        return s;
    }

    public isDstObserved (date?: Date) {

        let jan = new Date(date.getFullYear(), 0, 1);
        let jul = new Date(date.getFullYear(), 6, 1);
        let stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
        return date.getTimezoneOffset() < stdTimezoneOffset;
    }

    public setDefaultDate(){

        this.effectiveDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());
    }

    public onClickConfirmClassificationChange(){

        this.toggleDialogVisibility('classification-change-dialog');
        this.getTemplateViewModel().isClassificationConfirmed(true)
        this.onClickSave()
    }

    public onClickCancelClassificationChange(){
        this.toggleDialogVisibility('classification-change-dialog');
        this.getTemplateViewModel().isClassificationConfirmed(false)
    }

    public onClickConfirmOffboardingDialog(){

        let anyMissing = false;
        this.getTemplateViewModel().offboardingData().forEach(data => {
            if (data.isOffboarding()==1) {
                if (!data.reason() || data.reason() == 0) {
                    anyMissing = true;
                    data.warning("please select a reason");
                }

                data.warning(null);
            }
        });
        if (anyMissing) {
            return;
        }
        this.toggleDialogVisibility('offboarding-dialog');
        this.getTemplateViewModel().initialSelectedBrands(this.getTemplateViewModel().selectedBrands());
        this.onClickSave(true)
    }

    public onClickCancelOffboardingDialog(){
        this.getTemplateViewModel().offboardingData([]);
        this.toggleDialogVisibility('offboarding-dialog');
    }

    public filterSingleDateOnChange(idElement) {
        if(idElement == 'effectiveDatePicker') {
            this.getTemplateViewModel().isClassificationChanged(true)
        }
    }

    public onChangePaymentClassification(){

        this.getTemplateViewModel().idPaymentClassificationChanged(true);

        //Company = 1: Valnet, 2: PL
        //Classification = 1: Freelance, 2: Employee
        //Currency = 1: usd, 2: cad, 3: gbp, 4: eur
        let idPaymentClassification = this.getTemplateViewModel().idPaymentClassification();
        let idCompany = this.getTemplateViewModel().idCompany();

        let selectableIdCurrency = [];

        let companyCurrency = [
            {"idCompany": 1, "idPaymentClassification": 1, "currencies": [1,2,3,4]},
            {"idCompany": 1, "idPaymentClassification": 2, "currencies": [1,2,3,4]},
            {"idCompany": 2, "idPaymentClassification": 1, "currencies": [1,3]},
            {"idCompany": 2, "idPaymentClassification": 2, "currencies": [3]}
        ];

        companyCurrency.forEach(value => {

            if(idCompany == value.idCompany && idPaymentClassification == value.idPaymentClassification){

                selectableIdCurrency = value.currencies;
            }
        });

        let currencies = this.getTemplateViewModel().allCurrencies();
        currencies = currencies.filter(function (value) {

            return selectableIdCurrency.indexOf(value.id) > -1;
        });

        if(selectableIdCurrency.indexOf(this.getTemplateViewModel().idCurrency()) == -1){

            this.getTemplateViewModel().idCurrency(null);
        }

        this.getTemplateViewModel().options_currencies(currencies);
    }

    protected setArticleFilterAutocomplete(articles): void  {

        this.articleFilter.setOptions(articles);
    }

    protected onChangeSelectedBrandInfo(){

        //clear the article filter input
        this.clearArticleFilterInput();
    }

    public onClickAddPinnedArticle(){

        if(!this.articleFilter.getTemplateViewModel().idArticle()) {
            this.caller.triggerNotification('Article is mandatory.');
            return;
        }

        //Get the selected brand info to update the correct pinned articles list
        let selectedBrandInfo = this.getTemplateViewModel().selectedBrandInfo()
        let brandPinnedArticles = [];

        if(selectedBrandInfo && selectedBrandInfo.pinnedArticles){
            brandPinnedArticles = selectedBrandInfo.pinnedArticles();
        }

        if(brandPinnedArticles.length == 4) {
            this.caller.triggerNotification('Maximum number reached of articles reached for this brand. Please delete one to add another.');
            return;
        }

        let article = this.articleFilter.getTemplateViewModel().articleObj();
        let index = brandPinnedArticles.findIndex(item => item.id == article.id);

        let stippedArticles = {
            id: article.id,
            title: article.title,
            dateLastPublishStatus: article.dateLastPublishStatus,
            reference: article.reference
        }

        if(index > -1){

            this.caller.triggerNotification('This article has already been pinned.');
        }else {

            brandPinnedArticles.push(stippedArticles);
            selectedBrandInfo.pinnedArticles(brandPinnedArticles);
            this.clearArticleFilterInput();
        }
    }

    public clearArticleFilterInput(){

        this.articleFilter.setOptions([]);
        this.articleFilter.getTemplateViewModel().idArticle(null);
        this.articleFilter.getTemplateViewModel().article("");
        this.articleFilter.getTemplateViewModel().articleObj("");
    }

    public onClickDelete(article){

        //loop through brandinfo's pinnedArticles, and remove the article
        let brandInfo = this.getTemplateViewModel().selectedBrandInfo();
        let brandPinnedArticles = [];
        if(brandInfo.pinnedArticles()){
            brandPinnedArticles = brandInfo.pinnedArticles();
            brandPinnedArticles.splice(brandPinnedArticles.indexOf(article), 1);
        }
        brandInfo.pinnedArticles(brandPinnedArticles);
    }

    public onClickRemoveEmbed(data){

        //loop through brandinfo's embeds, and remove the embed
        let brandInfo = this.getTemplateViewModel().selectedBrandInfo();

        if(brandInfo){
            if (brandInfo.embeds && typeof brandInfo.embeds != "function") {

                brandInfo.embeds = ko.observableArray(brandInfo.embeds || []);
            }
            let embeds = brandInfo.embeds();
            embeds.splice(embeds.indexOf(data), 1);
            brandInfo.embeds(embeds);

            this.getTemplateViewModel().selectedBrandInfo(brandInfo);
        }
    }

    public setEmbedHTML(value){

        let brandInfo = this.getTemplateViewModel().selectedBrandInfo();
        let embeds = brandInfo.embeds();

        //max 2 embeds, so if there are less than 2, add the new embed
        if(embeds && embeds.length < 2){

            embeds.push(value);
            brandInfo.embeds(embeds);
        }
    }

    async setEmbedData(embedData: EmbedInfo) {

        this.getTemplateViewModel().embedder.previewEmbedType('embed_'+ embedData.name);

        let markup = embedData.html;
        markup = await this.embedHelper.processContentEmbed(embedData, [
            {width: 375,height: 667},
            {width: 310,height: 556}
        ]);

        this.getTemplateViewModel().embedder.embedCode(markup);
    }

    protected onClickRemoveTopicExpertise(tagObject, brandInfoViewModel){
        const topicExpertiseList = brandInfoViewModel.topicExpertiseList()
        const index = topicExpertiseList.findIndex(item => item.id == tagObject.id);
        if (index !== -1) {
            topicExpertiseList.splice(index, 1);
        }
        brandInfoViewModel.topicExpertiseList(topicExpertiseList)
        const topicExpertiseFilterAutoComplete = brandInfoViewModel.topicExpertise
        topicExpertiseFilterAutoComplete.setIsGlobalLockEnabled(brandInfoViewModel.topicExpertiseMaxItemReached())
    }

    protected handleJobTitleChange(brandId) {

        let inputElement = document.getElementById("jobTitleInput-" + brandId) as HTMLInputElement;
        let selectElement = document.getElementById("jobTitleSelect-" + brandId) as HTMLSelectElement;

        if (inputElement && selectElement && selectElement.value != "") {

            let brandInfo = this.getTemplateViewModel().brandInfo();
            let index = brandInfo.findIndex(b => b.brand.id === brandId && b.isAuthorDetailActive());

            if (index !== -1) {
                brandInfo[index].jobTitle = inputElement.value = selectElement.value;
                selectElement.value = "";
                this.getTemplateViewModel().brandInfo(brandInfo);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/usersEdit_template.ts